export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Cursor for paging through collections */
  ConnectionCursor: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  DateTimeRange: { input: { start: string, end: string }; output: { start: string, end: string }; }
  GeoJSONPointScalar: { input: { type: 'Point', coordinates: [lng: number, lat: number] }; output: { type: 'Point', coordinates: [lng: number, lat: number] }; }
  GeoJSONPolygonScalar: { input: { type: 'Polygon', coordinates: [lng: number, lat: number][][] }; output: { type: 'Polygon', coordinates: [lng: number, lat: number][][] }; }
  JSDate: { input: Date; output: Date; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  Object: { input: any; output: any; }
  SessionLinks: { input: Map<IntegrationType, string>; output: Map<IntegrationType, string>; }
};

export type AddAdditionalBookingContactsToSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type AddAvailabilitiesToUserInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type AddFilesToSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type AddItemsToOrderInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type AddLocationToSessionInput = {
  id: Scalars['ID']['input'];
  location: LocationInput;
  type: SessionLocationType;
};

export type AddMediaToCustomizationInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type AddMissionsToMissionSetInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type AddSessionModifiersInput = {
  id: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type AddSessionRelationsInput = {
  id: Scalars['ID']['input'];
  relations: Array<SessionRelationInput>;
};

export type AddTimelineItem = {
  item: NewTimelineItemInput;
  sessionId: Scalars['ID']['input'];
};

export type AiPrompt = {
  __typename?: 'AiPrompt';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  model: OpenAiModel;
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type AiPromptAggregateGroupBy = {
  __typename?: 'AiPromptAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  model?: Maybe<OpenAiModel>;
  name?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type AiPromptAvgAggregate = {
  __typename?: 'AiPromptAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type AiPromptConnection = {
  __typename?: 'AiPromptConnection';
  /** Array of nodes. */
  nodes: Array<AiPrompt>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type AiPromptCountAggregate = {
  __typename?: 'AiPromptCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  prompt?: Maybe<Scalars['Int']['output']>;
  webhookUrl?: Maybe<Scalars['Int']['output']>;
};

export type AiPromptDeleteResponse = {
  __typename?: 'AiPromptDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  model?: Maybe<OpenAiModel>;
  name?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type AiPromptFilter = {
  and?: InputMaybe<Array<AiPromptFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  model?: InputMaybe<OpenAiModelFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AiPromptFilter>>;
  prompt?: InputMaybe<StringFieldComparison>;
  webhookUrl?: InputMaybe<StringFieldComparison>;
};

export type AiPromptMaxAggregate = {
  __typename?: 'AiPromptMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  model?: Maybe<OpenAiModel>;
  name?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type AiPromptMinAggregate = {
  __typename?: 'AiPromptMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  model?: Maybe<OpenAiModel>;
  name?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type AiPromptSort = {
  direction: SortDirection;
  field: AiPromptSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AiPromptSortFields {
  ID = 'id',
  MODEL = 'model',
  NAME = 'name',
  PROMPT = 'prompt',
  WEBHOOK_URL = 'webhookUrl'
}

export type AiPromptSumAggregate = {
  __typename?: 'AiPromptSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type AssignmentApproval = {
  __typename?: 'AssignmentApproval';
  id: Scalars['ID']['output'];
  state: AssignmentApprovalState;
};

export enum AssignmentApprovalState {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING'
}

export enum AssignmentType {
  AUTO = 'Auto',
  MANUAL = 'Manual',
  RANDOM = 'Random'
}

export type Availability = {
  __typename?: 'Availability';
  available: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  datetime?: Maybe<Scalars['JSDate']['output']>;
  day: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  from: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  to: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type AvailabilityConnection = {
  __typename?: 'AvailabilityConnection';
  /** Array of nodes. */
  nodes: Array<Availability>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type AvailabilityFilter = {
  and?: InputMaybe<Array<AvailabilityFilter>>;
  enabled?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AvailabilityFilter>>;
  user?: InputMaybe<AvailabilityFilterUserFilter>;
};

export type AvailabilityFilterUserFilter = {
  active?: InputMaybe<BooleanFieldComparison>;
  and?: InputMaybe<Array<AvailabilityFilterUserFilter>>;
  anonymous?: InputMaybe<BooleanFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  fullName?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastAssignedAt?: InputMaybe<DateFieldComparison>;
  level?: InputMaybe<IntFieldComparison>;
  or?: InputMaybe<Array<AvailabilityFilterUserFilter>>;
  role?: InputMaybe<RoleFilterComparison>;
  unsubscribed?: InputMaybe<BooleanFieldComparison>;
};

export type AvailabilitySort = {
  direction: SortDirection;
  field: AvailabilitySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum AvailabilitySortFields {
  ENABLED = 'enabled',
  ID = 'id'
}

export type AvailableConsumable = {
  __typename?: 'AvailableConsumable';
  available: Scalars['Int']['output'];
  name: ConsumableName;
  orderItemId: Scalars['ID']['output'];
  ordered: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BreadcrumbMission = {
  __typename?: 'BreadcrumbMission';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BreadcrumbMissionConnection = {
  __typename?: 'BreadcrumbMissionConnection';
  /** Array of nodes. */
  nodes: Array<BreadcrumbMission>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type BreadcrumbMissionFilter = {
  list: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BreadcrumbMissionInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type BreadcrumbMissionList = {
  __typename?: 'BreadcrumbMissionList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BreadcrumbMissionListConnection = {
  __typename?: 'BreadcrumbMissionListConnection';
  /** Array of nodes. */
  nodes: Array<BreadcrumbMissionList>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type BreadcrumbSorting = {
  field?: InputMaybe<Scalars['String']['input']>;
};

export type ClearGroupDetailsInput = {
  id: Scalars['ID']['input'];
};

export type ClearSessionAssignmentInput = {
  id: Scalars['ID']['input'];
};

export type Consumable = {
  __typename?: 'Consumable';
  id: Scalars['Int']['output'];
  name: ConsumableName;
};

export enum ConsumableName {
  CREDIT = 'CREDIT',
  OPEN_WEVE_ROOM = 'OPEN_WEVE_ROOM',
  RESCHEDULE_FEE = 'RESCHEDULE_FEE'
}

export type CopyGroupDetailsInput = {
  from: Scalars['ID']['input'];
  to: Scalars['ID']['input'];
};

export type CreateAiPrompt = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<OpenAiModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAvailabilityInput = {
  available: Scalars['Boolean']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  day: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateBookingUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateCustomizationMedia = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CustomizationMediaType>;
};

export type CreateExperienceFormatInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  experienceId: Scalars['ID']['input'];
  hostType?: HostType;
  syncType?: SyncType;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: ExperienceFormatType;
};

export type CreateExperienceInput = {
  category?: InputMaybe<ExperienceCategory>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ExperienceType>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateFile = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MediaType>;
};

export type CreateGameZoneInput = {
  name: Scalars['String']['input'];
  placeId: Scalars['ID']['input'];
};

export type CreateGlobalUnavailability = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateInstruction = {
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<SessionDocument>;
  hosts?: InputMaybe<Array<HostType>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PdfType>;
};

export type CreateManualOrderInput = {
  discount?: Scalars['Int']['input'];
  item: OrderItemInput;
  workspaceId: Scalars['ID']['input'];
};

export type CreateManyCustomizationMediasInput = {
  /** Array of records to create */
  customizationMedias: Array<CreateCustomizationMedia>;
};

export type CreateManyFilesInput = {
  /** Array of records to create */
  files: Array<CreateFile>;
};

export type CreateManyGlobalUnavailabilitiesInput = {
  /** Array of records to create */
  globalUnavailabilities: Array<CreateGlobalUnavailability>;
};

export type CreateManySubscriptionPlansInput = {
  /** Array of records to create */
  subscriptionPlans: Array<CreateSubscriptionPlan>;
};

export type CreateMissionInput = {
  /** The record to create */
  mission: MissionInput;
};

export type CreateMissionSet = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateModifierInput = {
  /** The record to create */
  modifier: ModifierInput;
};

export type CreateOneAiPromptInput = {
  /** The record to create */
  aiPrompt: CreateAiPrompt;
};

export type CreateOneCustomizationMediaInput = {
  /** The record to create */
  customizationMedia: CreateCustomizationMedia;
};

export type CreateOneFileInput = {
  /** The record to create */
  file: CreateFile;
};

export type CreateOneGlobalUnavailabilityInput = {
  /** The record to create */
  globalUnavailability: CreateGlobalUnavailability;
};

export type CreateOneInstructionInput = {
  /** The record to create */
  instruction: CreateInstruction;
};

export type CreateOneMissionSetInput = {
  /** The record to create */
  missionSet: CreateMissionSet;
};

export type CreateOnePriceModifierInput = {
  /** The record to create */
  priceModifier: CreatePriceModifier;
};

export type CreateOneSessionPhoneInput = {
  /** The record to create */
  sessionPhone: CreateSessionPhone;
};

export type CreateOneSubscriptionPlanInput = {
  /** The record to create */
  subscriptionPlan: CreateSubscriptionPlan;
};

export type CreateOneVenueInput = {
  /** The record to create */
  venue: CreateVenueInput;
};

export type CreateOneVenueReviewInput = {
  /** The record to create */
  venueReview: CreateVenueReviewInput;
};

export type CreateOpenWeveInput = {
  title: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreatePermissionInput = {
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  role: PermissionRole;
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreatePlantInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<UserAttributesInput>;
  birthYear?: InputMaybe<Scalars['Int']['input']>;
  coordinates?: InputMaybe<Scalars['GeoJSONPointScalar']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
  load?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationInput>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  modifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  upgrades?: InputMaybe<Array<PackageLevel>>;
};

export type CreatePriceModifier = {
  dateRange?: InputMaybe<Scalars['DateTimeRange']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  types?: InputMaybe<Array<SessionType>>;
};

export type CreateSessionPhone = {
  hostType?: InputMaybe<HostType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  packageLevel?: InputMaybe<PackageLevel>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sessionType?: InputMaybe<SessionType>;
};

export type CreateStaffUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<UserAttributesInput>;
  birthYear?: InputMaybe<Scalars['Int']['input']>;
  coordinates?: InputMaybe<Scalars['GeoJSONPointScalar']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
  load?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationInput>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  modifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  timezone?: InputMaybe<Scalars['String']['input']>;
  upgrades?: InputMaybe<Array<PackageLevel>>;
};

export type CreateSubscriptionPlan = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  consumables?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastPaidAmount?: InputMaybe<Scalars['Float']['input']>;
  lastPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  renewAt?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<CreationSource>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SubscriptionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserAudioInput = {
  fileId: Scalars['ID']['input'];
  keypress?: InputMaybe<Scalars['String']['input']>;
  overlay?: InputMaybe<Scalars['Boolean']['input']>;
  volume?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateVenueInput = {
  city: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  gameZoneId?: InputMaybe<Scalars['String']['input']>;
  location: LocationInput;
  name: Scalars['String']['input'];
  participantsMax: Scalars['Int']['input'];
  participantsMin: Scalars['Int']['input'];
  private?: Scalars['Boolean']['input'];
};

export type CreateVenueReviewInput = {
  media?: InputMaybe<Array<Scalars['ID']['input']>>;
  rate: Scalars['Int']['input'];
  review: Scalars['String']['input'];
  sessionId: Scalars['ID']['input'];
  venueId: Scalars['ID']['input'];
};

export type CreateZoneAreaInput = {
  /** The record to create */
  zoneArea: ZoneAreaInput;
};

export enum CreationSource {
  HUBSPOT = 'Hubspot',
  ONLINE = 'Online'
}

export enum Credit {
  CREDIT_0 = 'CREDIT_0',
  CREDIT_1 = 'CREDIT_1',
  CREDIT_2 = 'CREDIT_2',
  CREDIT_3 = 'CREDIT_3',
  CREDIT_4 = 'CREDIT_4',
  CREDIT_5 = 'CREDIT_5',
  CREDIT_6 = 'CREDIT_6',
  CREDIT_7 = 'CREDIT_7',
  CREDIT_8 = 'CREDIT_8',
  CREDIT_9 = 'CREDIT_9',
  CREDIT_10 = 'CREDIT_10',
  CREDIT_11 = 'CREDIT_11',
  CREDIT_12 = 'CREDIT_12',
  CREDIT_13 = 'CREDIT_13',
  CREDIT_14 = 'CREDIT_14',
  CREDIT_15 = 'CREDIT_15'
}

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Customization = {
  __typename?: 'Customization';
  colors: CustomizationColors;
  id: Scalars['ID']['output'];
  media: Array<CustomizationMedia>;
  workspace: Workspace;
};


export type CustomizationMediaArgs = {
  filter?: CustomizationMediaFilter;
  sorting?: Array<CustomizationMediaSort>;
};

export type CustomizationAggregateGroupBy = {
  __typename?: 'CustomizationAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
};

export type CustomizationColors = {
  __typename?: 'CustomizationColors';
  primary?: Maybe<Scalars['String']['output']>;
  secondary?: Maybe<Scalars['String']['output']>;
  tertiary?: Maybe<Scalars['String']['output']>;
};

export type CustomizationColorsInput = {
  primary?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['String']['input']>;
  tertiary?: InputMaybe<Scalars['String']['input']>;
};

export type CustomizationConnection = {
  __typename?: 'CustomizationConnection';
  /** Array of edges. */
  edges: Array<CustomizationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type CustomizationCountAggregate = {
  __typename?: 'CustomizationCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type CustomizationEdge = {
  __typename?: 'CustomizationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Customization */
  node: Customization;
};

export type CustomizationFilter = {
  and?: InputMaybe<Array<CustomizationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CustomizationFilter>>;
};

export type CustomizationMaxAggregate = {
  __typename?: 'CustomizationMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type CustomizationMedia = {
  __typename?: 'CustomizationMedia';
  file: File;
  id: Scalars['ID']['output'];
  type: CustomizationMediaType;
};

export type CustomizationMediaAggregateGroupBy = {
  __typename?: 'CustomizationMediaAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<CustomizationMediaType>;
};

export type CustomizationMediaConnection = {
  __typename?: 'CustomizationMediaConnection';
  /** Array of edges. */
  edges: Array<CustomizationMediaEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type CustomizationMediaCountAggregate = {
  __typename?: 'CustomizationMediaCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type CustomizationMediaDeleteFilter = {
  and?: InputMaybe<Array<CustomizationMediaDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CustomizationMediaDeleteFilter>>;
  type?: InputMaybe<CustomizationMediaTypeFilterComparison>;
};

export type CustomizationMediaDeleteResponse = {
  __typename?: 'CustomizationMediaDeleteResponse';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<CustomizationMediaType>;
};

export type CustomizationMediaEdge = {
  __typename?: 'CustomizationMediaEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CustomizationMedia */
  node: CustomizationMedia;
};

export type CustomizationMediaFilter = {
  and?: InputMaybe<Array<CustomizationMediaFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CustomizationMediaFilter>>;
  type?: InputMaybe<CustomizationMediaTypeFilterComparison>;
};

export type CustomizationMediaMaxAggregate = {
  __typename?: 'CustomizationMediaMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<CustomizationMediaType>;
};

export type CustomizationMediaMinAggregate = {
  __typename?: 'CustomizationMediaMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<CustomizationMediaType>;
};

export type CustomizationMediaSort = {
  direction: SortDirection;
  field: CustomizationMediaSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CustomizationMediaSortFields {
  ID = 'id',
  TYPE = 'type'
}

export enum CustomizationMediaType {
  CUSTOM_LOGO = 'CUSTOM_LOGO',
  CUSTOM_LOGO_LARGE = 'CUSTOM_LOGO_LARGE',
  LOGIN_LOGO = 'LOGIN_LOGO'
}

export type CustomizationMediaTypeFilterComparison = {
  contArr?: InputMaybe<CustomizationMediaType>;
  eq?: InputMaybe<CustomizationMediaType>;
  gt?: InputMaybe<CustomizationMediaType>;
  gte?: InputMaybe<CustomizationMediaType>;
  iLike?: InputMaybe<CustomizationMediaType>;
  in?: InputMaybe<Array<CustomizationMediaType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<CustomizationMediaType>;
  lt?: InputMaybe<CustomizationMediaType>;
  lte?: InputMaybe<CustomizationMediaType>;
  neq?: InputMaybe<CustomizationMediaType>;
  notILike?: InputMaybe<CustomizationMediaType>;
  notIn?: InputMaybe<Array<CustomizationMediaType>>;
  notLike?: InputMaybe<CustomizationMediaType>;
  overlaps?: InputMaybe<CustomizationMediaType>;
};

export type CustomizationMediaUpdateFilter = {
  and?: InputMaybe<Array<CustomizationMediaUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<CustomizationMediaUpdateFilter>>;
  type?: InputMaybe<CustomizationMediaTypeFilterComparison>;
};

export type CustomizationMinAggregate = {
  __typename?: 'CustomizationMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type CustomizationSort = {
  direction: SortDirection;
  field: CustomizationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum CustomizationSortFields {
  ID = 'id'
}

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type DeleteAvailabilityResult = {
  __typename?: 'DeleteAvailabilityResult';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteManyCustomizationMediasInput = {
  /** Filter to find records to delete */
  filter: CustomizationMediaDeleteFilter;
};

export type DeleteManyFilesInput = {
  /** Filter to find records to delete */
  filter: FileDeleteFilter;
};

export type DeleteManyResponse = {
  __typename?: 'DeleteManyResponse';
  /** The number of records deleted. */
  deletedCount: Scalars['Int']['output'];
};

export type DeleteManySubscriptionPlansInput = {
  /** Filter to find records to delete */
  filter: SubscriptionPlanDeleteFilter;
};

export type DeleteOneAiPromptInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneCustomizationMediaInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneExperienceFormatInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneFileInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneGlobalUnavailabilityInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneInstructionInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneMissionInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneMissionSetInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneModifierInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOnePriceModifierInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneSessionInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneSessionPhoneInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneSubscriptionPlanInput = {
  /** The id of the record to delete. */
  id: Scalars['Int']['input'];
};

export type DeleteOneVenueInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneVenueReviewInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneZoneAreaInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOpenWeveInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrderInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrderItemsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeletePermissionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSessionAssignmentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSystemInput = {
  key: SystemKey;
};

export type DeleteUserDto = {
  __typename?: 'DeleteUserDto';
  id: Scalars['ID']['output'];
};

export type DeleteUserInput = {
  hard?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type Experience = {
  __typename?: 'Experience';
  attributes: ExperienceAttributes;
  banner?: Maybe<File>;
  bookable: Scalars['Boolean']['output'];
  category: ExperienceCategory;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<File>;
  formats: Array<ExperienceFormat>;
  hosts: Array<HostType>;
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  overview: ExperienceOverview;
  position: Scalars['Float']['output'];
  poster?: Maybe<File>;
  status?: Maybe<ExperienceStatus>;
  subscribers: Scalars['Boolean']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbnail?: Maybe<File>;
  tier?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  type: ExperienceType;
  types: Array<ExperienceFormatType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedDate: Scalars['JSDate']['output'];
  url?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};


export type ExperienceFormatsArgs = {
  filter?: ExperienceFormatFilter;
  sorting?: Array<ExperienceFormatSort>;
};

export type ExperienceAggregateGroupBy = {
  __typename?: 'ExperienceAggregateGroupBy';
  category?: Maybe<ExperienceCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hosts?: Maybe<Array<HostType>>;
  id?: Maybe<Scalars['ID']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExperienceType>;
  types?: Maybe<Array<ExperienceFormatType>>;
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperienceAttributes = {
  __typename?: 'ExperienceAttributes';
  gCalPrefix?: Maybe<Scalars['String']['output']>;
  hubSpotDisabled?: Maybe<Scalars['Boolean']['output']>;
  quoteDisabled?: Maybe<Scalars['Boolean']['output']>;
  webSiteDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperienceAttributesInput = {
  gCalPrefix?: InputMaybe<Scalars['String']['input']>;
  hubSpotDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  quoteDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  webSiteDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperienceAvgAggregate = {
  __typename?: 'ExperienceAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
};

export enum ExperienceCategory {
  ADVENTURE = 'ADVENTURE',
  DEI = 'DEI',
  ESCAPE_ROOM = 'ESCAPE_ROOM',
  GAME_SHOW = 'GAME_SHOW',
  INTERNATIONAL = 'INTERNATIONAL',
  KIT_BASED = 'KIT_BASED',
  NONE = 'NONE',
  PROFESSIONAL_DEVELOPMENT = 'PROFESSIONAL_DEVELOPMENT',
  SPECIAL_OCCASION = 'SPECIAL_OCCASION',
  THEATRICAL = 'THEATRICAL'
}

export type ExperienceCategoryFilterComparison = {
  contArr?: InputMaybe<ExperienceCategory>;
  eq?: InputMaybe<ExperienceCategory>;
  gt?: InputMaybe<ExperienceCategory>;
  gte?: InputMaybe<ExperienceCategory>;
  iLike?: InputMaybe<ExperienceCategory>;
  in?: InputMaybe<Array<ExperienceCategory>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ExperienceCategory>;
  lt?: InputMaybe<ExperienceCategory>;
  lte?: InputMaybe<ExperienceCategory>;
  neq?: InputMaybe<ExperienceCategory>;
  notILike?: InputMaybe<ExperienceCategory>;
  notIn?: InputMaybe<Array<ExperienceCategory>>;
  notLike?: InputMaybe<ExperienceCategory>;
  overlaps?: InputMaybe<ExperienceCategory>;
};

export type ExperienceConnection = {
  __typename?: 'ExperienceConnection';
  /** Array of nodes. */
  nodes: Array<Experience>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type ExperienceCountAggregate = {
  __typename?: 'ExperienceCountAggregate';
  category?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  hosts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  types?: Maybe<Scalars['Int']['output']>;
  visible?: Maybe<Scalars['Int']['output']>;
};

export type ExperienceCustomization = {
  __typename?: 'ExperienceCustomization';
  description: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ExperienceCustomizationInput = {
  description: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ExperienceFilter = {
  and?: InputMaybe<Array<ExperienceFilter>>;
  category?: InputMaybe<ExperienceCategoryFilterComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  formats?: InputMaybe<ExperienceFilterExperienceFormatFilter>;
  hosts?: InputMaybe<HostTypeArrayFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ExperienceFilter>>;
  position?: InputMaybe<FloatFieldComparison>;
  title?: InputMaybe<ExperienceTitleFilterComparison>;
  type?: InputMaybe<ExperienceTypeFilterComparison>;
  types?: InputMaybe<ExperienceFormatTypeArrayFilterComparison>;
  visible?: InputMaybe<BooleanFieldComparison>;
};

export type ExperienceFilterExperienceFormatFilter = {
  and?: InputMaybe<Array<ExperienceFilterExperienceFormatFilter>>;
  hostType?: InputMaybe<ExperienceFormatHostTypeFilterComparison>;
  id?: InputMaybe<ExperienceFormatIdFilterComparison>;
  or?: InputMaybe<Array<ExperienceFilterExperienceFormatFilter>>;
  title?: InputMaybe<ExperienceFormatTitleFilterComparison>;
  type?: InputMaybe<ExperienceFormatTypeFilterComparison>;
};

export type ExperienceFormat = {
  __typename?: 'ExperienceFormat';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  experience: Experience;
  formatDescription?: Maybe<Scalars['String']['output']>;
  hostDescription?: Maybe<Scalars['String']['output']>;
  hostType: HostType;
  id: Scalars['ID']['output'];
  kitBased?: Maybe<Scalars['Boolean']['output']>;
  lobby?: Maybe<Scalars['Boolean']['output']>;
  locatable: Scalars['Boolean']['output'];
  maxDuration?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<File>;
  minDuration?: Maybe<Scalars['Int']['output']>;
  modifiers: Array<Modifier>;
  pdfType?: Maybe<PdfType>;
  playType?: Maybe<PlayType>;
  poster?: Maybe<File>;
  settings: ExperienceFormatSettings;
  subtitle?: Maybe<Scalars['String']['output']>;
  syncType: SyncType;
  template: SessionTemplateType;
  templateId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ExperienceFormatType;
  updatedAt: Scalars['DateTime']['output'];
  youtube?: Maybe<Scalars['String']['output']>;
};


export type ExperienceFormatModifiersArgs = {
  filter?: ModifierFilter;
  sorting?: Array<ModifierSort>;
};

export type ExperienceFormatAggregateGroupBy = {
  __typename?: 'ExperienceFormatAggregateGroupBy';
  hostType?: Maybe<HostType>;
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExperienceFormatType>;
};

export type ExperienceFormatAvgAggregate = {
  __typename?: 'ExperienceFormatAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type ExperienceFormatConnection = {
  __typename?: 'ExperienceFormatConnection';
  /** Array of nodes. */
  nodes: Array<ExperienceFormat>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type ExperienceFormatCountAggregate = {
  __typename?: 'ExperienceFormatCountAggregate';
  hostType?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type ExperienceFormatCustomization = {
  __typename?: 'ExperienceFormatCustomization';
  description?: Maybe<Scalars['String']['output']>;
  type: PackageLevel;
};

export type ExperienceFormatCustomizationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  type: PackageLevel;
};

export type ExperienceFormatDeleteResponse = {
  __typename?: 'ExperienceFormatDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  formatDescription?: Maybe<Scalars['String']['output']>;
  hostDescription?: Maybe<Scalars['String']['output']>;
  hostType?: Maybe<HostType>;
  id?: Maybe<Scalars['ID']['output']>;
  kitBased?: Maybe<Scalars['Boolean']['output']>;
  lobby?: Maybe<Scalars['Boolean']['output']>;
  maxDuration?: Maybe<Scalars['Int']['output']>;
  minDuration?: Maybe<Scalars['Int']['output']>;
  pdfType?: Maybe<PdfType>;
  playType?: Maybe<PlayType>;
  settings?: Maybe<ExperienceFormatSettings>;
  subtitle?: Maybe<Scalars['String']['output']>;
  syncType?: Maybe<SyncType>;
  template?: Maybe<SessionTemplateType>;
  templateId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExperienceFormatType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type ExperienceFormatFilter = {
  and?: InputMaybe<Array<ExperienceFormatFilter>>;
  hostType?: InputMaybe<ExperienceFormatHostTypeFilterComparison>;
  id?: InputMaybe<ExperienceFormatIdFilterComparison>;
  or?: InputMaybe<Array<ExperienceFormatFilter>>;
  title?: InputMaybe<ExperienceFormatTitleFilterComparison>;
  type?: InputMaybe<ExperienceFormatTypeFilterComparison>;
};

export type ExperienceFormatHostTypeFilterComparison = {
  eq?: InputMaybe<HostType>;
  in?: InputMaybe<Array<HostType>>;
};

export type ExperienceFormatIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
};

export type ExperienceFormatMaxAggregate = {
  __typename?: 'ExperienceFormatMaxAggregate';
  hostType?: Maybe<HostType>;
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExperienceFormatType>;
};

export type ExperienceFormatMinAggregate = {
  __typename?: 'ExperienceFormatMinAggregate';
  hostType?: Maybe<HostType>;
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExperienceFormatType>;
};

export type ExperienceFormatSettings = {
  __typename?: 'ExperienceFormatSettings';
  customization?: Maybe<Array<ExperienceFormatCustomization>>;
};

export type ExperienceFormatSettingsInput = {
  customization?: InputMaybe<Array<ExperienceFormatCustomizationInput>>;
};

export type ExperienceFormatSort = {
  direction: SortDirection;
  field: ExperienceFormatSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ExperienceFormatSortFields {
  HOST_TYPE = 'hostType',
  ID = 'id',
  TITLE = 'title',
  TYPE = 'type'
}

export type ExperienceFormatSumAggregate = {
  __typename?: 'ExperienceFormatSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type ExperienceFormatTitleFilterComparison = {
  iLike?: InputMaybe<Scalars['String']['input']>;
};

export enum ExperienceFormatType {
  HYBRID = 'HYBRID',
  IN_PERSON = 'IN_PERSON',
  REMOTE = 'REMOTE'
}

export type ExperienceFormatTypeArrayFilterComparison = {
  contArr?: InputMaybe<Array<ExperienceFormatType>>;
  eq?: InputMaybe<Array<ExperienceFormatType>>;
  gt?: InputMaybe<Array<ExperienceFormatType>>;
  gte?: InputMaybe<Array<ExperienceFormatType>>;
  iLike?: InputMaybe<Array<ExperienceFormatType>>;
  in?: InputMaybe<Array<Array<ExperienceFormatType>>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Array<ExperienceFormatType>>;
  lt?: InputMaybe<Array<ExperienceFormatType>>;
  lte?: InputMaybe<Array<ExperienceFormatType>>;
  neq?: InputMaybe<Array<ExperienceFormatType>>;
  notILike?: InputMaybe<Array<ExperienceFormatType>>;
  notIn?: InputMaybe<Array<Array<ExperienceFormatType>>>;
  notLike?: InputMaybe<Array<ExperienceFormatType>>;
  overlaps?: InputMaybe<Array<ExperienceFormatType>>;
};

export type ExperienceFormatTypeFilterComparison = {
  eq?: InputMaybe<ExperienceFormatType>;
  in?: InputMaybe<Array<ExperienceFormatType>>;
};

export type ExperienceFormatUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  formatDescription?: InputMaybe<Scalars['String']['input']>;
  hostDescription?: InputMaybe<Scalars['String']['input']>;
  hostType?: InputMaybe<HostType>;
  kitBased?: InputMaybe<Scalars['Boolean']['input']>;
  lobby?: InputMaybe<Scalars['Boolean']['input']>;
  maxDuration?: InputMaybe<Scalars['Int']['input']>;
  minDuration?: InputMaybe<Scalars['Int']['input']>;
  modifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  pdfType?: InputMaybe<PdfType>;
  playType?: InputMaybe<PlayType>;
  settings?: InputMaybe<ExperienceFormatSettingsInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  syncType?: InputMaybe<SyncType>;
  template?: InputMaybe<SessionTemplateType>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ExperienceFormatType>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type ExperienceMaxAggregate = {
  __typename?: 'ExperienceMaxAggregate';
  category?: Maybe<ExperienceCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hosts?: Maybe<Array<HostType>>;
  id?: Maybe<Scalars['ID']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExperienceType>;
  types?: Maybe<Array<ExperienceFormatType>>;
};

export type ExperienceMinAggregate = {
  __typename?: 'ExperienceMinAggregate';
  category?: Maybe<ExperienceCategory>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hosts?: Maybe<Array<HostType>>;
  id?: Maybe<Scalars['ID']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExperienceType>;
  types?: Maybe<Array<ExperienceFormatType>>;
};

export type ExperienceOverview = {
  __typename?: 'ExperienceOverview';
  attendees?: Maybe<Scalars['Int']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  customizations?: Maybe<Array<ExperienceCustomization>>;
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<ExperienceOverviewItem>>;
  feedbacks?: Maybe<Array<ExperienceOverviewItem>>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  label?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  studies?: Maybe<Array<ExperienceOverviewItem>>;
  titleTag?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type ExperienceOverviewInput = {
  attendees?: InputMaybe<Scalars['Int']['input']>;
  cost?: InputMaybe<Scalars['String']['input']>;
  customizations?: InputMaybe<Array<ExperienceCustomizationInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<ExperienceOverviewItemInput>>;
  feedbacks?: InputMaybe<Array<ExperienceOverviewItemInput>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  label?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  studies?: InputMaybe<Array<ExperienceOverviewItemInput>>;
  titleTag?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type ExperienceOverviewItem = {
  __typename?: 'ExperienceOverviewItem';
  body?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['ID']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ExperienceOverviewItemInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ExperienceSort = {
  direction: SortDirection;
  field: ExperienceSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ExperienceSortFields {
  CATEGORY = 'category',
  CREATED_AT = 'createdAt',
  HOSTS = 'hosts',
  ID = 'id',
  POSITION = 'position',
  TITLE = 'title',
  TYPE = 'type',
  TYPES = 'types',
  VISIBLE = 'visible'
}

export enum ExperienceStatus {
  NEW = 'NEW',
  UPDATED = 'UPDATED'
}

export type ExperienceSumAggregate = {
  __typename?: 'ExperienceSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
};

export type ExperienceTitleFilterComparison = {
  iLike?: InputMaybe<Scalars['String']['input']>;
};

export enum ExperienceType {
  COMBO = 'COMBO',
  MULTI_FORMAT = 'MULTI_FORMAT'
}

export type ExperienceTypeFilterComparison = {
  contArr?: InputMaybe<ExperienceType>;
  eq?: InputMaybe<ExperienceType>;
  gt?: InputMaybe<ExperienceType>;
  gte?: InputMaybe<ExperienceType>;
  iLike?: InputMaybe<ExperienceType>;
  in?: InputMaybe<Array<ExperienceType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<ExperienceType>;
  lt?: InputMaybe<ExperienceType>;
  lte?: InputMaybe<ExperienceType>;
  neq?: InputMaybe<ExperienceType>;
  notILike?: InputMaybe<ExperienceType>;
  notIn?: InputMaybe<Array<ExperienceType>>;
  notLike?: InputMaybe<ExperienceType>;
  overlaps?: InputMaybe<ExperienceType>;
};

export type File = {
  __typename?: 'File';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  src: Scalars['String']['output'];
  type: MediaType;
};

export type FileAggregateGroupBy = {
  __typename?: 'FileAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
};

export type FileConnection = {
  __typename?: 'FileConnection';
  /** Array of edges. */
  edges: Array<FileEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type FileCountAggregate = {
  __typename?: 'FileCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type FileDeleteFilter = {
  and?: InputMaybe<Array<FileDeleteFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FileDeleteFilter>>;
};

export type FileDeleteResponse = {
  __typename?: 'FileDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  mime?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MediaType>;
};

export type FileEdge = {
  __typename?: 'FileEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the File */
  node: File;
};

export type FileFilter = {
  and?: InputMaybe<Array<FileFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FileFilter>>;
};

export type FileMaxAggregate = {
  __typename?: 'FileMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type FileMinAggregate = {
  __typename?: 'FileMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type FileSort = {
  direction: SortDirection;
  field: FileSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum FileSortFields {
  ID = 'id'
}

export type FileUpdateFilter = {
  and?: InputMaybe<Array<FileUpdateFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<FileUpdateFilter>>;
};

export type FloatFieldComparison = {
  between?: InputMaybe<FloatFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<FloatFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type GameCity = {
  __typename?: 'GameCity';
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type GameCityConnection = {
  __typename?: 'GameCityConnection';
  /** Array of nodes. */
  nodes: Array<GameCity>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type GameCityFilter = {
  exclude?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GameZone = {
  __typename?: 'GameZone';
  hull: Array<Scalars['GeoJSONPointScalar']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  point: Scalars['GeoJSONPointScalar']['output'];
};

export type GameZoneConnection = {
  __typename?: 'GameZoneConnection';
  /** Array of nodes. */
  nodes: Array<GameZone>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type GameZoneFilter = {
  exclude?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalUnavailability = {
  __typename?: 'GlobalUnavailability';
  endDate: Scalars['JSDate']['output'];
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  startDate: Scalars['JSDate']['output'];
  startsAt: Scalars['DateTime']['output'];
};

export type GlobalUnavailabilityAggregateGroupBy = {
  __typename?: 'GlobalUnavailabilityAggregateGroupBy';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlobalUnavailabilityConnection = {
  __typename?: 'GlobalUnavailabilityConnection';
  /** Array of nodes. */
  nodes: Array<GlobalUnavailability>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type GlobalUnavailabilityCountAggregate = {
  __typename?: 'GlobalUnavailabilityCountAggregate';
  endsAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startsAt?: Maybe<Scalars['Int']['output']>;
};

export type GlobalUnavailabilityDeleteResponse = {
  __typename?: 'GlobalUnavailabilityDeleteResponse';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlobalUnavailabilityFilter = {
  and?: InputMaybe<Array<GlobalUnavailabilityFilter>>;
  endsAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<GlobalUnavailabilityFilter>>;
  startsAt?: InputMaybe<DateFieldComparison>;
};

export type GlobalUnavailabilityMaxAggregate = {
  __typename?: 'GlobalUnavailabilityMaxAggregate';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlobalUnavailabilityMinAggregate = {
  __typename?: 'GlobalUnavailabilityMinAggregate';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlobalUnavailabilitySort = {
  direction: SortDirection;
  field: GlobalUnavailabilitySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum GlobalUnavailabilitySortFields {
  ENDS_AT = 'endsAt',
  ID = 'id',
  STARTS_AT = 'startsAt'
}

export enum HostType {
  ON_SCREEN = 'ON_SCREEN',
  ON_SITE = 'ON_SITE',
  SELF_HOSTED = 'SELF_HOSTED'
}

export type HostTypeArrayFilterComparison = {
  contArr?: InputMaybe<Array<HostType>>;
  eq?: InputMaybe<Array<HostType>>;
  gt?: InputMaybe<Array<HostType>>;
  gte?: InputMaybe<Array<HostType>>;
  iLike?: InputMaybe<Array<HostType>>;
  in?: InputMaybe<Array<Array<HostType>>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Array<HostType>>;
  lt?: InputMaybe<Array<HostType>>;
  lte?: InputMaybe<Array<HostType>>;
  neq?: InputMaybe<Array<HostType>>;
  notILike?: InputMaybe<Array<HostType>>;
  notIn?: InputMaybe<Array<Array<HostType>>>;
  notLike?: InputMaybe<Array<HostType>>;
  overlaps?: InputMaybe<Array<HostType>>;
};

export type HostTypeFilterComparison = {
  contArr?: InputMaybe<HostType>;
  eq?: InputMaybe<HostType>;
  gt?: InputMaybe<HostType>;
  gte?: InputMaybe<HostType>;
  iLike?: InputMaybe<HostType>;
  in?: InputMaybe<Array<HostType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<HostType>;
  lt?: InputMaybe<HostType>;
  lte?: InputMaybe<HostType>;
  neq?: InputMaybe<HostType>;
  notILike?: InputMaybe<HostType>;
  notIn?: InputMaybe<Array<HostType>>;
  notLike?: InputMaybe<HostType>;
  overlaps?: InputMaybe<HostType>;
};

export type IdFilterComparison = {
  contArr?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  iLike?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notILike?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notLike?: InputMaybe<Scalars['ID']['input']>;
  overlaps?: InputMaybe<Scalars['ID']['input']>;
};

export type Instruction = {
  __typename?: 'Instruction';
  content: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentType: SessionDocument;
  hosts: Array<HostType>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: PdfType;
};

export type InstructionAggregateGroupBy = {
  __typename?: 'InstructionAggregateGroupBy';
  hosts?: Maybe<Array<HostType>>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<PdfType>;
};

export type InstructionAvgAggregate = {
  __typename?: 'InstructionAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type InstructionConnection = {
  __typename?: 'InstructionConnection';
  /** Array of nodes. */
  nodes: Array<Instruction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type InstructionCountAggregate = {
  __typename?: 'InstructionCountAggregate';
  hosts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type InstructionDeleteResponse = {
  __typename?: 'InstructionDeleteResponse';
  content?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<SessionDocument>;
  hosts?: Maybe<Array<HostType>>;
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PdfType>;
};

export type InstructionFilter = {
  and?: InputMaybe<Array<InstructionFilter>>;
  hosts?: InputMaybe<HostTypeArrayFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<InstructionFilter>>;
  type?: InputMaybe<PdfTypeFilterComparison>;
};

export type InstructionMaxAggregate = {
  __typename?: 'InstructionMaxAggregate';
  hosts?: Maybe<Array<HostType>>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<PdfType>;
};

export type InstructionMinAggregate = {
  __typename?: 'InstructionMinAggregate';
  hosts?: Maybe<Array<HostType>>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<PdfType>;
};

export type InstructionSort = {
  direction: SortDirection;
  field: InstructionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum InstructionSortFields {
  HOSTS = 'hosts',
  ID = 'id',
  TYPE = 'type'
}

export type InstructionSumAggregate = {
  __typename?: 'InstructionSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type IntFieldComparison = {
  between?: InputMaybe<IntFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notBetween?: InputMaybe<IntFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntFieldComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

export enum IntegrationType {
  BC2 = 'BC2',
  BREADCRUMB = 'BREADCRUMB',
  GALLERY = 'GALLERY',
  HUBSPOT = 'HUBSPOT',
  PLAY = 'PLAY',
  SLACK = 'SLACK',
  WEVE = 'WEVE'
}

export type IntegrationTypeFilterComparison = {
  contArr?: InputMaybe<IntegrationType>;
  eq?: InputMaybe<IntegrationType>;
  gt?: InputMaybe<IntegrationType>;
  gte?: InputMaybe<IntegrationType>;
  iLike?: InputMaybe<IntegrationType>;
  in?: InputMaybe<Array<IntegrationType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<IntegrationType>;
  lt?: InputMaybe<IntegrationType>;
  lte?: InputMaybe<IntegrationType>;
  neq?: InputMaybe<IntegrationType>;
  notILike?: InputMaybe<IntegrationType>;
  notIn?: InputMaybe<Array<IntegrationType>>;
  notLike?: InputMaybe<IntegrationType>;
  overlaps?: InputMaybe<IntegrationType>;
};

export type LawnSchedule = {
  __typename?: 'LawnSchedule';
  break: Scalars['Boolean']['output'];
  breakDuration: Scalars['Int']['output'];
  endOffset: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  list: Scalars['String']['output'];
  missions: Array<BreadcrumbMission>;
  roundBreakDuration: Scalars['Int']['output'];
  schedule: Array<Array<Array<Scalars['String']['output']>>>;
  startOffset: Scalars['Int']['output'];
  tournament: Tournament;
};

export type Location = {
  __typename?: 'Location';
  address: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  placeId: Scalars['ID']['output'];
  point: Scalars['GeoJSONPointScalar']['output'];
  venueId?: Maybe<Scalars['ID']['output']>;
};

export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Location */
  node: Location;
};

export type LocationInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  placeId: Scalars['ID']['input'];
  point: Scalars['GeoJSONPointScalar']['input'];
};

export enum MediaType {
  AUDIO = 'Audio',
  DOCUMENT = 'Document',
  IMAGE = 'Image',
  VIDEO = 'Video'
}

export type Mission = {
  __typename?: 'Mission';
  createdAt: Scalars['DateTime']['output'];
  createdAtDate: Scalars['JSDate']['output'];
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  missionSet: MissionSet;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  options: Array<MissionOption>;
  position?: Maybe<Scalars['Float']['output']>;
  type: MissionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type MissionAggregateGroupBy = {
  __typename?: 'MissionAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
};

export type MissionAvgAggregate = {
  __typename?: 'MissionAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type MissionConnection = {
  __typename?: 'MissionConnection';
  /** Array of nodes. */
  nodes: Array<Mission>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type MissionCountAggregate = {
  __typename?: 'MissionCountAggregate';
  createdAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type MissionDeleteResponse = {
  __typename?: 'MissionDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<MissionOption>>;
  position?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<MissionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MissionFilter = {
  and?: InputMaybe<Array<MissionFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  missionSet?: InputMaybe<MissionFilterMissionSetFilter>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<MissionFilter>>;
  position?: InputMaybe<MissionPositionFilterComparison>;
};

export type MissionFilterMissionSetFilter = {
  and?: InputMaybe<Array<MissionFilterMissionSetFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<MissionFilterMissionSetFilter>>;
  workspaceId?: InputMaybe<IdFilterComparison>;
};

export type MissionInput = {
  instructions: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  options: Array<MissionOptionInput>;
  position?: InputMaybe<Scalars['Float']['input']>;
  set: Scalars['ID']['input'];
  type: MissionType;
};

export type MissionListFilter = {
  exclude?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MissionMaxAggregate = {
  __typename?: 'MissionMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
};

export type MissionMinAggregate = {
  __typename?: 'MissionMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
};

export type MissionOption = {
  __typename?: 'MissionOption';
  correct?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export type MissionOptionInput = {
  correct?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type MissionPositionFilterComparison = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type MissionSet = {
  __typename?: 'MissionSet';
  id: Scalars['ID']['output'];
  missions?: Maybe<Array<Mission>>;
  name: Scalars['String']['output'];
  workspaceId: Scalars['ID']['output'];
};


export type MissionSetMissionsArgs = {
  filter?: MissionFilter;
  sorting?: Array<MissionSort>;
};

export type MissionSetAggregateGroupBy = {
  __typename?: 'MissionSetAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type MissionSetConnection = {
  __typename?: 'MissionSetConnection';
  /** Array of nodes. */
  nodes: Array<MissionSet>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type MissionSetCountAggregate = {
  __typename?: 'MissionSetCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type MissionSetDeleteResponse = {
  __typename?: 'MissionSetDeleteResponse';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type MissionSetFilter = {
  and?: InputMaybe<Array<MissionSetFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<MissionSetFilter>>;
  workspaceId?: InputMaybe<IdFilterComparison>;
};

export type MissionSetMaxAggregate = {
  __typename?: 'MissionSetMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type MissionSetMinAggregate = {
  __typename?: 'MissionSetMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type MissionSetSort = {
  direction: SortDirection;
  field: MissionSetSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum MissionSetSortFields {
  ID = 'id',
  NAME = 'name',
  WORKSPACE_ID = 'workspaceId'
}

export type MissionSort = {
  direction: SortDirection;
  field: MissionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum MissionSortFields {
  CREATED_AT = 'createdAt',
  ID = 'id',
  NAME = 'name',
  POSITION = 'position'
}

export type MissionSumAggregate = {
  __typename?: 'MissionSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export enum MissionType {
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  TEXT = 'TEXT',
  TRUE_FALSE = 'TRUE_FALSE'
}

export type Modifier = {
  __typename?: 'Modifier';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  role: ModifierRole;
  updatedAt: Scalars['DateTime']['output'];
};

export type ModifierAggregateGroupBy = {
  __typename?: 'ModifierAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  role?: Maybe<ModifierRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModifierAvgAggregate = {
  __typename?: 'ModifierAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type ModifierConnection = {
  __typename?: 'ModifierConnection';
  /** Array of nodes. */
  nodes: Array<Modifier>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type ModifierCountAggregate = {
  __typename?: 'ModifierCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export type ModifierDeleteResponse = {
  __typename?: 'ModifierDeleteResponse';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  role?: Maybe<ModifierRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModifierFilter = {
  and?: InputMaybe<Array<ModifierFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  label?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ModifierFilter>>;
  role?: InputMaybe<ModifierRoleFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ModifierInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<ModifierRole>;
};

export type ModifierMaxAggregate = {
  __typename?: 'ModifierMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  role?: Maybe<ModifierRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModifierMinAggregate = {
  __typename?: 'ModifierMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  role?: Maybe<ModifierRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ModifierRole {
  EVENT_PRODUCER = 'EVENT_PRODUCER',
  HOST = 'HOST',
  PLANT = 'PLANT'
}

export type ModifierRoleFilterComparison = {
  eq?: InputMaybe<ModifierRole>;
};

export type ModifierSort = {
  direction: SortDirection;
  field: ModifierSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ModifierSortFields {
  ID = 'id',
  LABEL = 'label',
  ROLE = 'role',
  UPDATED_AT = 'updatedAt'
}

export type ModifierSumAggregate = {
  __typename?: 'ModifierSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  actionEndRealPlaythrough: Playthrough;
  actionMessageRealPlaythrough: Playthrough;
  actionStartRealPlaythrough: Playthrough;
  addAdditionalBookingContactsToSession: Session;
  addAvailabilitiesToUser: User;
  addFilesToSession: Session;
  addItemsToOrder: Order;
  addLocationToSession: Session;
  addMediaToCustomization: Customization;
  addMissionsToMissionSet: MissionSet;
  addSessionModifiers: Session;
  addSessionRelations: Session;
  addTimelineItem: TimelineItem;
  clearGroupDetails: Session;
  clearSessionAssignment: SessionAssignment;
  copyExperience: Experience;
  copyGroupDetails: Session;
  createAiPrompt: AiPrompt;
  createAvailabilities: Array<Availability>;
  createAvailability: Availability;
  createBookingUser: User;
  createExperience: Experience;
  createExperienceFormat: ExperienceFormat;
  createGameZone: GameZone;
  createGlobalUnavailabilities: Array<GlobalUnavailability>;
  createGlobalUnavailability: GlobalUnavailability;
  createInstruction: Instruction;
  createManualOrder: Order;
  createManyCustomizationMedias: Array<CustomizationMedia>;
  createManyFiles: Array<File>;
  createManySubscriptionPlans: Array<SubscriptionPlan>;
  createMission: Mission;
  createMissionSet: MissionSet;
  createModifier: Modifier;
  createOneCustomizationMedia: CustomizationMedia;
  createOneFile: File;
  createOneSubscriptionPlan: SubscriptionPlan;
  createOpenWeve: OpenWeve;
  createPermission: Permission;
  createPlant: User;
  createPriceModifier: PriceModifier;
  createSessionPhone: SessionPhone;
  createStaffUser: User;
  createUserAudio: UserAudio;
  createVenue: Venue;
  createVenueReview: VenueReview;
  createZoneArea: ZoneArea;
  deleteAiPrompt: AiPromptDeleteResponse;
  deleteAvailabilities: Array<DeleteAvailabilityResult>;
  deleteAvailability: DeleteAvailabilityResult;
  deleteExperience: Scalars['Boolean']['output'];
  deleteExperienceFormat: ExperienceFormatDeleteResponse;
  deleteGlobalUnavailability: GlobalUnavailabilityDeleteResponse;
  deleteInstruction: InstructionDeleteResponse;
  deleteManyCustomizationMedias: DeleteManyResponse;
  deleteManyFiles: DeleteManyResponse;
  deleteManySubscriptionPlans: DeleteManyResponse;
  deleteMission: MissionDeleteResponse;
  deleteMissionSet: MissionSetDeleteResponse;
  deleteModifier: ModifierDeleteResponse;
  deleteOneCustomizationMedia: CustomizationMediaDeleteResponse;
  deleteOneFile: FileDeleteResponse;
  deleteOneSubscriptionPlan: SubscriptionPlanDeleteResponse;
  deleteOpenWeve: OpenWeve;
  deleteOrder: Order;
  deleteOrderItems: DeleteManyResponse;
  deletePermission: Permission;
  deletePriceModifier: PriceModifierDeleteResponse;
  deleteSession: SessionDeleteResponse;
  deleteSessionAssignment?: Maybe<SessionAssignment>;
  deleteSessionPhone: SessionPhoneDeleteResponse;
  deleteSystem: System;
  deleteUser: DeleteUserDto;
  deleteUserAudio: Scalars['Boolean']['output'];
  deleteVenue: VenueDeleteResponse;
  deleteVenueReview: VenueReviewDeleteResponse;
  deleteZoneArea: ZoneAreaDeleteResponse;
  removeAdditionalBookingContactsFromSession: Session;
  removeAvailabilitiesFromUser: User;
  removeBannerFromExperience: Experience;
  removeBookingContactFromSession: Session;
  removeContactFromSession: Session;
  removeCustomizationFromWorkspace: Workspace;
  removeFeaturedFromExperience: Experience;
  removeFileFromCustomizationMedia: CustomizationMedia;
  removeFilesFromSession: Session;
  removeGroupFromSession: Session;
  removeImageFromExperience: Experience;
  removeImageFromUser: User;
  removeItemsFromOrder: Order;
  removeLawnScheduleFromSession: Session;
  removeLeftFromSessionRelation: SessionRelation;
  removeLocationFromSession: Session;
  removeMediaFromCustomization: Customization;
  removeMediaFromExperienceFormat: ExperienceFormat;
  removeMediaFromVenueReview: VenueReview;
  removeMissionSetFromSession: Session;
  removeMissionsFromMissionSet: MissionSet;
  removePosterFromExperience: Experience;
  removePosterFromExperienceFormat: ExperienceFormat;
  removeRightFromSessionRelation: SessionRelation;
  removeSessionModifiers: Session;
  removeSessionRelations: Session;
  removeSourceSessionFromSession: Session;
  removeThumbnailFromExperience: Experience;
  removeTimelineItem: TimelineItem;
  removeWorkspaceFromCustomization: Customization;
  resetCustomization: Customization;
  setAdditionalBookingContactsOnSession: Session;
  setAvailabilitiesOnUser: User;
  setBookingContactOnSession: Session;
  setContactOnSession: Session;
  setCustomizationOnWorkspace: Workspace;
  setFileOnCustomizationMedia: CustomizationMedia;
  setFilesOnSession: Session;
  setGroupOnSession: Session;
  setImageOnUser: User;
  setItemsOnOrder: Order;
  setLawnScheduleOnSession: Session;
  setLeftOnSessionRelation: SessionRelation;
  setMediaOnCustomization: Customization;
  setMissionSetOnSession: Session;
  setMissionsOnMissionSet: MissionSet;
  setRightOnSessionRelation: SessionRelation;
  setSourceSessionOnSession: Session;
  setSystem: System;
  setTimeline: Session;
  setUserOnSessionAssignment: SessionAssignment;
  setWorkspaceOnCustomization: Customization;
  updateAiPrompt: AiPrompt;
  updateAvailability: Availability;
  updateCustomization: Customization;
  updateExperience: Experience;
  updateExperienceFormat: ExperienceFormat;
  updateGalleryPassword: SessionIntegration;
  updateInstruction: Instruction;
  updateLawnSchedule?: Maybe<LawnSchedule>;
  updateManyCustomizationMedias: UpdateManyResponse;
  updateManyFiles: UpdateManyResponse;
  updateManySubscriptionPlans: UpdateManyResponse;
  updateMission: Mission;
  updateMissionSet: MissionSet;
  updateModifier: Modifier;
  updateOneCustomizationMedia: CustomizationMedia;
  updateOneFile: File;
  updateOneSubscriptionPlan: SubscriptionPlan;
  updateOpenWeve: OpenWeve;
  updateOrderItem: OrderItem;
  updatePermission: Permission;
  updatePriceModifier: PriceModifier;
  updateSession: Session;
  updateSessionAssignment: SessionAssignment;
  updateSessionAssignmentTravelConfirmationStatus: SessionAssignment;
  updateSessionGameControl: Session;
  updateSessionHostType: Session;
  updateSessionPhone: SessionPhone;
  updateSessionSyncType: Session;
  updateSessionType: Session;
  updateUser: User;
  updateUserAudio: UserAudio;
  updateVenue: Venue;
  updateVenueReview: VenueReview;
  updateWorkspace: Workspace;
  updateWorkspaceStaff: Workspace;
  updateZoneArea: ZoneArea;
};


export type MutationActionEndRealPlaythroughArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationActionMessageRealPlaythroughArgs = {
  message: Scalars['String']['input'];
  sessionId: Scalars['ID']['input'];
};


export type MutationActionStartRealPlaythroughArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationAddAdditionalBookingContactsToSessionArgs = {
  input: AddAdditionalBookingContactsToSessionInput;
};


export type MutationAddAvailabilitiesToUserArgs = {
  input: AddAvailabilitiesToUserInput;
};


export type MutationAddFilesToSessionArgs = {
  input: AddFilesToSessionInput;
};


export type MutationAddItemsToOrderArgs = {
  input: AddItemsToOrderInput;
};


export type MutationAddLocationToSessionArgs = {
  input: AddLocationToSessionInput;
};


export type MutationAddMediaToCustomizationArgs = {
  input: AddMediaToCustomizationInput;
};


export type MutationAddMissionsToMissionSetArgs = {
  input: AddMissionsToMissionSetInput;
};


export type MutationAddSessionModifiersArgs = {
  input: AddSessionModifiersInput;
};


export type MutationAddSessionRelationsArgs = {
  input: AddSessionRelationsInput;
};


export type MutationAddTimelineItemArgs = {
  input: AddTimelineItem;
};


export type MutationClearGroupDetailsArgs = {
  input: ClearGroupDetailsInput;
};


export type MutationClearSessionAssignmentArgs = {
  input: ClearSessionAssignmentInput;
};


export type MutationCopyExperienceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCopyGroupDetailsArgs = {
  input: CopyGroupDetailsInput;
};


export type MutationCreateAiPromptArgs = {
  input: CreateOneAiPromptInput;
};


export type MutationCreateAvailabilitiesArgs = {
  input: Array<CreateAvailabilityInput>;
};


export type MutationCreateAvailabilityArgs = {
  input: CreateAvailabilityInput;
};


export type MutationCreateBookingUserArgs = {
  input: CreateBookingUserInput;
};


export type MutationCreateExperienceArgs = {
  input: CreateExperienceInput;
};


export type MutationCreateExperienceFormatArgs = {
  input: CreateExperienceFormatInput;
};


export type MutationCreateGameZoneArgs = {
  input: CreateGameZoneInput;
};


export type MutationCreateGlobalUnavailabilitiesArgs = {
  input: CreateManyGlobalUnavailabilitiesInput;
};


export type MutationCreateGlobalUnavailabilityArgs = {
  input: CreateOneGlobalUnavailabilityInput;
};


export type MutationCreateInstructionArgs = {
  input: CreateOneInstructionInput;
};


export type MutationCreateManualOrderArgs = {
  input: CreateManualOrderInput;
};


export type MutationCreateManyCustomizationMediasArgs = {
  input: CreateManyCustomizationMediasInput;
};


export type MutationCreateManyFilesArgs = {
  input: CreateManyFilesInput;
};


export type MutationCreateManySubscriptionPlansArgs = {
  input: CreateManySubscriptionPlansInput;
};


export type MutationCreateMissionArgs = {
  input: CreateMissionInput;
};


export type MutationCreateMissionSetArgs = {
  input: CreateOneMissionSetInput;
};


export type MutationCreateModifierArgs = {
  input: CreateModifierInput;
};


export type MutationCreateOneCustomizationMediaArgs = {
  input: CreateOneCustomizationMediaInput;
};


export type MutationCreateOneFileArgs = {
  input: CreateOneFileInput;
};


export type MutationCreateOneSubscriptionPlanArgs = {
  input: CreateOneSubscriptionPlanInput;
};


export type MutationCreateOpenWeveArgs = {
  input: CreateOpenWeveInput;
};


export type MutationCreatePermissionArgs = {
  input: CreatePermissionInput;
};


export type MutationCreatePlantArgs = {
  input: CreatePlantInput;
};


export type MutationCreatePriceModifierArgs = {
  input: CreateOnePriceModifierInput;
};


export type MutationCreateSessionPhoneArgs = {
  input: CreateOneSessionPhoneInput;
};


export type MutationCreateStaffUserArgs = {
  input: CreateStaffUserInput;
};


export type MutationCreateUserAudioArgs = {
  input: CreateUserAudioInput;
};


export type MutationCreateVenueArgs = {
  input: CreateOneVenueInput;
};


export type MutationCreateVenueReviewArgs = {
  input: CreateOneVenueReviewInput;
};


export type MutationCreateZoneAreaArgs = {
  input: CreateZoneAreaInput;
};


export type MutationDeleteAiPromptArgs = {
  input: DeleteOneAiPromptInput;
};


export type MutationDeleteAvailabilitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAvailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExperienceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExperienceFormatArgs = {
  input: DeleteOneExperienceFormatInput;
};


export type MutationDeleteGlobalUnavailabilityArgs = {
  input: DeleteOneGlobalUnavailabilityInput;
};


export type MutationDeleteInstructionArgs = {
  input: DeleteOneInstructionInput;
};


export type MutationDeleteManyCustomizationMediasArgs = {
  input: DeleteManyCustomizationMediasInput;
};


export type MutationDeleteManyFilesArgs = {
  input: DeleteManyFilesInput;
};


export type MutationDeleteManySubscriptionPlansArgs = {
  input: DeleteManySubscriptionPlansInput;
};


export type MutationDeleteMissionArgs = {
  input: DeleteOneMissionInput;
};


export type MutationDeleteMissionSetArgs = {
  input: DeleteOneMissionSetInput;
};


export type MutationDeleteModifierArgs = {
  input: DeleteOneModifierInput;
};


export type MutationDeleteOneCustomizationMediaArgs = {
  input: DeleteOneCustomizationMediaInput;
};


export type MutationDeleteOneFileArgs = {
  input: DeleteOneFileInput;
};


export type MutationDeleteOneSubscriptionPlanArgs = {
  input: DeleteOneSubscriptionPlanInput;
};


export type MutationDeleteOpenWeveArgs = {
  input: DeleteOpenWeveInput;
};


export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};


export type MutationDeleteOrderItemsArgs = {
  input: DeleteOrderItemsInput;
};


export type MutationDeletePermissionArgs = {
  input: DeletePermissionInput;
};


export type MutationDeletePriceModifierArgs = {
  input: DeleteOnePriceModifierInput;
};


export type MutationDeleteSessionArgs = {
  input: DeleteOneSessionInput;
};


export type MutationDeleteSessionAssignmentArgs = {
  input: DeleteSessionAssignmentInput;
};


export type MutationDeleteSessionPhoneArgs = {
  input: DeleteOneSessionPhoneInput;
};


export type MutationDeleteSystemArgs = {
  input: DeleteSystemInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteUserAudioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVenueArgs = {
  input: DeleteOneVenueInput;
};


export type MutationDeleteVenueReviewArgs = {
  input: DeleteOneVenueReviewInput;
};


export type MutationDeleteZoneAreaArgs = {
  input: DeleteOneZoneAreaInput;
};


export type MutationRemoveAdditionalBookingContactsFromSessionArgs = {
  input: RemoveAdditionalBookingContactsFromSessionInput;
};


export type MutationRemoveAvailabilitiesFromUserArgs = {
  input: RemoveAvailabilitiesFromUserInput;
};


export type MutationRemoveBannerFromExperienceArgs = {
  input: RemoveBannerFromExperienceInput;
};


export type MutationRemoveBookingContactFromSessionArgs = {
  input: RemoveBookingContactFromSessionInput;
};


export type MutationRemoveContactFromSessionArgs = {
  input: RemoveContactFromSessionInput;
};


export type MutationRemoveCustomizationFromWorkspaceArgs = {
  input: RemoveCustomizationFromWorkspaceInput;
};


export type MutationRemoveFeaturedFromExperienceArgs = {
  input: RemoveFeaturedFromExperienceInput;
};


export type MutationRemoveFileFromCustomizationMediaArgs = {
  input: RemoveFileFromCustomizationMediaInput;
};


export type MutationRemoveFilesFromSessionArgs = {
  input: RemoveFilesFromSessionInput;
};


export type MutationRemoveGroupFromSessionArgs = {
  input: RemoveGroupFromSessionInput;
};


export type MutationRemoveImageFromExperienceArgs = {
  input: RemoveImageFromExperienceInput;
};


export type MutationRemoveImageFromUserArgs = {
  input: RemoveImageFromUserInput;
};


export type MutationRemoveItemsFromOrderArgs = {
  input: RemoveItemsFromOrderInput;
};


export type MutationRemoveLawnScheduleFromSessionArgs = {
  input: RemoveLawnScheduleFromSessionInput;
};


export type MutationRemoveLeftFromSessionRelationArgs = {
  input: RemoveLeftFromSessionRelationInput;
};


export type MutationRemoveLocationFromSessionArgs = {
  input: RemoveLocationFromSessionInput;
};


export type MutationRemoveMediaFromCustomizationArgs = {
  input: RemoveMediaFromCustomizationInput;
};


export type MutationRemoveMediaFromExperienceFormatArgs = {
  input: RemoveMediaFromExperienceFormatInput;
};


export type MutationRemoveMediaFromVenueReviewArgs = {
  input: RemoveMediaFromVenueReviewInput;
};


export type MutationRemoveMissionSetFromSessionArgs = {
  input: RemoveMissionSetFromSessionInput;
};


export type MutationRemoveMissionsFromMissionSetArgs = {
  input: RemoveMissionsFromMissionSetInput;
};


export type MutationRemovePosterFromExperienceArgs = {
  input: RemovePosterFromExperienceInput;
};


export type MutationRemovePosterFromExperienceFormatArgs = {
  input: RemovePosterFromExperienceFormatInput;
};


export type MutationRemoveRightFromSessionRelationArgs = {
  input: RemoveRightFromSessionRelationInput;
};


export type MutationRemoveSessionModifiersArgs = {
  input: RemoveSessionModifiersInput;
};


export type MutationRemoveSessionRelationsArgs = {
  input: RemoveSessionRelationsInput;
};


export type MutationRemoveSourceSessionFromSessionArgs = {
  input: RemoveSourceSessionFromSessionInput;
};


export type MutationRemoveThumbnailFromExperienceArgs = {
  input: RemoveThumbnailFromExperienceInput;
};


export type MutationRemoveTimelineItemArgs = {
  input: RemoveTimelineItem;
};


export type MutationRemoveWorkspaceFromCustomizationArgs = {
  input: RemoveWorkspaceFromCustomizationInput;
};


export type MutationResetCustomizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetAdditionalBookingContactsOnSessionArgs = {
  input: SetAdditionalBookingContactsOnSessionInput;
};


export type MutationSetAvailabilitiesOnUserArgs = {
  input: SetAvailabilitiesOnUserInput;
};


export type MutationSetBookingContactOnSessionArgs = {
  input: SetBookingContactOnSessionInput;
};


export type MutationSetContactOnSessionArgs = {
  input: SetContactOnSessionInput;
};


export type MutationSetCustomizationOnWorkspaceArgs = {
  input: SetCustomizationOnWorkspaceInput;
};


export type MutationSetFileOnCustomizationMediaArgs = {
  input: SetFileOnCustomizationMediaInput;
};


export type MutationSetFilesOnSessionArgs = {
  input: SetFilesOnSessionInput;
};


export type MutationSetGroupOnSessionArgs = {
  input: SetGroupOnSessionInput;
};


export type MutationSetImageOnUserArgs = {
  input: SetImageOnUserInput;
};


export type MutationSetItemsOnOrderArgs = {
  input: SetItemsOnOrderInput;
};


export type MutationSetLawnScheduleOnSessionArgs = {
  input: SetLawnScheduleOnSessionInput;
};


export type MutationSetLeftOnSessionRelationArgs = {
  input: SetLeftOnSessionRelationInput;
};


export type MutationSetMediaOnCustomizationArgs = {
  input: SetMediaOnCustomizationInput;
};


export type MutationSetMissionSetOnSessionArgs = {
  input: SetMissionSetOnSessionInput;
};


export type MutationSetMissionsOnMissionSetArgs = {
  input: SetMissionsOnMissionSetInput;
};


export type MutationSetRightOnSessionRelationArgs = {
  input: SetRightOnSessionRelationInput;
};


export type MutationSetSourceSessionOnSessionArgs = {
  input: SetSourceSessionOnSessionInput;
};


export type MutationSetSystemArgs = {
  input: SetSystemInput;
};


export type MutationSetTimelineArgs = {
  input: SetTimelineInput;
};


export type MutationSetUserOnSessionAssignmentArgs = {
  input: SetUserOnSessionAssignmentInput;
};


export type MutationSetWorkspaceOnCustomizationArgs = {
  input: SetWorkspaceOnCustomizationInput;
};


export type MutationUpdateAiPromptArgs = {
  input: UpdateOneAiPromptInput;
};


export type MutationUpdateAvailabilityArgs = {
  input: UpdateAvailabilityInput;
};


export type MutationUpdateCustomizationArgs = {
  input: UpdateOneCustomizationInput;
};


export type MutationUpdateExperienceArgs = {
  input: UpdateOneExperienceInput;
};


export type MutationUpdateExperienceFormatArgs = {
  input: UpdateOneExperienceFormatInput;
};


export type MutationUpdateGalleryPasswordArgs = {
  input: UpdateGalleryPasswordInput;
};


export type MutationUpdateInstructionArgs = {
  input: UpdateOneInstructionInput;
};


export type MutationUpdateLawnScheduleArgs = {
  input: UpdateLawnScheduleInput;
  sessionId: Scalars['ID']['input'];
};


export type MutationUpdateManyCustomizationMediasArgs = {
  input: UpdateManyCustomizationMediasInput;
};


export type MutationUpdateManyFilesArgs = {
  input: UpdateManyFilesInput;
};


export type MutationUpdateManySubscriptionPlansArgs = {
  input: UpdateManySubscriptionPlansInput;
};


export type MutationUpdateMissionArgs = {
  input: UpdateOneMissionInput;
};


export type MutationUpdateMissionSetArgs = {
  input: UpdateOneMissionSetInput;
};


export type MutationUpdateModifierArgs = {
  input: UpdateOneModifierInput;
};


export type MutationUpdateOneCustomizationMediaArgs = {
  input: UpdateOneCustomizationMediaInput;
};


export type MutationUpdateOneFileArgs = {
  input: UpdateOneFileInput;
};


export type MutationUpdateOneSubscriptionPlanArgs = {
  input: UpdateOneSubscriptionPlanInput;
};


export type MutationUpdateOpenWeveArgs = {
  input: UpdateOpenWeveInput;
};


export type MutationUpdateOrderItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrderItemInput;
};


export type MutationUpdatePermissionArgs = {
  input: UpdatePermissionInput;
};


export type MutationUpdatePriceModifierArgs = {
  input: UpdateOnePriceModifierInput;
};


export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};


export type MutationUpdateSessionAssignmentArgs = {
  input: UpdateSessionAssignmentInput;
};


export type MutationUpdateSessionAssignmentTravelConfirmationStatusArgs = {
  input: UpdateSessionAssignmentTravelConfirmationStatusInput;
};


export type MutationUpdateSessionGameControlArgs = {
  input: UpdateGameControl;
};


export type MutationUpdateSessionHostTypeArgs = {
  input: UpdateHostTypeInput;
};


export type MutationUpdateSessionPhoneArgs = {
  input: UpdateOneSessionPhoneInput;
};


export type MutationUpdateSessionSyncTypeArgs = {
  input: UpdateSessionSyncTypeInput;
};


export type MutationUpdateSessionTypeArgs = {
  input: UpdateSessionTypeInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserAudioArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserAudioInput;
};


export type MutationUpdateVenueArgs = {
  input: UpdateOneVenueInput;
};


export type MutationUpdateVenueReviewArgs = {
  input: UpdateOneVenueReviewInput;
};


export type MutationUpdateWorkspaceArgs = {
  input: UpdateWorkspaceInput;
};


export type MutationUpdateWorkspaceStaffArgs = {
  input: UpdateWorkspaceStaffInput;
};


export type MutationUpdateZoneAreaArgs = {
  input: UpdateOneZoneAreaInput;
};

export type NearPoint = {
  coordinates: Array<Scalars['Float']['input']>;
  radius: Scalars['Float']['input'];
};

export type NewTimelineItemInput = {
  description: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
};

export type OffsetPaging = {
  /** Limit the number of records returned */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Offset to start returning records from */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum OpenAiModel {
  GPT_4_O = 'GPT_4O',
  GTP_4 = 'GTP_4'
}

export type OpenAiModelFilterComparison = {
  contArr?: InputMaybe<OpenAiModel>;
  eq?: InputMaybe<OpenAiModel>;
  gt?: InputMaybe<OpenAiModel>;
  gte?: InputMaybe<OpenAiModel>;
  iLike?: InputMaybe<OpenAiModel>;
  in?: InputMaybe<Array<OpenAiModel>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<OpenAiModel>;
  lt?: InputMaybe<OpenAiModel>;
  lte?: InputMaybe<OpenAiModel>;
  neq?: InputMaybe<OpenAiModel>;
  notILike?: InputMaybe<OpenAiModel>;
  notIn?: InputMaybe<Array<OpenAiModel>>;
  notLike?: InputMaybe<OpenAiModel>;
  overlaps?: InputMaybe<OpenAiModel>;
};

export type OpenWeve = {
  __typename?: 'OpenWeve';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  workspace: Workspace;
};

export type OpenWeveAggregateGroupBy = {
  __typename?: 'OpenWeveAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OpenWeveConnection = {
  __typename?: 'OpenWeveConnection';
  /** Array of nodes. */
  nodes: Array<OpenWeve>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type OpenWeveCountAggregate = {
  __typename?: 'OpenWeveCountAggregate';
  createdAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export type OpenWeveFilter = {
  and?: InputMaybe<Array<OpenWeveFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OpenWeveFilter>>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  workspace?: InputMaybe<OpenWeveFilterWorkspaceFilter>;
};

export type OpenWeveFilterWorkspaceFilter = {
  and?: InputMaybe<Array<OpenWeveFilterWorkspaceFilter>>;
  id?: InputMaybe<WorkspaceIdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<OpenWeveFilterWorkspaceFilter>>;
  preferredEventProducerId?: InputMaybe<IdFilterComparison>;
  preferredSalesId?: InputMaybe<IdFilterComparison>;
};

export type OpenWeveMaxAggregate = {
  __typename?: 'OpenWeveMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OpenWeveMinAggregate = {
  __typename?: 'OpenWeveMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OpenWeveSort = {
  direction: SortDirection;
  field: OpenWeveSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OpenWeveSortFields {
  CREATED_AT = 'createdAt',
  ID = 'id',
  UPDATED_AT = 'updatedAt'
}

export type Order = {
  __typename?: 'Order';
  amount: Scalars['Float']['output'];
  consumables: Array<AvailableConsumable>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdDate: Scalars['JSDate']['output'];
  dealId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
  paidAt: Scalars['Date']['output'];
  paidDate: Scalars['JSDate']['output'];
  source: OrderCreationSource;
  subscription: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['ID']['output'];
};


export type OrderItemsArgs = {
  filter?: OrderItemFilter;
  sorting?: Array<OrderItemSort>;
};

export type OrderAggregateGroupBy = {
  __typename?: 'OrderAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type OrderAvgAggregate = {
  __typename?: 'OrderAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  workspaceId?: Maybe<Scalars['Float']['output']>;
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** Array of nodes. */
  nodes: Array<Order>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type OrderCountAggregate = {
  __typename?: 'OrderCountAggregate';
  createdAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export enum OrderCreationSource {
  HUBSPOT = 'HUBSPOT',
  MANUAL = 'MANUAL',
  ONLINE = 'ONLINE'
}

export type OrderFilter = {
  and?: InputMaybe<Array<OrderFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<OrderIdFilterComparison>;
  or?: InputMaybe<Array<OrderFilter>>;
  workspaceId?: InputMaybe<OrderWorkspaceIdFilterComparison>;
};

export type OrderIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  consumable: Consumable;
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type OrderItemAggregateGroupBy = {
  __typename?: 'OrderItemAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
};

export type OrderItemAvgAggregate = {
  __typename?: 'OrderItemAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type OrderItemConnection = {
  __typename?: 'OrderItemConnection';
  /** Array of edges. */
  edges: Array<OrderItemEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type OrderItemCountAggregate = {
  __typename?: 'OrderItemCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type OrderItemEdge = {
  __typename?: 'OrderItemEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the OrderItem */
  node: OrderItem;
};

export type OrderItemFilter = {
  and?: InputMaybe<Array<OrderItemFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<OrderItemFilter>>;
};

export type OrderItemInput = {
  name: PurchasableConsumableName;
  quantity: Scalars['Int']['input'];
  unitPrice: Scalars['Int']['input'];
};

export type OrderItemMaxAggregate = {
  __typename?: 'OrderItemMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type OrderItemMinAggregate = {
  __typename?: 'OrderItemMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type OrderItemSort = {
  direction: SortDirection;
  field: OrderItemSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrderItemSortFields {
  ID = 'id'
}

export type OrderItemSumAggregate = {
  __typename?: 'OrderItemSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type OrderMaxAggregate = {
  __typename?: 'OrderMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type OrderMinAggregate = {
  __typename?: 'OrderMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type OrderSort = {
  direction: SortDirection;
  field: OrderSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum OrderSortFields {
  CREATED_AT = 'createdAt',
  ID = 'id',
  WORKSPACE_ID = 'workspaceId'
}

export type OrderSumAggregate = {
  __typename?: 'OrderSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  workspaceId?: Maybe<Scalars['Float']['output']>;
};

export type OrderWorkspaceIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
};

export enum PdfType {
  BATTLE_ROYALE = 'BATTLE_ROYALE',
  CHARITY_BIKE_BUILD = 'CHARITY_BIKE_BUILD',
  GAME_ADVENTURE = 'GAME_ADVENTURE',
  GAME_SHOW = 'GAME_SHOW',
  MUSIC_VIDEO = 'MUSIC_VIDEO',
  NETWORKING_BINGO = 'NETWORKING_BINGO',
  SECRET_AGENT = 'SECRET_AGENT',
  SINGLE_TEAM_ADVENTURE = 'SINGLE_TEAM_ADVENTURE',
  SPANISH_ADVENTURE = 'SPANISH_ADVENTURE',
  STACKING_FOR_GOOD = 'STACKING_FOR_GOOD',
  TEAM_PLAY = 'TEAM_PLAY',
  VAS = 'VAS'
}

export type PdfTypeFilterComparison = {
  contArr?: InputMaybe<PdfType>;
  eq?: InputMaybe<PdfType>;
  gt?: InputMaybe<PdfType>;
  gte?: InputMaybe<PdfType>;
  iLike?: InputMaybe<PdfType>;
  in?: InputMaybe<Array<PdfType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<PdfType>;
  lt?: InputMaybe<PdfType>;
  lte?: InputMaybe<PdfType>;
  neq?: InputMaybe<PdfType>;
  notILike?: InputMaybe<PdfType>;
  notIn?: InputMaybe<Array<PdfType>>;
  notLike?: InputMaybe<PdfType>;
  overlaps?: InputMaybe<PdfType>;
};

export enum PackageLevel {
  PREMIUM = 'PREMIUM',
  PRO = 'PRO',
  STANDARD = 'STANDARD'
}

export type PackageLevelFilterComparison = {
  contArr?: InputMaybe<PackageLevel>;
  eq?: InputMaybe<PackageLevel>;
  gt?: InputMaybe<PackageLevel>;
  gte?: InputMaybe<PackageLevel>;
  iLike?: InputMaybe<PackageLevel>;
  in?: InputMaybe<Array<PackageLevel>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<PackageLevel>;
  lt?: InputMaybe<PackageLevel>;
  lte?: InputMaybe<PackageLevel>;
  neq?: InputMaybe<PackageLevel>;
  notILike?: InputMaybe<PackageLevel>;
  notIn?: InputMaybe<Array<PackageLevel>>;
  notLike?: InputMaybe<PackageLevel>;
  overlaps?: InputMaybe<PackageLevel>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  id: Scalars['ID']['output'];
  primary: Scalars['Boolean']['output'];
  role: PermissionRole;
  userId: Scalars['ID']['output'];
  workspace: Workspace;
  workspaceId: Scalars['ID']['output'];
};

export type PermissionAggregateGroupBy = {
  __typename?: 'PermissionAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<PermissionRole>;
  userId?: Maybe<Scalars['ID']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type PermissionAvgAggregate = {
  __typename?: 'PermissionAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  role?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
  workspaceId?: Maybe<Scalars['Float']['output']>;
};

export type PermissionConnection = {
  __typename?: 'PermissionConnection';
  /** Array of nodes. */
  nodes: Array<Permission>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type PermissionCountAggregate = {
  __typename?: 'PermissionCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type PermissionFilter = {
  and?: InputMaybe<Array<PermissionFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<PermissionFilter>>;
  role?: InputMaybe<PermissionRoleFilterComparison>;
  userId?: InputMaybe<PermissionUserIdFilterComparison>;
  workspaceId?: InputMaybe<PermissionWorkspaceIdFilterComparison>;
};

export type PermissionMaxAggregate = {
  __typename?: 'PermissionMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<PermissionRole>;
  userId?: Maybe<Scalars['ID']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type PermissionMinAggregate = {
  __typename?: 'PermissionMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<PermissionRole>;
  userId?: Maybe<Scalars['ID']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export enum PermissionRole {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER'
}

export type PermissionRoleFilterComparison = {
  eq?: InputMaybe<PermissionRole>;
};

export type PermissionSort = {
  direction: SortDirection;
  field: PermissionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PermissionSortFields {
  ID = 'id',
  ROLE = 'role',
  USER_ID = 'userId',
  WORKSPACE_ID = 'workspaceId'
}

export type PermissionSumAggregate = {
  __typename?: 'PermissionSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  role?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
  workspaceId?: Maybe<Scalars['Float']['output']>;
};

export type PermissionUserIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PermissionWorkspaceIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum PhoneSource {
  PRODUCER = 'PRODUCER',
  SUPPORTING_PRODUCER = 'SUPPORTING_PRODUCER',
  SUPPORT_TEAM = 'SUPPORT_TEAM'
}

export enum PlayType {
  INDIVIDUAL = 'INDIVIDUAL',
  TEAM = 'TEAM'
}

export type Playthrough = {
  __typename?: 'Playthrough';
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: PlaythroughStatus;
};

export enum PlaythroughStatus {
  ARCHIVED = 'ARCHIVED',
  CLOSED = 'CLOSED',
  ENDED = 'ENDED',
  ENDING = 'ENDING',
  PAUSED = 'PAUSED',
  STARTED = 'STARTED',
  VOTING = 'VOTING'
}

export type PointFieldComparison = {
  near?: InputMaybe<NearPoint>;
  within?: InputMaybe<Within>;
};

export type PriceModifier = {
  __typename?: 'PriceModifier';
  dateRange: Scalars['DateTimeRange']['output'];
  id: Scalars['ID']['output'];
  percent: Scalars['Float']['output'];
  types: Array<SessionType>;
};

export type PriceModifierAggregateGroupBy = {
  __typename?: 'PriceModifierAggregateGroupBy';
  dateRange?: Maybe<Scalars['DateTimeRange']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PriceModifierAvgAggregate = {
  __typename?: 'PriceModifierAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type PriceModifierConnection = {
  __typename?: 'PriceModifierConnection';
  /** Array of nodes. */
  nodes: Array<PriceModifier>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type PriceModifierCountAggregate = {
  __typename?: 'PriceModifierCountAggregate';
  dateRange?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type PriceModifierDateRangeFilterComparison = {
  overlaps?: InputMaybe<Scalars['DateTimeRange']['input']>;
};

export type PriceModifierDeleteResponse = {
  __typename?: 'PriceModifierDeleteResponse';
  dateRange?: Maybe<Scalars['DateTimeRange']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  types?: Maybe<Array<SessionType>>;
};

export type PriceModifierFilter = {
  and?: InputMaybe<Array<PriceModifierFilter>>;
  dateRange?: InputMaybe<PriceModifierDateRangeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<PriceModifierFilter>>;
};

export type PriceModifierMaxAggregate = {
  __typename?: 'PriceModifierMaxAggregate';
  dateRange?: Maybe<Scalars['DateTimeRange']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PriceModifierMinAggregate = {
  __typename?: 'PriceModifierMinAggregate';
  dateRange?: Maybe<Scalars['DateTimeRange']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PriceModifierSort = {
  direction: SortDirection;
  field: PriceModifierSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum PriceModifierSortFields {
  DATE_RANGE = 'dateRange',
  ID = 'id'
}

export type PriceModifierSumAggregate = {
  __typename?: 'PriceModifierSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export enum PurchasableConsumableName {
  CREDIT = 'CREDIT'
}

export type Query = {
  __typename?: 'Query';
  aiPrompt?: Maybe<AiPrompt>;
  aiPrompts: AiPromptConnection;
  availabilities: AvailabilityConnection;
  availability?: Maybe<Availability>;
  breadcrumbMissionLists: BreadcrumbMissionListConnection;
  breadcrumbMissions: BreadcrumbMissionConnection;
  breadcrumbRealPlaythrough: Playthrough;
  customization?: Maybe<Customization>;
  customizationMedia?: Maybe<CustomizationMedia>;
  customizationMedias: CustomizationMediaConnection;
  customizations: CustomizationConnection;
  experience: Experience;
  experienceFormat?: Maybe<ExperienceFormat>;
  experienceFormats: ExperienceFormatConnection;
  experiences: ExperienceConnection;
  file?: Maybe<File>;
  files: FileConnection;
  gameCities: GameCityConnection;
  gameZone?: Maybe<GameZone>;
  gameZones: GameZoneConnection;
  globalUnavailabilities: GlobalUnavailabilityConnection;
  globalUnavailability?: Maybe<GlobalUnavailability>;
  instruction?: Maybe<Instruction>;
  instructions: InstructionConnection;
  lawnSchedule?: Maybe<LawnSchedule>;
  me: User;
  mission?: Maybe<Mission>;
  missionSet?: Maybe<MissionSet>;
  missionSets: MissionSetConnection;
  missions: MissionConnection;
  modifier?: Maybe<Modifier>;
  modifiers: ModifierConnection;
  openWeve?: Maybe<OpenWeve>;
  openWeves: OpenWeveConnection;
  order?: Maybe<Order>;
  orderItem?: Maybe<OrderItem>;
  orderItems: OrderItemConnection;
  orders: OrderConnection;
  permission?: Maybe<Permission>;
  permissions: PermissionConnection;
  priceModifier?: Maybe<PriceModifier>;
  priceModifiers: PriceModifierConnection;
  session?: Maybe<Session>;
  sessionAssignment?: Maybe<SessionAssignment>;
  sessionAssignments: SessionAssignmentConnection;
  sessionGroup?: Maybe<SessionGroup>;
  sessionGroups: SessionGroupConnection;
  sessionPhone?: Maybe<SessionPhone>;
  sessionPhones: SessionPhoneConnection;
  sessions: SessionConnection;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  subscriptionPlans: SubscriptionPlanConnection;
  system?: Maybe<System>;
  template?: Maybe<Template>;
  templates: TemplateConnection;
  user?: Maybe<User>;
  userAudios: UserAudioConnection;
  users: UserConnection;
  venue?: Maybe<Venue>;
  venueReview?: Maybe<VenueReview>;
  venueReviews: VenueReviewConnection;
  venues: VenueConnection;
  workspace?: Maybe<Workspace>;
  workspaces: WorkspaceConnection;
  zoneArea?: Maybe<ZoneArea>;
  zoneAreas: ZoneAreaConnection;
};


export type QueryAiPromptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAiPromptsArgs = {
  filter?: AiPromptFilter;
  paging?: OffsetPaging;
  sorting?: Array<AiPromptSort>;
};


export type QueryAvailabilitiesArgs = {
  filter?: AvailabilityFilter;
  paging?: OffsetPaging;
  sorting?: Array<AvailabilitySort>;
};


export type QueryAvailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBreadcrumbMissionListsArgs = {
  filter: MissionListFilter;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<BreadcrumbSorting>;
};


export type QueryBreadcrumbMissionsArgs = {
  filter: BreadcrumbMissionFilter;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<BreadcrumbSorting>;
};


export type QueryBreadcrumbRealPlaythroughArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryCustomizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomizationMediaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomizationMediasArgs = {
  filter?: CustomizationMediaFilter;
  paging?: CursorPaging;
  sorting?: Array<CustomizationMediaSort>;
};


export type QueryCustomizationsArgs = {
  filter?: CustomizationFilter;
  paging?: CursorPaging;
  sorting?: Array<CustomizationSort>;
};


export type QueryExperienceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExperienceFormatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExperienceFormatsArgs = {
  filter?: ExperienceFormatFilter;
  paging?: OffsetPaging;
  sorting?: Array<ExperienceFormatSort>;
};


export type QueryExperiencesArgs = {
  filter?: ExperienceFilter;
  paging?: OffsetPaging;
  sorting?: Array<ExperienceSort>;
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFilesArgs = {
  filter?: FileFilter;
  paging?: CursorPaging;
  sorting?: Array<FileSort>;
};


export type QueryGameCitiesArgs = {
  filter: GameCityFilter;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<BreadcrumbSorting>;
};


export type QueryGameZoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGameZonesArgs = {
  filter: GameZoneFilter;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<BreadcrumbSorting>;
};


export type QueryGlobalUnavailabilitiesArgs = {
  filter?: GlobalUnavailabilityFilter;
  paging?: OffsetPaging;
  sorting?: Array<GlobalUnavailabilitySort>;
};


export type QueryGlobalUnavailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInstructionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInstructionsArgs = {
  filter?: InstructionFilter;
  paging?: OffsetPaging;
  sorting?: Array<InstructionSort>;
};


export type QueryLawnScheduleArgs = {
  sessionId: Scalars['ID']['input'];
};


export type QueryMissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMissionSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMissionSetsArgs = {
  filter?: MissionSetFilter;
  paging?: OffsetPaging;
  sorting?: Array<MissionSetSort>;
};


export type QueryMissionsArgs = {
  filter?: MissionFilter;
  paging?: OffsetPaging;
  sorting?: Array<MissionSort>;
};


export type QueryModifierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryModifiersArgs = {
  filter?: ModifierFilter;
  paging?: OffsetPaging;
  sorting?: Array<ModifierSort>;
};


export type QueryOpenWeveArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpenWevesArgs = {
  filter?: OpenWeveFilter;
  paging?: OffsetPaging;
  sorting?: Array<OpenWeveSort>;
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderItemsArgs = {
  filter?: OrderItemFilter;
  paging?: CursorPaging;
  sorting?: Array<OrderItemSort>;
};


export type QueryOrdersArgs = {
  filter?: OrderFilter;
  paging?: OffsetPaging;
  sorting?: Array<OrderSort>;
};


export type QueryPermissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionsArgs = {
  filter?: PermissionFilter;
  paging?: OffsetPaging;
  sorting?: Array<PermissionSort>;
};


export type QueryPriceModifierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPriceModifiersArgs = {
  filter?: PriceModifierFilter;
  paging?: OffsetPaging;
  sorting?: Array<PriceModifierSort>;
};


export type QuerySessionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySessionAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySessionAssignmentsArgs = {
  filter?: SessionAssignmentFilter;
  paging?: OffsetPaging;
  sorting?: Array<SessionAssignmentSort>;
};


export type QuerySessionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySessionGroupsArgs = {
  filter?: SessionGroupFilter;
  paging?: OffsetPaging;
  sorting?: Array<SessionGroupSort>;
};


export type QuerySessionPhoneArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySessionPhonesArgs = {
  filter?: SessionPhoneFilter;
  paging?: OffsetPaging;
  sorting?: Array<SessionPhoneSort>;
};


export type QuerySessionsArgs = {
  filter?: SessionFilter;
  paging?: OffsetPaging;
  sorting?: Array<SessionSort>;
};


export type QuerySubscriptionPlanArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscriptionPlansArgs = {
  filter?: SubscriptionPlanFilter;
  paging?: CursorPaging;
  sorting?: Array<SubscriptionPlanSort>;
};


export type QuerySystemArgs = {
  key: SystemKey;
};


export type QueryTemplateArgs = {
  id: Scalars['ID']['input'];
  sync: SyncType;
  type?: InputMaybe<SessionTemplateType>;
};


export type QueryTemplatesArgs = {
  filter?: InputMaybe<TemplateFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Sorting>;
  sync: SyncType;
  type?: InputMaybe<SessionTemplateType>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAudiosArgs = {
  paging?: OffsetPaging;
};


export type QueryUsersArgs = {
  filter?: UserFilter;
  paging?: OffsetPaging;
  sorting?: Array<UserSort>;
};


export type QueryVenueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVenueReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVenueReviewsArgs = {
  filter?: VenueReviewFilter;
  paging?: OffsetPaging;
  sorting?: Array<VenueReviewSort>;
};


export type QueryVenuesArgs = {
  filter?: VenueFilter;
  paging?: OffsetPaging;
  sorting?: Array<VenueSort>;
};


export type QueryWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkspacesArgs = {
  filter?: WorkspaceFilter;
  paging?: OffsetPaging;
  sorting?: Array<WorkspaceSort>;
};


export type QueryZoneAreaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZoneAreasArgs = {
  filter?: ZoneAreaFilter;
  paging?: OffsetPaging;
  sorting?: Array<ZoneAreaSort>;
};

export type RemoveAdditionalBookingContactsFromSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type RemoveAvailabilitiesFromUserInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type RemoveBannerFromExperienceInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveBookingContactFromSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveContactFromSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveCustomizationFromWorkspaceInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveFeaturedFromExperienceInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveFileFromCustomizationMediaInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveFilesFromSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type RemoveGroupFromSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveImageFromExperienceInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveImageFromUserInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveItemsFromOrderInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type RemoveLawnScheduleFromSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['Int']['input'];
};

export type RemoveLeftFromSessionRelationInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveLocationFromSessionInput = {
  id: Scalars['ID']['input'];
  type: SessionLocationType;
};

export type RemoveMediaFromCustomizationInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type RemoveMediaFromExperienceFormatInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveMediaFromVenueReviewInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type RemoveMissionSetFromSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveMissionsFromMissionSetInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type RemovePosterFromExperienceFormatInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemovePosterFromExperienceInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveRightFromSessionRelationInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveSessionModifiersInput = {
  id: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type RemoveSessionRelationsInput = {
  id: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type RemoveSourceSessionFromSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveThumbnailFromExperienceInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type RemoveTimelineItem = {
  id: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type RemoveWorkspaceFromCustomizationInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export enum Role {
  ADMIN = 'ADMIN',
  BOOKING_USER = 'BOOKING_USER',
  CUSTOMER_SUCCESS_MANAGER = 'CUSTOMER_SUCCESS_MANAGER',
  EVENT_PRODUCER = 'EVENT_PRODUCER',
  HOST = 'HOST',
  PLANT = 'PLANT',
  SALESPERSON = 'SALESPERSON'
}

export type RoleFilterComparison = {
  contArr?: InputMaybe<Role>;
  eq?: InputMaybe<Role>;
  gt?: InputMaybe<Role>;
  gte?: InputMaybe<Role>;
  iLike?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Role>;
  lt?: InputMaybe<Role>;
  lte?: InputMaybe<Role>;
  neq?: InputMaybe<Role>;
  notILike?: InputMaybe<Role>;
  notIn?: InputMaybe<Array<Role>>;
  notLike?: InputMaybe<Role>;
  overlaps?: InputMaybe<Role>;
};

export type Session = {
  __typename?: 'Session';
  activityNotes?: Maybe<Scalars['String']['output']>;
  additionalBookingContacts: Array<User>;
  assignability: SessionAssignability;
  assignments: Array<SessionAssignment>;
  attendees: Scalars['Int']['output'];
  bookingContact?: Maybe<User>;
  city?: Maybe<Scalars['String']['output']>;
  complete: Scalars['Boolean']['output'];
  contact?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  createdDate: Scalars['JSDate']['output'];
  creationType: SessionCreationType;
  credits: Scalars['Int']['output'];
  diy: Scalars['Boolean']['output'];
  duration: Scalars['Int']['output'];
  emailRegexPattern?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['JSDate']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  expericene: Experience;
  experience?: Maybe<Experience>;
  files: Array<File>;
  freeReschedule: Scalars['Boolean']['output'];
  futureEventsDetails?: Maybe<Scalars['String']['output']>;
  gameZone?: Maybe<GameZone>;
  gameZoneDescription?: Maybe<Scalars['String']['output']>;
  gameZoneId?: Maybe<Scalars['ID']['output']>;
  group?: Maybe<SessionGroup>;
  hasBreadcrumbIntegration: Scalars['Boolean']['output'];
  hasGroup: Scalars['Boolean']['output'];
  hasGroupDetails: Scalars['Boolean']['output'];
  hasUpgrade: Scalars['Boolean']['output'];
  hostType: HostType;
  hosts: Array<SessionAssignment>;
  hybrid: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  instructions: Array<Instruction>;
  integrations: Array<SessionIntegration>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  irl: Scalars['Boolean']['output'];
  isApprovable: Scalars['Boolean']['output'];
  isCustomizable: Scalars['Boolean']['output'];
  isEscapeRoom: Scalars['Boolean']['output'];
  isLobbyEligible: Scalars['Boolean']['output'];
  isMysteryExpress: Scalars['Boolean']['output'];
  isTravelable: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lawnSchedule?: Maybe<LawnSchedule>;
  links: Scalars['SessionLinks']['output'];
  lobby: Scalars['Boolean']['output'];
  locateable: Scalars['Boolean']['output'];
  locationDetails?: Maybe<Scalars['String']['output']>;
  locations: Array<SessionLocation>;
  meta: SessionMeta;
  missionSet?: Maybe<MissionSet>;
  modifications: Array<Scalars['ID']['output']>;
  modifiers: Array<Modifier>;
  name: Scalars['String']['output'];
  onScreen: Scalars['Boolean']['output'];
  packageLevel: PackageLevel;
  pastEventsDetails?: Maybe<Scalars['String']['output']>;
  pdfType?: Maybe<PdfType>;
  playType?: Maybe<PlayType>;
  preview?: Maybe<Scalars['String']['output']>;
  priceZone?: Maybe<Credit>;
  producer?: Maybe<User>;
  producers: Array<User>;
  relations: Array<SessionRelation>;
  remote: Scalars['Boolean']['output'];
  restrictions: SessionRestrictions;
  scheduleOffset: Scalars['Int']['output'];
  scheduleStartDate?: Maybe<Scalars['JSDate']['output']>;
  scheduleStartsAt?: Maybe<Scalars['DateTime']['output']>;
  scheduled: Scalars['Boolean']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  social?: Maybe<Scalars['Boolean']['output']>;
  sourceSession?: Maybe<Session>;
  startDate?: Maybe<Scalars['JSDate']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: SessionStatus;
  supportsGameZone: Scalars['Boolean']['output'];
  supportsPrizes: Scalars['Boolean']['output'];
  supportsSlots: SupportsSlots;
  supportsUpgrade: SessionSupportsUpgrade;
  syncType: SyncType;
  teams: Scalars['Int']['output'];
  templateId?: Maybe<Scalars['ID']['output']>;
  timeline: Timeline;
  timezone: Scalars['String']['output'];
  type: SessionType;
  upcoming: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vas: Scalars['Boolean']['output'];
  venue?: Maybe<SessionVenueContacts>;
  workspace: Workspace;
  workspaceId: Scalars['ID']['output'];
  wrapUpEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SessionAdditionalBookingContactsArgs = {
  filter?: UserFilter;
  sorting?: Array<UserSort>;
};


export type SessionAssignmentsArgs = {
  filter?: SessionAssignmentFilter;
  sorting?: Array<SessionAssignmentSort>;
};


export type SessionFilesArgs = {
  filter?: FileFilter;
  sorting?: Array<FileSort>;
};


export type SessionIntegrationsArgs = {
  filter?: SessionIntegrationFilter;
  sorting?: Array<SessionIntegrationSort>;
};


export type SessionLocationsArgs = {
  filter?: SessionLocationFilter;
  sorting?: Array<SessionLocationSort>;
};


export type SessionModifiersArgs = {
  filter?: ModifierFilter;
  sorting?: Array<ModifierSort>;
};


export type SessionRelationsArgs = {
  filter?: SessionRelationFilter;
  sorting?: Array<SessionRelationSort>;
};

export type SessionAggregateGroupBy = {
  __typename?: 'SessionAggregateGroupBy';
  diy?: Maybe<Scalars['Boolean']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  hasGroupDetails?: Maybe<Scalars['Boolean']['output']>;
  hostType?: Maybe<HostType>;
  id?: Maybe<Scalars['ID']['output']>;
  isCustomizable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packageLevel?: Maybe<PackageLevel>;
  scheduleStartsAt?: Maybe<Scalars['DateTime']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SessionStatus>;
  type?: Maybe<SessionType>;
  vas?: Maybe<Scalars['Boolean']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export enum SessionAssignability {
  ASSIGNABLE = 'ASSIGNABLE',
  NOT_ASSIGNABLE = 'NOT_ASSIGNABLE',
  ONLY_HOSTS = 'ONLY_HOSTS',
  ONLY_PRODUCER = 'ONLY_PRODUCER'
}

export type SessionAssignment = {
  __typename?: 'SessionAssignment';
  approval?: Maybe<AssignmentApproval>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  role: SessionRole;
  session: Session;
  travel?: Maybe<Scalars['DateTimeRange']['output']>;
  travelConfirmed?: Maybe<Scalars['Boolean']['output']>;
  type: AssignmentType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SessionAssignmentAggregateGroupBy = {
  __typename?: 'SessionAssignmentAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<SessionRole>;
  travel?: Maybe<Scalars['DateTimeRange']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SessionAssignmentAvgAggregate = {
  __typename?: 'SessionAssignmentAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

export type SessionAssignmentConnection = {
  __typename?: 'SessionAssignmentConnection';
  /** Array of nodes. */
  nodes: Array<SessionAssignment>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type SessionAssignmentCountAggregate = {
  __typename?: 'SessionAssignmentCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  travel?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type SessionAssignmentFilter = {
  and?: InputMaybe<Array<SessionAssignmentFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SessionAssignmentFilter>>;
  order?: InputMaybe<IntFieldComparison>;
  rating?: InputMaybe<IntFieldComparison>;
  role?: InputMaybe<SessionRoleFilterComparison>;
  session?: InputMaybe<SessionAssignmentFilterSessionFilter>;
  travel?: InputMaybe<SessionAssignmentTravelFilterComparison>;
  userId?: InputMaybe<IdFilterComparison>;
};

export type SessionAssignmentFilterSessionFilter = {
  and?: InputMaybe<Array<SessionAssignmentFilterSessionFilter>>;
  diy?: InputMaybe<BooleanFieldComparison>;
  endsAt?: InputMaybe<DateFieldComparison>;
  hasGroupDetails?: InputMaybe<BooleanFieldComparison>;
  hostType?: InputMaybe<HostTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isCustomizable?: InputMaybe<SessionIsCustomizableFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionAssignmentFilterSessionFilter>>;
  packageLevel?: InputMaybe<PackageLevelFilterComparison>;
  scheduleStartsAt?: InputMaybe<DateFieldComparison>;
  shortName?: InputMaybe<StringFieldComparison>;
  startsAt?: InputMaybe<DateFieldComparison>;
  status?: InputMaybe<SessionStatusFilterComparison>;
  type?: InputMaybe<SessionTypeFilterComparison>;
  vas?: InputMaybe<BooleanFieldComparison>;
  workspaceId?: InputMaybe<SessionWorkspaceIdFilterComparison>;
};

export type SessionAssignmentMaxAggregate = {
  __typename?: 'SessionAssignmentMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<SessionRole>;
  travel?: Maybe<Scalars['DateTimeRange']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SessionAssignmentMinAggregate = {
  __typename?: 'SessionAssignmentMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<SessionRole>;
  travel?: Maybe<Scalars['DateTimeRange']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type SessionAssignmentSort = {
  direction: SortDirection;
  field: SessionAssignmentSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SessionAssignmentSortFields {
  ID = 'id',
  ORDER = 'order',
  RATING = 'rating',
  ROLE = 'role',
  TRAVEL = 'travel',
  USER_ID = 'userId'
}

export type SessionAssignmentSumAggregate = {
  __typename?: 'SessionAssignmentSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

export type SessionAssignmentTravelFilterComparison = {
  overlaps?: InputMaybe<Scalars['DateTimeRange']['input']>;
};

export type SessionAvgAggregate = {
  __typename?: 'SessionAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  workspaceId?: Maybe<Scalars['Float']['output']>;
};

export type SessionConnection = {
  __typename?: 'SessionConnection';
  /** Array of nodes. */
  nodes: Array<Session>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type SessionCountAggregate = {
  __typename?: 'SessionCountAggregate';
  diy?: Maybe<Scalars['Int']['output']>;
  endsAt?: Maybe<Scalars['Int']['output']>;
  hasGroupDetails?: Maybe<Scalars['Int']['output']>;
  hostType?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isCustomizable?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  packageLevel?: Maybe<Scalars['Int']['output']>;
  scheduleStartsAt?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['Int']['output']>;
  startsAt?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  vas?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export enum SessionCreationType {
  HUBSPOT = 'Hubspot',
  MANUAL = 'Manual'
}

export type SessionDeleteResponse = {
  __typename?: 'SessionDeleteResponse';
  activityNotes?: Maybe<Scalars['String']['output']>;
  attendees?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationType?: Maybe<SessionCreationType>;
  credits?: Maybe<Scalars['Int']['output']>;
  diy?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  emailRegexPattern?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  expericene?: Maybe<Experience>;
  freeReschedule?: Maybe<Scalars['Boolean']['output']>;
  futureEventsDetails?: Maybe<Scalars['String']['output']>;
  gameZoneDescription?: Maybe<Scalars['String']['output']>;
  gameZoneId?: Maybe<Scalars['ID']['output']>;
  hasGroupDetails?: Maybe<Scalars['Boolean']['output']>;
  hostType?: Maybe<HostType>;
  id?: Maybe<Scalars['ID']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  isCustomizable?: Maybe<Scalars['Boolean']['output']>;
  isEscapeRoom?: Maybe<Scalars['Boolean']['output']>;
  isMysteryExpress?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lobby?: Maybe<Scalars['Boolean']['output']>;
  locateable?: Maybe<Scalars['Boolean']['output']>;
  locationDetails?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<SessionMeta>;
  name?: Maybe<Scalars['String']['output']>;
  packageLevel?: Maybe<PackageLevel>;
  pastEventsDetails?: Maybe<Scalars['String']['output']>;
  pdfType?: Maybe<PdfType>;
  playType?: Maybe<PlayType>;
  preview?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<SessionRestrictions>;
  scheduleOffset?: Maybe<Scalars['Int']['output']>;
  scheduleStartsAt?: Maybe<Scalars['DateTime']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  social?: Maybe<Scalars['Boolean']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SessionStatus>;
  syncType?: Maybe<SyncType>;
  teams?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
  timeline?: Maybe<Timeline>;
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SessionType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vas?: Maybe<Scalars['Boolean']['output']>;
  venue?: Maybe<SessionVenueContacts>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
  wrapUpEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SessionDocument {
  IRL_ADMIN_INSTRUCTIONS = 'IRL_ADMIN_INSTRUCTIONS',
  IRL_LOGIN_INSTRUCTIONS = 'IRL_LOGIN_INSTRUCTIONS',
  IRL_LOGIN_INSTRUCTIONS_NO_CODE = 'IRL_LOGIN_INSTRUCTIONS_NO_CODE',
  IRL_LOGIN_INSTRUCTIONS_NO_QR = 'IRL_LOGIN_INSTRUCTIONS_NO_QR',
  IRL_TALKING_POINTS = 'IRL_TALKING_POINTS'
}

export type SessionFilter = {
  and?: InputMaybe<Array<SessionFilter>>;
  assignments?: InputMaybe<SessionFilterSessionAssignmentFilter>;
  bookingContact?: InputMaybe<SessionFilterUserFilter>;
  contact?: InputMaybe<SessionFilterUserFilter>;
  diy?: InputMaybe<BooleanFieldComparison>;
  endsAt?: InputMaybe<DateFieldComparison>;
  group?: InputMaybe<SessionFilterSessionGroupFilter>;
  hasGroupDetails?: InputMaybe<BooleanFieldComparison>;
  hostType?: InputMaybe<HostTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  integrations?: InputMaybe<SessionFilterSessionIntegrationFilter>;
  isCustomizable?: InputMaybe<SessionIsCustomizableFilterComparison>;
  missionSet?: InputMaybe<SessionFilterMissionSetFilter>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionFilter>>;
  packageLevel?: InputMaybe<PackageLevelFilterComparison>;
  scheduleStartsAt?: InputMaybe<DateFieldComparison>;
  shortName?: InputMaybe<StringFieldComparison>;
  startsAt?: InputMaybe<DateFieldComparison>;
  status?: InputMaybe<SessionStatusFilterComparison>;
  type?: InputMaybe<SessionTypeFilterComparison>;
  vas?: InputMaybe<BooleanFieldComparison>;
  workspace?: InputMaybe<SessionFilterWorkspaceFilter>;
  workspaceId?: InputMaybe<SessionWorkspaceIdFilterComparison>;
};

export type SessionFilterMissionSetFilter = {
  and?: InputMaybe<Array<SessionFilterMissionSetFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionFilterMissionSetFilter>>;
  workspaceId?: InputMaybe<IdFilterComparison>;
};

export type SessionFilterSessionAssignmentFilter = {
  and?: InputMaybe<Array<SessionFilterSessionAssignmentFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SessionFilterSessionAssignmentFilter>>;
  order?: InputMaybe<IntFieldComparison>;
  rating?: InputMaybe<IntFieldComparison>;
  role?: InputMaybe<SessionRoleFilterComparison>;
  travel?: InputMaybe<SessionAssignmentTravelFilterComparison>;
  userId?: InputMaybe<IdFilterComparison>;
};

export type SessionFilterSessionGroupFilter = {
  and?: InputMaybe<Array<SessionFilterSessionGroupFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionFilterSessionGroupFilter>>;
  workspaceId?: InputMaybe<SessionGroupWorkspaceIdFilterComparison>;
};

export type SessionFilterSessionIntegrationFilter = {
  and?: InputMaybe<Array<SessionFilterSessionIntegrationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  integrationId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionFilterSessionIntegrationFilter>>;
  sessionId?: InputMaybe<SessionIntegrationSessionIdFilterComparison>;
  syncedAt?: InputMaybe<DateFieldComparison>;
  type?: InputMaybe<IntegrationTypeFilterComparison>;
};

export type SessionFilterUserFilter = {
  active?: InputMaybe<BooleanFieldComparison>;
  and?: InputMaybe<Array<SessionFilterUserFilter>>;
  anonymous?: InputMaybe<BooleanFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  fullName?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastAssignedAt?: InputMaybe<DateFieldComparison>;
  level?: InputMaybe<IntFieldComparison>;
  or?: InputMaybe<Array<SessionFilterUserFilter>>;
  role?: InputMaybe<RoleFilterComparison>;
  unsubscribed?: InputMaybe<BooleanFieldComparison>;
};

export type SessionFilterWorkspaceFilter = {
  and?: InputMaybe<Array<SessionFilterWorkspaceFilter>>;
  id?: InputMaybe<WorkspaceIdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionFilterWorkspaceFilter>>;
  preferredEventProducerId?: InputMaybe<IdFilterComparison>;
  preferredSalesId?: InputMaybe<IdFilterComparison>;
};

export type SessionGroup = {
  __typename?: 'SessionGroup';
  attendees: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  experience?: Maybe<Experience>;
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  name: Scalars['String']['output'];
  sessions: Array<Session>;
  updatedAt: Scalars['DateTime']['output'];
  workspace: Workspace;
  workspaceId: Scalars['ID']['output'];
};


export type SessionGroupSessionsArgs = {
  filter?: SessionFilter;
  sorting?: Array<SessionSort>;
};

export type SessionGroupAggregateGroupBy = {
  __typename?: 'SessionGroupAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type SessionGroupAvgAggregate = {
  __typename?: 'SessionGroupAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type SessionGroupConnection = {
  __typename?: 'SessionGroupConnection';
  /** Array of nodes. */
  nodes: Array<SessionGroup>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type SessionGroupCountAggregate = {
  __typename?: 'SessionGroupCountAggregate';
  createdAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type SessionGroupDetails = {
  __typename?: 'SessionGroupDetails';
  age?: Maybe<Scalars['String']['output']>;
  alcohol?: Maybe<Scalars['String']['output']>;
  attendeesDetails?: Maybe<Scalars['String']['output']>;
  av?: Maybe<Array<Scalars['String']['output']>>;
  avDetails?: Maybe<Scalars['String']['output']>;
  bar?: Maybe<Scalars['String']['output']>;
  departments?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventDetails?: Maybe<Scalars['String']['output']>;
  familiar?: Maybe<Scalars['String']['output']>;
  food?: Maybe<Scalars['String']['output']>;
  hasNextEvent?: Maybe<Scalars['String']['output']>;
  hasPreviousEvent?: Maybe<Scalars['String']['output']>;
  mobility?: Maybe<Scalars['String']['output']>;
  /** Yes, No */
  multiSession?: Maybe<Scalars['String']['output']>;
  multicultural?: Maybe<Scalars['String']['output']>;
  nextEventUrl?: Maybe<Scalars['String']['output']>;
  /** Virtual, In-Person, Both, No, N/A */
  playedPreviously?: Maybe<Scalars['String']['output']>;
  previousEventDetails?: Maybe<Scalars['String']['output']>;
  /** Go Game, Client */
  prizesOrigin?: Maybe<Scalars['String']['output']>;
  prizesShippingAddress?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  sameLocation?: Maybe<Scalars['String']['output']>;
  teamsDetails?: Maybe<Scalars['String']['output']>;
  teamsOrigin?: Maybe<Scalars['String']['output']>;
  young?: Maybe<Scalars['String']['output']>;
};

export type SessionGroupDetailsInput = {
  age?: InputMaybe<Scalars['String']['input']>;
  alcohol?: InputMaybe<Scalars['String']['input']>;
  attendeesDetails?: InputMaybe<Scalars['String']['input']>;
  av?: InputMaybe<Array<Scalars['String']['input']>>;
  avDetails?: InputMaybe<Scalars['String']['input']>;
  bar?: InputMaybe<Scalars['String']['input']>;
  departments?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventDetails?: InputMaybe<Scalars['String']['input']>;
  familiar?: InputMaybe<Scalars['String']['input']>;
  food?: InputMaybe<Scalars['String']['input']>;
  hasNextEvent?: InputMaybe<Scalars['String']['input']>;
  hasPreviousEvent?: InputMaybe<Scalars['String']['input']>;
  mobility?: InputMaybe<Scalars['String']['input']>;
  /** Yes, No */
  multiSession?: InputMaybe<Scalars['String']['input']>;
  multicultural?: InputMaybe<Scalars['String']['input']>;
  nextEventUrl?: InputMaybe<Scalars['String']['input']>;
  /** Virtual, In-Person, Both, No, N/A */
  playedPreviously?: InputMaybe<Scalars['String']['input']>;
  previousEventDetails?: InputMaybe<Scalars['String']['input']>;
  /** Go Game, Client */
  prizesOrigin?: InputMaybe<Scalars['String']['input']>;
  prizesShippingAddress?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  sameLocation?: InputMaybe<Scalars['String']['input']>;
  teamsDetails?: InputMaybe<Scalars['String']['input']>;
  teamsOrigin?: InputMaybe<Scalars['String']['input']>;
  young?: InputMaybe<Scalars['String']['input']>;
};

export type SessionGroupFilter = {
  and?: InputMaybe<Array<SessionGroupFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionGroupFilter>>;
  sessions?: InputMaybe<SessionGroupFilterSessionFilter>;
  workspace?: InputMaybe<SessionGroupFilterWorkspaceFilter>;
  workspaceId?: InputMaybe<SessionGroupWorkspaceIdFilterComparison>;
};

export type SessionGroupFilterSessionFilter = {
  and?: InputMaybe<Array<SessionGroupFilterSessionFilter>>;
  diy?: InputMaybe<BooleanFieldComparison>;
  endsAt?: InputMaybe<DateFieldComparison>;
  hasGroupDetails?: InputMaybe<BooleanFieldComparison>;
  hostType?: InputMaybe<HostTypeFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isCustomizable?: InputMaybe<SessionIsCustomizableFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionGroupFilterSessionFilter>>;
  packageLevel?: InputMaybe<PackageLevelFilterComparison>;
  scheduleStartsAt?: InputMaybe<DateFieldComparison>;
  shortName?: InputMaybe<StringFieldComparison>;
  startsAt?: InputMaybe<DateFieldComparison>;
  status?: InputMaybe<SessionStatusFilterComparison>;
  type?: InputMaybe<SessionTypeFilterComparison>;
  vas?: InputMaybe<BooleanFieldComparison>;
  workspaceId?: InputMaybe<SessionWorkspaceIdFilterComparison>;
};

export type SessionGroupFilterWorkspaceFilter = {
  and?: InputMaybe<Array<SessionGroupFilterWorkspaceFilter>>;
  id?: InputMaybe<WorkspaceIdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionGroupFilterWorkspaceFilter>>;
  preferredEventProducerId?: InputMaybe<IdFilterComparison>;
  preferredSalesId?: InputMaybe<IdFilterComparison>;
};

export type SessionGroupMaxAggregate = {
  __typename?: 'SessionGroupMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type SessionGroupMinAggregate = {
  __typename?: 'SessionGroupMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type SessionGroupSort = {
  direction: SortDirection;
  field: SessionGroupSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SessionGroupSortFields {
  CREATED_AT = 'createdAt',
  ID = 'id',
  NAME = 'name',
  WORKSPACE_ID = 'workspaceId'
}

export type SessionGroupSumAggregate = {
  __typename?: 'SessionGroupSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type SessionGroupWorkspaceIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SessionIntegration = {
  __typename?: 'SessionIntegration';
  active: Scalars['Boolean']['output'];
  attributes: SessionIntegrationAttributes;
  id: Scalars['ID']['output'];
  integrationId: Scalars['String']['output'];
  sessionId: Scalars['ID']['output'];
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  type: IntegrationType;
  url?: Maybe<Scalars['String']['output']>;
};

export type SessionIntegrationAggregateGroupBy = {
  __typename?: 'SessionIntegrationAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  integrationId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<IntegrationType>;
};

export type SessionIntegrationAttributes = {
  __typename?: 'SessionIntegrationAttributes';
  code?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
};

export type SessionIntegrationAttributesInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type SessionIntegrationAvgAggregate = {
  __typename?: 'SessionIntegrationAvgAggregate';
  sessionId?: Maybe<Scalars['Float']['output']>;
};

export type SessionIntegrationCountAggregate = {
  __typename?: 'SessionIntegrationCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  integrationId?: Maybe<Scalars['Int']['output']>;
  sessionId?: Maybe<Scalars['Int']['output']>;
  syncedAt?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type SessionIntegrationEdge = {
  __typename?: 'SessionIntegrationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SessionIntegration */
  node: SessionIntegration;
};

export type SessionIntegrationFilter = {
  and?: InputMaybe<Array<SessionIntegrationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  integrationId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionIntegrationFilter>>;
  sessionId?: InputMaybe<SessionIntegrationSessionIdFilterComparison>;
  syncedAt?: InputMaybe<DateFieldComparison>;
  type?: InputMaybe<IntegrationTypeFilterComparison>;
};

export type SessionIntegrationMaxAggregate = {
  __typename?: 'SessionIntegrationMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  integrationId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<IntegrationType>;
};

export type SessionIntegrationMinAggregate = {
  __typename?: 'SessionIntegrationMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  integrationId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<IntegrationType>;
};

export type SessionIntegrationSessionIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
};

export type SessionIntegrationSort = {
  direction: SortDirection;
  field: SessionIntegrationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SessionIntegrationSortFields {
  ID = 'id',
  INTEGRATION_ID = 'integrationId',
  SESSION_ID = 'sessionId',
  SYNCED_AT = 'syncedAt',
  TYPE = 'type'
}

export type SessionIntegrationSumAggregate = {
  __typename?: 'SessionIntegrationSumAggregate';
  sessionId?: Maybe<Scalars['Float']['output']>;
};

export type SessionIsCustomizableFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SessionLocation = {
  __typename?: 'SessionLocation';
  id: Scalars['ID']['output'];
  location: Location;
  type: SessionLocationType;
};

export type SessionLocationAggregateGroupBy = {
  __typename?: 'SessionLocationAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SessionLocationCountAggregate = {
  __typename?: 'SessionLocationCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type SessionLocationEdge = {
  __typename?: 'SessionLocationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SessionLocation */
  node: SessionLocation;
};

export type SessionLocationFilter = {
  and?: InputMaybe<Array<SessionLocationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  location?: InputMaybe<SessionLocationFilterLocationFilter>;
  or?: InputMaybe<Array<SessionLocationFilter>>;
};

export type SessionLocationFilterLocationFilter = {
  address?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<SessionLocationFilterLocationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SessionLocationFilterLocationFilter>>;
  placeId?: InputMaybe<IdFilterComparison>;
  point?: InputMaybe<PointFieldComparison>;
};

export type SessionLocationMaxAggregate = {
  __typename?: 'SessionLocationMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SessionLocationMinAggregate = {
  __typename?: 'SessionLocationMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SessionLocationSort = {
  direction: SortDirection;
  field: SessionLocationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SessionLocationSortFields {
  ID = 'id'
}

export enum SessionLocationType {
  END = 'END',
  START = 'START',
  VENUE = 'VENUE'
}

export type SessionMaxAggregate = {
  __typename?: 'SessionMaxAggregate';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  hostType?: Maybe<HostType>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packageLevel?: Maybe<PackageLevel>;
  scheduleStartsAt?: Maybe<Scalars['DateTime']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SessionStatus>;
  type?: Maybe<SessionType>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type SessionMeta = {
  __typename?: 'SessionMeta';
  actors?: Maybe<Scalars['Boolean']['output']>;
  attendees?: Maybe<Scalars['Boolean']['output']>;
  corporateActor?: Maybe<Scalars['Boolean']['output']>;
  gameControl?: Maybe<Scalars['Boolean']['output']>;
  group?: Maybe<SessionGroupDetails>;
  kitBased?: Maybe<Scalars['Boolean']['output']>;
  lodging?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Scalars['Boolean']['output']>;
  phoneSource?: Maybe<PhoneSource>;
  template?: Maybe<SessionTemplateType>;
  vas?: Maybe<Scalars['Boolean']['output']>;
};

export type SessionMetaInput = {
  actors?: InputMaybe<Scalars['Boolean']['input']>;
  attendees?: InputMaybe<Scalars['Boolean']['input']>;
  corporateActor?: InputMaybe<Scalars['Boolean']['input']>;
  gameControl?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<SessionGroupDetailsInput>;
  kitBased?: InputMaybe<Scalars['Boolean']['input']>;
  lodging?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSource?: InputMaybe<PhoneSource>;
  template?: InputMaybe<SessionTemplateType>;
  vas?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SessionMinAggregate = {
  __typename?: 'SessionMinAggregate';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  hostType?: Maybe<HostType>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packageLevel?: Maybe<PackageLevel>;
  scheduleStartsAt?: Maybe<Scalars['DateTime']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SessionStatus>;
  type?: Maybe<SessionType>;
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type SessionPhone = {
  __typename?: 'SessionPhone';
  hostType: HostType;
  id: Scalars['ID']['output'];
  packageLevel: PackageLevel;
  phone: Scalars['String']['output'];
  sessionType: SessionType;
};

export type SessionPhoneAggregateGroupBy = {
  __typename?: 'SessionPhoneAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SessionPhoneAvgAggregate = {
  __typename?: 'SessionPhoneAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type SessionPhoneConnection = {
  __typename?: 'SessionPhoneConnection';
  /** Array of nodes. */
  nodes: Array<SessionPhone>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type SessionPhoneCountAggregate = {
  __typename?: 'SessionPhoneCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
};

export type SessionPhoneDeleteResponse = {
  __typename?: 'SessionPhoneDeleteResponse';
  hostType?: Maybe<HostType>;
  id?: Maybe<Scalars['ID']['output']>;
  packageLevel?: Maybe<PackageLevel>;
  phone?: Maybe<Scalars['String']['output']>;
  sessionType?: Maybe<SessionType>;
};

export type SessionPhoneFilter = {
  and?: InputMaybe<Array<SessionPhoneFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SessionPhoneFilter>>;
};

export type SessionPhoneMaxAggregate = {
  __typename?: 'SessionPhoneMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SessionPhoneMinAggregate = {
  __typename?: 'SessionPhoneMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SessionPhoneSort = {
  direction: SortDirection;
  field: SessionPhoneSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SessionPhoneSortFields {
  ID = 'id'
}

export type SessionPhoneSumAggregate = {
  __typename?: 'SessionPhoneSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type SessionRelation = {
  __typename?: 'SessionRelation';
  id: Scalars['ID']['output'];
  left: Session;
  right: Session;
  type: SessionRelationType;
};

export type SessionRelationAggregateGroupBy = {
  __typename?: 'SessionRelationAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<SessionRelationType>;
};

export type SessionRelationCountAggregate = {
  __typename?: 'SessionRelationCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type SessionRelationEdge = {
  __typename?: 'SessionRelationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SessionRelation */
  node: SessionRelation;
};

export type SessionRelationFilter = {
  and?: InputMaybe<Array<SessionRelationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<SessionRelationFilter>>;
  type?: InputMaybe<SessionRelationTypeFilterComparison>;
};

export type SessionRelationInput = {
  id: Scalars['ID']['input'];
  type: SessionRelationType;
};

export type SessionRelationMaxAggregate = {
  __typename?: 'SessionRelationMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<SessionRelationType>;
};

export type SessionRelationMinAggregate = {
  __typename?: 'SessionRelationMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<SessionRelationType>;
};

export type SessionRelationSort = {
  direction: SortDirection;
  field: SessionRelationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SessionRelationSortFields {
  ID = 'id',
  TYPE = 'type'
}

export enum SessionRelationType {
  FUTURE = 'FUTURE',
  PAST = 'PAST'
}

export type SessionRelationTypeFilterComparison = {
  eq?: InputMaybe<SessionRelationType>;
};

export type SessionRestrictions = {
  __typename?: 'SessionRestrictions';
  attendees: Scalars['Int']['output'];
};

export enum SessionRole {
  HOST = 'HOST',
  PLANT = 'PLANT',
  PRODUCER = 'PRODUCER',
  SALESPERSON = 'SALESPERSON',
  SUPPORTING_PRODUCER = 'SUPPORTING_PRODUCER'
}

export type SessionRoleFilterComparison = {
  contArr?: InputMaybe<SessionRole>;
  eq?: InputMaybe<SessionRole>;
  gt?: InputMaybe<SessionRole>;
  gte?: InputMaybe<SessionRole>;
  iLike?: InputMaybe<SessionRole>;
  in?: InputMaybe<Array<SessionRole>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SessionRole>;
  lt?: InputMaybe<SessionRole>;
  lte?: InputMaybe<SessionRole>;
  neq?: InputMaybe<SessionRole>;
  notILike?: InputMaybe<SessionRole>;
  notIn?: InputMaybe<Array<SessionRole>>;
  notLike?: InputMaybe<SessionRole>;
  overlaps?: InputMaybe<SessionRole>;
};

export type SessionSort = {
  direction: SortDirection;
  field: SessionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SessionSortFields {
  DIY = 'diy',
  ENDS_AT = 'endsAt',
  HAS_GROUP_DETAILS = 'hasGroupDetails',
  HOST_TYPE = 'hostType',
  ID = 'id',
  IS_CUSTOMIZABLE = 'isCustomizable',
  NAME = 'name',
  PACKAGE_LEVEL = 'packageLevel',
  SCHEDULE_STARTS_AT = 'scheduleStartsAt',
  SHORT_NAME = 'shortName',
  STARTS_AT = 'startsAt',
  STATUS = 'status',
  TYPE = 'type',
  VAS = 'vas',
  WORKSPACE_ID = 'workspaceId'
}

export enum SessionStatus {
  EM_DETAILS_REQUIRED = 'EmDetailsRequired',
  GAME_READY = 'GameReady',
  HOST_NEEDED = 'HostNeeded',
  MANAGERS_NEEDED = 'ManagersNeeded',
  USER_DETAILS_REQUIRED = 'UserDetailsRequired'
}

export type SessionStatusFilterComparison = {
  contArr?: InputMaybe<SessionStatus>;
  eq?: InputMaybe<SessionStatus>;
  gt?: InputMaybe<SessionStatus>;
  gte?: InputMaybe<SessionStatus>;
  iLike?: InputMaybe<SessionStatus>;
  in?: InputMaybe<Array<SessionStatus>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SessionStatus>;
  lt?: InputMaybe<SessionStatus>;
  lte?: InputMaybe<SessionStatus>;
  neq?: InputMaybe<SessionStatus>;
  notILike?: InputMaybe<SessionStatus>;
  notIn?: InputMaybe<Array<SessionStatus>>;
  notLike?: InputMaybe<SessionStatus>;
  overlaps?: InputMaybe<SessionStatus>;
};

export type SessionSumAggregate = {
  __typename?: 'SessionSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  workspaceId?: Maybe<Scalars['Float']['output']>;
};

export type SessionSupportsUpgrade = {
  __typename?: 'SessionSupportsUpgrade';
  customer: SessionSupportsUpgradeDefinition;
  staff: SessionSupportsUpgradeDefinition;
};

export type SessionSupportsUpgradeDefinition = {
  __typename?: 'SessionSupportsUpgradeDefinition';
  reason?: Maybe<SessionUpgradeNotAlowedReason>;
  value: Scalars['Boolean']['output'];
};

export enum SessionTemplateType {
  CUSTOM = 'CUSTOM',
  LEGACY = 'LEGACY',
  MASTER = 'MASTER'
}

export enum SessionType {
  HYBRID = 'HYBRID',
  IN_PERSON = 'IN_PERSON',
  REMOTE = 'REMOTE'
}

export type SessionTypeFilterComparison = {
  contArr?: InputMaybe<SessionType>;
  eq?: InputMaybe<SessionType>;
  gt?: InputMaybe<SessionType>;
  gte?: InputMaybe<SessionType>;
  iLike?: InputMaybe<SessionType>;
  in?: InputMaybe<Array<SessionType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SessionType>;
  lt?: InputMaybe<SessionType>;
  lte?: InputMaybe<SessionType>;
  neq?: InputMaybe<SessionType>;
  notILike?: InputMaybe<SessionType>;
  notIn?: InputMaybe<Array<SessionType>>;
  notLike?: InputMaybe<SessionType>;
  overlaps?: InputMaybe<SessionType>;
};

export enum SessionUpgradeNotAlowedReason {
  NOT_ALLOWED_TYPE = 'NOT_ALLOWED_TYPE',
  STARTS_SOON = 'STARTS_SOON',
  UNSCHEDULED = 'UNSCHEDULED'
}

export type SessionVenueContacts = {
  __typename?: 'SessionVenueContacts';
  details?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SessionVenueContactsInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SessionWorkspaceIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SetAdditionalBookingContactsOnSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type SetAvailabilitiesOnUserInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type SetBookingContactOnSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetContactOnSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetCustomizationOnWorkspaceInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetFileOnCustomizationMediaInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetFilesOnSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type SetGroupOnSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetImageOnUserInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetItemsOnOrderInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type SetLawnScheduleOnSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['Int']['input'];
};

export type SetLeftOnSessionRelationInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetMediaOnCustomizationInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type SetMissionSetOnSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetMissionsOnMissionSetInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type SetRightOnSessionRelationInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetSourceSessionOnSessionInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

export type SetSystemInput = {
  key: SystemKey;
  value: Scalars['String']['input'];
};

export type SetTimelineInput = {
  items: Array<TimelineItemInput>;
  sessionId: Scalars['ID']['input'];
};

export type SetUserOnSessionAssignmentInput = {
  approval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  role: SessionRole;
  session: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export type SetWorkspaceOnCustomizationInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The id of relation. */
  relationId: Scalars['ID']['input'];
};

/** Sort Directions */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Sort Nulls Options */
export enum SortNulls {
  NULLS_FIRST = 'NULLS_FIRST',
  NULLS_LAST = 'NULLS_LAST'
}

export type Sorting = {
  field?: InputMaybe<Scalars['String']['input']>;
};

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notILike?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  attributes: Scalars['JSON']['output'];
  consumables: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  endsAt: Scalars['DateTime']['output'];
  frequency: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastPaidAmount: Scalars['Float']['output'];
  lastPaidDate: Scalars['DateTime']['output'];
  renewAt: Scalars['DateTime']['output'];
  source: CreationSource;
  sourceId: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  status: SubscriptionStatus;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['Int']['output'];
};

export type SubscriptionPlanAggregateGroupBy = {
  __typename?: 'SubscriptionPlanAggregateGroupBy';
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<SubscriptionStatus>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPlanAvgAggregate = {
  __typename?: 'SubscriptionPlanAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  workspaceId?: Maybe<Scalars['Float']['output']>;
};

export type SubscriptionPlanConnection = {
  __typename?: 'SubscriptionPlanConnection';
  /** Array of edges. */
  edges: Array<SubscriptionPlanEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type SubscriptionPlanCountAggregate = {
  __typename?: 'SubscriptionPlanCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPlanDeleteFilter = {
  and?: InputMaybe<Array<SubscriptionPlanDeleteFilter>>;
  id?: InputMaybe<IntFieldComparison>;
  or?: InputMaybe<Array<SubscriptionPlanDeleteFilter>>;
  status?: InputMaybe<SubscriptionStatusFilterComparison>;
  workspaceId?: InputMaybe<SubscriptionPlanWorkspaceIdFilterComparison>;
};

export type SubscriptionPlanDeleteResponse = {
  __typename?: 'SubscriptionPlanDeleteResponse';
  attributes?: Maybe<Scalars['JSON']['output']>;
  consumables?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastPaidAmount?: Maybe<Scalars['Float']['output']>;
  lastPaidDate?: Maybe<Scalars['DateTime']['output']>;
  renewAt?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<CreationSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<SubscriptionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPlanEdge = {
  __typename?: 'SubscriptionPlanEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SubscriptionPlan */
  node: SubscriptionPlan;
};

export type SubscriptionPlanFilter = {
  and?: InputMaybe<Array<SubscriptionPlanFilter>>;
  id?: InputMaybe<IntFieldComparison>;
  or?: InputMaybe<Array<SubscriptionPlanFilter>>;
  status?: InputMaybe<SubscriptionStatusFilterComparison>;
  workspaceId?: InputMaybe<SubscriptionPlanWorkspaceIdFilterComparison>;
};

export type SubscriptionPlanMaxAggregate = {
  __typename?: 'SubscriptionPlanMaxAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<SubscriptionStatus>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPlanMinAggregate = {
  __typename?: 'SubscriptionPlanMinAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<SubscriptionStatus>;
  workspaceId?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPlanSort = {
  direction: SortDirection;
  field: SubscriptionPlanSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum SubscriptionPlanSortFields {
  ID = 'id',
  STATUS = 'status',
  WORKSPACE_ID = 'workspaceId'
}

export type SubscriptionPlanSumAggregate = {
  __typename?: 'SubscriptionPlanSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  workspaceId?: Maybe<Scalars['Float']['output']>;
};

export type SubscriptionPlanUpdateFilter = {
  and?: InputMaybe<Array<SubscriptionPlanUpdateFilter>>;
  id?: InputMaybe<IntFieldComparison>;
  or?: InputMaybe<Array<SubscriptionPlanUpdateFilter>>;
  status?: InputMaybe<SubscriptionStatusFilterComparison>;
  workspaceId?: InputMaybe<SubscriptionPlanWorkspaceIdFilterComparison>;
};

export type SubscriptionPlanWorkspaceIdFilterComparison = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type SubscriptionStatusFilterComparison = {
  contArr?: InputMaybe<SubscriptionStatus>;
  eq?: InputMaybe<SubscriptionStatus>;
  gt?: InputMaybe<SubscriptionStatus>;
  gte?: InputMaybe<SubscriptionStatus>;
  iLike?: InputMaybe<SubscriptionStatus>;
  in?: InputMaybe<Array<SubscriptionStatus>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<SubscriptionStatus>;
  lt?: InputMaybe<SubscriptionStatus>;
  lte?: InputMaybe<SubscriptionStatus>;
  neq?: InputMaybe<SubscriptionStatus>;
  notILike?: InputMaybe<SubscriptionStatus>;
  notIn?: InputMaybe<Array<SubscriptionStatus>>;
  notLike?: InputMaybe<SubscriptionStatus>;
  overlaps?: InputMaybe<SubscriptionStatus>;
};

export type SupportsSlots = {
  __typename?: 'SupportsSlots';
  customer: Scalars['Boolean']['output'];
  staff: Scalars['Boolean']['output'];
};

export enum SyncType {
  BC2 = 'BC2',
  BREADCRUMB = 'BREADCRUMB',
  PLAY = 'PLAY',
  THIRD_PARTY = 'THIRD_PARTY',
  VAS = 'VAS',
  VAS_PLAY = 'VAS_PLAY',
  WEVE_MULTI_ROUND = 'WEVE_MULTI_ROUND',
  WEVE_STANDARD = 'WEVE_STANDARD'
}

export type System = {
  __typename?: 'System';
  createdAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export enum SystemKey {
  IRL_HYBRID_ASSIGNMENTS = 'IRL_HYBRID_ASSIGNMENTS',
  OPEN_WEVE_TEMPLATE_ID = 'OPEN_WEVE_TEMPLATE_ID',
  PLAY_DEMO_EXPERIENCE_ID = 'PLAY_DEMO_EXPERIENCE_ID',
  PLAY_DEMO_WORKSPACE_ID = 'PLAY_DEMO_WORKSPACE_ID',
  PREFERRED_EVENT_PRODUCER_ID = 'PREFERRED_EVENT_PRODUCER_ID',
  QUICKBOOKS_SECRET = 'QUICKBOOKS_SECRET',
  TAGS = 'TAGS',
  VAS_EXPERIENCE_ID = 'VAS_EXPERIENCE_ID',
  VAS_WORKSPACE_ID = 'VAS_WORKSPACE_ID'
}

export type Template = {
  __typename?: 'Template';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  /** Array of nodes. */
  nodes: Array<Template>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type TemplateFilter = {
  exclude?: InputMaybe<Scalars['String']['input']>;
  lobby?: InputMaybe<Scalars['Boolean']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Timeline = {
  __typename?: 'Timeline';
  items?: Maybe<Array<TimelineItem>>;
  outdated?: Maybe<Scalars['Boolean']['output']>;
};

export type TimelineItem = {
  __typename?: 'TimelineItem';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  time: Scalars['String']['output'];
};

export type TimelineItemInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  time: Scalars['String']['input'];
};

export type Tournament = {
  __typename?: 'Tournament';
  break?: Maybe<TournamentBreak>;
  rounds: Array<TournamentRound>;
};

export type TournamentBreak = {
  __typename?: 'TournamentBreak';
  afterRound: Scalars['Int']['output'];
  endsAt: Scalars['DateTime']['output'];
  startsAt: Scalars['DateTime']['output'];
};

export type TournamentRound = {
  __typename?: 'TournamentRound';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  round: Scalars['Int']['output'];
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  teams?: Maybe<Array<Array<Scalars['String']['output']>>>;
};

export type UpdateAiPrompt = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<OpenAiModel>;
  name?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAvailabilityInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCustomization = {
  colors?: InputMaybe<CustomizationColorsInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCustomizationMedia = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CustomizationMediaType>;
};

export type UpdateExperienceInput = {
  attributes?: InputMaybe<ExperienceAttributesInput>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<ExperienceCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  overview?: InputMaybe<ExperienceOverviewInput>;
  position?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<ExperienceStatus>;
  subscribers?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tier?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ExperienceType>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFile = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MediaType>;
};

export type UpdateGalleryPasswordInput = {
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};

export type UpdateGameControl = {
  gameControl: Scalars['Boolean']['input'];
  sessionId: Scalars['ID']['input'];
};

export type UpdateHostTypeInput = {
  hostType: HostType;
  id: Scalars['ID']['input'];
};

export type UpdateInstruction = {
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<SessionDocument>;
  hosts?: InputMaybe<Array<HostType>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PdfType>;
};

export type UpdateLawnScheduleInput = {
  break: Scalars['Boolean']['input'];
  breakDuration: Scalars['Int']['input'];
  endOffset: Scalars['Int']['input'];
  list: Scalars['String']['input'];
  missions: Array<BreadcrumbMissionInput>;
  roundBreakDuration: Scalars['Int']['input'];
  startOffset: Scalars['Int']['input'];
};

export type UpdateManyCustomizationMediasInput = {
  /** Filter used to find fields to update */
  filter: CustomizationMediaUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateCustomizationMedia;
};

export type UpdateManyFilesInput = {
  /** Filter used to find fields to update */
  filter: FileUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateFile;
};

export type UpdateManyResponse = {
  __typename?: 'UpdateManyResponse';
  /** The number of records updated. */
  updatedCount: Scalars['Int']['output'];
};

export type UpdateManySubscriptionPlansInput = {
  /** Filter used to find fields to update */
  filter: SubscriptionPlanUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateSubscriptionPlan;
};

export type UpdateMission = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<MissionOptionInput>>;
  position?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<MissionType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateMissionSet = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateModifier = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<ModifierRole>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateOneAiPromptInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateAiPrompt;
};

export type UpdateOneCustomizationInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateCustomization;
};

export type UpdateOneCustomizationMediaInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateCustomizationMedia;
};

export type UpdateOneExperienceFormatInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: ExperienceFormatUpdateInput;
};

export type UpdateOneExperienceInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateExperienceInput;
};

export type UpdateOneFileInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateFile;
};

export type UpdateOneInstructionInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateInstruction;
};

export type UpdateOneMissionInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateMission;
};

export type UpdateOneMissionSetInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateMissionSet;
};

export type UpdateOneModifierInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateModifier;
};

export type UpdateOnePriceModifierInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdatePriceModifier;
};

export type UpdateOneSessionPhoneInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateSessionPhone;
};

export type UpdateOneSubscriptionPlanInput = {
  /** The id of the record to update */
  id: Scalars['Int']['input'];
  /** The update to apply. */
  update: UpdateSubscriptionPlan;
};

export type UpdateOneVenueInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateVenueInput;
};

export type UpdateOneVenueReviewInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateVenueReviewInput;
};

export type UpdateOneZoneAreaInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateZoneArea;
};

export type UpdateOpenWeve = {
  description?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOpenWeveInput = {
  id: Scalars['ID']['input'];
  update: UpdateOpenWeve;
};

export type UpdateOrderItemInput = {
  quantity: Scalars['Int']['input'];
};

export type UpdatePermission = {
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePermissionInput = {
  id: Scalars['ID']['input'];
  update: UpdatePermission;
};

export type UpdatePriceModifier = {
  dateRange?: InputMaybe<Scalars['DateTimeRange']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  types?: InputMaybe<Array<SessionType>>;
};

export type UpdateSession = {
  activityNotes?: InputMaybe<Scalars['String']['input']>;
  attendees?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  emailRegexPattern?: InputMaybe<Scalars['String']['input']>;
  freeReschedule?: InputMaybe<Scalars['Boolean']['input']>;
  futureEventsDetails?: InputMaybe<Scalars['String']['input']>;
  gameZoneId?: InputMaybe<Scalars['ID']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lobby?: InputMaybe<Scalars['Boolean']['input']>;
  locationDetails?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<SessionMetaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pastEventsDetails?: InputMaybe<Scalars['String']['input']>;
  pdfType?: InputMaybe<PdfType>;
  playType?: InputMaybe<PlayType>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  venue?: InputMaybe<SessionVenueContactsInput>;
};

export type UpdateSessionAssignmentInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateSessionAssignmentUpdateInput;
};

export type UpdateSessionAssignmentTravelConfirmationStatusInput = {
  id: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
};

export type UpdateSessionAssignmentUpdateInput = {
  rating?: InputMaybe<Scalars['Int']['input']>;
  travel?: InputMaybe<Scalars['DateTimeRange']['input']>;
  travelTimeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSessionInput = {
  id: Scalars['ID']['input'];
  update: UpdateSession;
};

export type UpdateSessionPhone = {
  hostType?: InputMaybe<HostType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  packageLevel?: InputMaybe<PackageLevel>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sessionType?: InputMaybe<SessionType>;
};

export type UpdateSessionSyncTypeInput = {
  id: Scalars['ID']['input'];
  value: SyncType;
};

export type UpdateSessionTypeInput = {
  id: Scalars['ID']['input'];
  type: SessionType;
};

export type UpdateSubscriptionPlan = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  consumables?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastPaidAmount?: InputMaybe<Scalars['Float']['input']>;
  lastPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  renewAt?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<CreationSource>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SubscriptionStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUser = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<UserAttributesInput>;
  birthYear?: InputMaybe<Scalars['Int']['input']>;
  coordinates?: InputMaybe<Scalars['GeoJSONPointScalar']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  load?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationInput>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  modifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<UserPermission>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  upgrades?: InputMaybe<Array<PackageLevel>>;
  zoneAreaId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserAudioInput = {
  keypress?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overlay?: InputMaybe<Scalars['Boolean']['input']>;
  volume?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserInput = {
  id: Scalars['ID']['input'];
  update: UpdateUser;
};

export type UpdateVenueInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gameZoneId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  participantsMax?: InputMaybe<Scalars['Int']['input']>;
  participantsMin?: InputMaybe<Scalars['Int']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateVenueReviewInput = {
  media?: InputMaybe<Array<Scalars['ID']['input']>>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkspaceInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: WorkspaceUpdateInput;
};

export type UpdateWorkspaceStaffInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: WorkspaceUpdateStaffInput;
};

export type UpdateZoneArea = {
  area?: InputMaybe<Scalars['GeoJSONPolygonScalar']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  attributes: UserAttributes;
  availabilities: Array<Availability>;
  avatar?: Maybe<Scalars['String']['output']>;
  birthYear?: Maybe<Scalars['Int']['output']>;
  canHaveAvailability: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<File>;
  languages: Array<Scalars['String']['output']>;
  lastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  lastLoggedInAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  load?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Location>;
  meetingLink?: Maybe<Scalars['String']['output']>;
  modifiers: Array<Modifier>;
  notes?: Maybe<Scalars['String']['output']>;
  permission: UserPermission;
  permissions: Array<Permission>;
  phone?: Maybe<Scalars['String']['output']>;
  role: Role;
  timezone?: Maybe<Scalars['String']['output']>;
  unsubscribed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  upgrades: Array<PackageLevel>;
  workspace: Workspace;
  zoneAreaId?: Maybe<Scalars['ID']['output']>;
};


export type UserAvailabilitiesArgs = {
  filter?: AvailabilityFilter;
  sorting?: Array<AvailabilitySort>;
};


export type UserModifiersArgs = {
  filter?: ModifierFilter;
  sorting?: Array<ModifierSort>;
};


export type UserPermissionsArgs = {
  filter?: PermissionFilter;
  sorting?: Array<PermissionSort>;
};

export type UserAggregateGroupBy = {
  __typename?: 'UserAggregateGroupBy';
  active?: Maybe<Scalars['Boolean']['output']>;
  anonymous?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Role>;
  unsubscribed?: Maybe<Scalars['Boolean']['output']>;
};

export type UserAttributes = {
  __typename?: 'UserAttributes';
  email?: Maybe<Scalars['String']['output']>;
};

export type UserAttributesInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type UserAudio = {
  __typename?: 'UserAudio';
  file: File;
  id: Scalars['ID']['output'];
  keypress?: Maybe<Scalars['String']['output']>;
  overlay?: Maybe<Scalars['Boolean']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
};

export type UserAudioConnection = {
  __typename?: 'UserAudioConnection';
  nodes: Array<UserAudio>;
  pageInfo: OffsetPageInfo;
};

export type UserAvgAggregate = {
  __typename?: 'UserAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** Array of nodes. */
  nodes: Array<User>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  active?: Maybe<Scalars['Int']['output']>;
  anonymous?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastAssignedAt?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  unsubscribed?: Maybe<Scalars['Int']['output']>;
};

export type UserFilter = {
  active?: InputMaybe<BooleanFieldComparison>;
  and?: InputMaybe<Array<UserFilter>>;
  anonymous?: InputMaybe<BooleanFieldComparison>;
  availability?: InputMaybe<UserFilterAvailabilityFilter>;
  createdAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  fullName?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  lastAssignedAt?: InputMaybe<DateFieldComparison>;
  level?: InputMaybe<IntFieldComparison>;
  location?: InputMaybe<UserFilterLocationFilter>;
  modifiers?: InputMaybe<UserFilterModifierFilter>;
  or?: InputMaybe<Array<UserFilter>>;
  permissions?: InputMaybe<UserFilterPermissionFilter>;
  role?: InputMaybe<RoleFilterComparison>;
  unsubscribed?: InputMaybe<BooleanFieldComparison>;
};

export type UserFilterAvailabilityFilter = {
  and?: InputMaybe<Array<UserFilterAvailabilityFilter>>;
  enabled?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<UserFilterAvailabilityFilter>>;
};

export type UserFilterLocationFilter = {
  address?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<UserFilterLocationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<UserFilterLocationFilter>>;
  placeId?: InputMaybe<IdFilterComparison>;
  point?: InputMaybe<PointFieldComparison>;
};

export type UserFilterModifierFilter = {
  and?: InputMaybe<Array<UserFilterModifierFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  label?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<UserFilterModifierFilter>>;
  role?: InputMaybe<ModifierRoleFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type UserFilterPermissionFilter = {
  and?: InputMaybe<Array<UserFilterPermissionFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<UserFilterPermissionFilter>>;
  role?: InputMaybe<PermissionRoleFilterComparison>;
  userId?: InputMaybe<PermissionUserIdFilterComparison>;
  workspaceId?: InputMaybe<PermissionWorkspaceIdFilterComparison>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Role>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Role>;
};

export enum UserPermission {
  ADMIN = 'ADMIN',
  BOOKING_USER = 'BOOKING_USER',
  HOST = 'HOST',
  STAFF = 'STAFF'
}

export type UserSort = {
  direction: SortDirection;
  field: UserSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum UserSortFields {
  ACTIVE = 'active',
  ANONYMOUS = 'anonymous',
  CREATED_AT = 'createdAt',
  EMAIL = 'email',
  FULL_NAME = 'fullName',
  ID = 'id',
  LAST_ASSIGNED_AT = 'lastAssignedAt',
  LEVEL = 'level',
  ROLE = 'role',
  UNSUBSCRIBED = 'unsubscribed'
}

export type UserSumAggregate = {
  __typename?: 'UserSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<Scalars['Float']['output']>;
};

export type Venue = {
  __typename?: 'Venue';
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gameZone?: Maybe<GameZone>;
  gameZoneId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location: Location;
  nOfEvents: Scalars['Int']['output'];
  nOfReviews: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  participantsMax: Scalars['Int']['output'];
  participantsMin: Scalars['Int']['output'];
  private: Scalars['Boolean']['output'];
  rating: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type VenueAggregateGroupBy = {
  __typename?: 'VenueAggregateGroupBy';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gameZoneId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  mostRecent?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participantsMax?: Maybe<Scalars['Int']['output']>;
  participantsMin?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VenueAvgAggregate = {
  __typename?: 'VenueAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  participantsMax?: Maybe<Scalars['Float']['output']>;
  participantsMin?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type VenueConnection = {
  __typename?: 'VenueConnection';
  /** Array of nodes. */
  nodes: Array<Venue>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type VenueCountAggregate = {
  __typename?: 'VenueCountAggregate';
  city?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  gameZoneId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mostRecent?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  participantsMax?: Maybe<Scalars['Int']['output']>;
  participantsMin?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export type VenueDeleteResponse = {
  __typename?: 'VenueDeleteResponse';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gameZoneId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participantsMax?: Maybe<Scalars['Int']['output']>;
  participantsMin?: Maybe<Scalars['Int']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VenueFilter = {
  and?: InputMaybe<Array<VenueFilter>>;
  city?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  gameZoneId?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  location?: InputMaybe<VenueFilterLocationFilter>;
  mostRecent?: InputMaybe<VenueMostRecentFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<VenueFilter>>;
  participantsMax?: InputMaybe<VenueParticipantsMaxFilterComparison>;
  participantsMin?: InputMaybe<VenueParticipantsMinFilterComparison>;
  rating?: InputMaybe<VenueRatingFilterComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type VenueFilterLocationFilter = {
  address?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<VenueFilterLocationFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<VenueFilterLocationFilter>>;
  placeId?: InputMaybe<IdFilterComparison>;
  point?: InputMaybe<PointFieldComparison>;
};

export type VenueMaxAggregate = {
  __typename?: 'VenueMaxAggregate';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gameZoneId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participantsMax?: Maybe<Scalars['Int']['output']>;
  participantsMin?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VenueMinAggregate = {
  __typename?: 'VenueMinAggregate';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gameZoneId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participantsMax?: Maybe<Scalars['Int']['output']>;
  participantsMin?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VenueMostRecentFilterComparison = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueParticipantsMaxFilterComparison = {
  gte?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export type VenueParticipantsMinFilterComparison = {
  gte?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export type VenueRatingFilterComparison = {
  gte?: InputMaybe<Scalars['Float']['input']>;
};

export type VenueReview = {
  __typename?: 'VenueReview';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  media: Array<File>;
  rate: Scalars['Float']['output'];
  review: Scalars['String']['output'];
  session: Session;
  sessionId: Scalars['ID']['output'];
  venue: Venue;
  venueId: Scalars['ID']['output'];
};


export type VenueReviewMediaArgs = {
  filter?: FileFilter;
  sorting?: Array<FileSort>;
};

export type VenueReviewAggregateGroupBy = {
  __typename?: 'VenueReviewAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  venueId?: Maybe<Scalars['ID']['output']>;
};

export type VenueReviewAvgAggregate = {
  __typename?: 'VenueReviewAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  venueId?: Maybe<Scalars['Float']['output']>;
};

export type VenueReviewConnection = {
  __typename?: 'VenueReviewConnection';
  /** Array of nodes. */
  nodes: Array<VenueReview>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type VenueReviewCountAggregate = {
  __typename?: 'VenueReviewCountAggregate';
  createdAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type VenueReviewDeleteResponse = {
  __typename?: 'VenueReviewDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdById?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  venueId?: Maybe<Scalars['ID']['output']>;
};

export type VenueReviewFilter = {
  and?: InputMaybe<Array<VenueReviewFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<VenueReviewFilter>>;
  venueId?: InputMaybe<IdFilterComparison>;
};

export type VenueReviewMaxAggregate = {
  __typename?: 'VenueReviewMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  venueId?: Maybe<Scalars['ID']['output']>;
};

export type VenueReviewMinAggregate = {
  __typename?: 'VenueReviewMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  venueId?: Maybe<Scalars['ID']['output']>;
};

export type VenueReviewSort = {
  direction: SortDirection;
  field: VenueReviewSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum VenueReviewSortFields {
  CREATED_AT = 'createdAt',
  ID = 'id',
  VENUE_ID = 'venueId'
}

export type VenueReviewSumAggregate = {
  __typename?: 'VenueReviewSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  venueId?: Maybe<Scalars['Float']['output']>;
};

export type VenueSort = {
  direction: SortDirection;
  field: VenueSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum VenueSortFields {
  CITY = 'city',
  CREATED_AT = 'createdAt',
  GAME_ZONE_ID = 'gameZoneId',
  ID = 'id',
  MOST_RECENT = 'mostRecent',
  NAME = 'name',
  PARTICIPANTS_MAX = 'participantsMax',
  PARTICIPANTS_MIN = 'participantsMin',
  RATING = 'rating',
  UPDATED_AT = 'updatedAt'
}

export type VenueSumAggregate = {
  __typename?: 'VenueSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  participantsMax?: Maybe<Scalars['Float']['output']>;
  participantsMin?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type Within = {
  max: Array<Scalars['Float']['input']>;
  min: Array<Scalars['Float']['input']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  company?: Maybe<Scalars['String']['output']>;
  consumables: WorkspaceConsumables;
  content?: Maybe<Scalars['Boolean']['output']>;
  customization: Customization;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Scalars['Boolean']['output']>;
  preferredEventProducerId?: Maybe<Scalars['ID']['output']>;
  preferredSalesId?: Maybe<Scalars['ID']['output']>;
  sessions: WorkspaceSessionsConnection;
  settings: WorkspaceSettings;
  subscriber: Scalars['Boolean']['output'];
  subscriptions: WorkspaceSubscriptionsConnection;
};


export type WorkspaceSessionsArgs = {
  filter?: SessionFilter;
  paging?: OffsetPaging;
  sorting?: Array<SessionSort>;
};


export type WorkspaceSubscriptionsArgs = {
  filter?: SubscriptionPlanFilter;
  paging?: OffsetPaging;
  sorting?: Array<SubscriptionPlanSort>;
};

export type WorkspaceAggregateGroupBy = {
  __typename?: 'WorkspaceAggregateGroupBy';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preferredEventProducerId?: Maybe<Scalars['ID']['output']>;
  preferredSalesId?: Maybe<Scalars['ID']['output']>;
};

export type WorkspaceAvgAggregate = {
  __typename?: 'WorkspaceAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type WorkspaceConnection = {
  __typename?: 'WorkspaceConnection';
  /** Array of nodes. */
  nodes: Array<Workspace>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type WorkspaceConsumables = {
  __typename?: 'WorkspaceConsumables';
  credits: Scalars['Int']['output'];
  openWeves: Scalars['Int']['output'];
};

export type WorkspaceCountAggregate = {
  __typename?: 'WorkspaceCountAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  preferredEventProducerId?: Maybe<Scalars['Int']['output']>;
  preferredSalesId?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceFilter = {
  and?: InputMaybe<Array<WorkspaceFilter>>;
  id?: InputMaybe<WorkspaceIdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<WorkspaceFilter>>;
  preferredEventProducerId?: InputMaybe<IdFilterComparison>;
  preferredSalesId?: InputMaybe<IdFilterComparison>;
};

export type WorkspaceIdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WorkspaceMaxAggregate = {
  __typename?: 'WorkspaceMaxAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preferredEventProducerId?: Maybe<Scalars['ID']['output']>;
  preferredSalesId?: Maybe<Scalars['ID']['output']>;
};

export type WorkspaceMinAggregate = {
  __typename?: 'WorkspaceMinAggregate';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preferredEventProducerId?: Maybe<Scalars['ID']['output']>;
  preferredSalesId?: Maybe<Scalars['ID']['output']>;
};

export type WorkspaceSessionsConnection = {
  __typename?: 'WorkspaceSessionsConnection';
  /** Array of nodes. */
  nodes: Array<Session>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type WorkspaceSettings = {
  __typename?: 'WorkspaceSettings';
  missions?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceSettingsUpdateStaffInput = {
  missions?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkspaceSort = {
  direction: SortDirection;
  field: WorkspaceSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum WorkspaceSortFields {
  ID = 'id',
  NAME = 'name',
  PREFERRED_EVENT_PRODUCER_ID = 'preferredEventProducerId',
  PREFERRED_SALES_ID = 'preferredSalesId'
}

export type WorkspaceSubscriptionsConnection = {
  __typename?: 'WorkspaceSubscriptionsConnection';
  /** Array of nodes. */
  nodes: Array<SubscriptionPlan>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type WorkspaceSumAggregate = {
  __typename?: 'WorkspaceSumAggregate';
  id?: Maybe<Scalars['Float']['output']>;
};

export type WorkspaceUpdateInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkspaceUpdateStaffInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['Boolean']['input']>;
  preferredEventProducerId?: InputMaybe<Scalars['ID']['input']>;
  preferredSalesId?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<WorkspaceSettingsUpdateStaffInput>;
};

export type ZoneArea = {
  __typename?: 'ZoneArea';
  area: Scalars['GeoJSONPolygonScalar']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ZoneAreaAggregateGroupBy = {
  __typename?: 'ZoneAreaAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ZoneAreaConnection = {
  __typename?: 'ZoneAreaConnection';
  /** Array of nodes. */
  nodes: Array<ZoneArea>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type ZoneAreaCountAggregate = {
  __typename?: 'ZoneAreaCountAggregate';
  createdAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type ZoneAreaDeleteResponse = {
  __typename?: 'ZoneAreaDeleteResponse';
  area?: Maybe<Scalars['GeoJSONPolygonScalar']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ZoneAreaFilter = {
  and?: InputMaybe<Array<ZoneAreaFilter>>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ZoneAreaFilter>>;
};

export type ZoneAreaInput = {
  area: Scalars['GeoJSONPolygonScalar']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export type ZoneAreaMaxAggregate = {
  __typename?: 'ZoneAreaMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ZoneAreaMinAggregate = {
  __typename?: 'ZoneAreaMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ZoneAreaSort = {
  direction: SortDirection;
  field: ZoneAreaSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export enum ZoneAreaSortFields {
  CREATED_AT = 'createdAt',
  ID = 'id',
  NAME = 'name'
}

export type GetWorkspaceForEventsSearchDropdownQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkspaceForEventsSearchDropdownQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, sessions: { __typename?: 'WorkspaceSessionsConnection', totalCount: number } } | null };

export type WorkspaceForEventsSearchDropdownFragment = { __typename?: 'Workspace', id: string, sessions: { __typename?: 'WorkspaceSessionsConnection', totalCount: number } };

export type UserWithAvatarAndImageFragment = { __typename?: 'User', id: string, avatar?: string | null, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null };

export type DeleteOrderMutationVariables = Exact<{
  input: DeleteOrderInput;
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: { __typename?: 'Order', id: string } };

export type DeleteOrderItemsMutationVariables = Exact<{
  input: DeleteOrderItemsInput;
}>;


export type DeleteOrderItemsMutation = { __typename?: 'Mutation', deleteOrderItems: { __typename?: 'DeleteManyResponse', deletedCount: number } };

export type GetOrderForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrderForEditQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, consumables: Array<{ __typename?: 'AvailableConsumable', used: number, available: number, name: ConsumableName, orderItemId: string, ordered: number }> } | null };

export type OrderForEditFragment = { __typename?: 'Order', id: string, consumables: Array<{ __typename?: 'AvailableConsumable', used: number, available: number, name: ConsumableName, orderItemId: string, ordered: number }> };

export type UpdateOrderItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateOrderItemInput;
}>;


export type UpdateOrderItemMutation = { __typename?: 'Mutation', updateOrderItem: { __typename?: 'OrderItem', id: string, quantity: number, unitPrice: number, discount: number, consumable: { __typename?: 'Consumable', id: number, name: ConsumableName } } };

export type SessionWithFilesFragment = { __typename?: 'Session', id: string, files: Array<{ __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType }> };

export type ExperienceForExperienceMultiselectFragment = { __typename?: 'Experience', id: string, title: string };

export type ListExperiencesForExperienceMultiselectQueryVariables = Exact<{
  filter?: InputMaybe<ExperienceFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<ExperienceSort> | ExperienceSort>;
}>;


export type ListExperiencesForExperienceMultiselectQuery = { __typename?: 'Query', experiences: { __typename?: 'ExperienceConnection', nodes: Array<{ __typename?: 'Experience', id: string, title: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type ExperienceForExperienceSelectFragment = { __typename?: 'Experience', id: string, title: string };

export type GetExperienceForExperienceSelectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExperienceForExperienceSelectQuery = { __typename?: 'Query', experience: { __typename?: 'Experience', id: string, title: string } };

export type ListExperiencesForExperienceSelectQueryVariables = Exact<{
  filter?: InputMaybe<ExperienceFilter>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListExperiencesForExperienceSelectQuery = { __typename?: 'Query', experiences: { __typename?: 'ExperienceConnection', nodes: Array<{ __typename?: 'Experience', id: string, title: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type UpdateGalleryPasswordMutationVariables = Exact<{
  input: UpdateGalleryPasswordInput;
}>;


export type UpdateGalleryPasswordMutation = { __typename?: 'Mutation', updateGalleryPassword: { __typename?: 'SessionIntegration', id: string, type: IntegrationType, url?: string | null, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null } } };

export type GameCityForGameCitiesSelectFragment = { __typename?: 'GameCity', id: string, label: string };

export type ListGameCitiesForGameCitySelectQueryVariables = Exact<{
  filter: GameCityFilter;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListGameCitiesForGameCitySelectQuery = { __typename?: 'Query', gameCities: { __typename?: 'GameCityConnection', nodes: Array<{ __typename?: 'GameCity', id: string, label: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type GameZoneForGameZoneSelectFragment = { __typename?: 'GameZone', id: string, name: string };

export type ListGameZonesForGameZoneSelectQueryVariables = Exact<{
  filter: GameZoneFilter;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListGameZonesForGameZoneSelectQuery = { __typename?: 'Query', gameZones: { __typename?: 'GameZoneConnection', nodes: Array<{ __typename?: 'GameZone', id: string, name: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type SessionForInstructionsFragment = { __typename?: 'Session', id: string, instructions: Array<{ __typename?: 'Instruction', id: string, type: PdfType, documentType: SessionDocument, title?: string | null, description?: string | null }> };

export type SessionForInviteLinksFragment = { __typename?: 'Session', id: string, name: string, shortName?: string | null, type: SessionType, irl: boolean, hybrid: boolean, hostType: HostType, syncType: SyncType, vas: boolean, isEscapeRoom: boolean, isMysteryExpress: boolean, pdfType?: PdfType | null, startsAt?: string | null, startDate?: Date | null, endsAt?: string | null, endDate?: Date | null, timezone: string, scheduled: boolean, hasBreadcrumbIntegration: boolean, links: Map<IntegrationType, string>, language?: string | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, experience?: { __typename?: 'Experience', id: string, title: string } | null, integrations: Array<{ __typename?: 'SessionIntegration', id: string, type: IntegrationType, url?: string | null }>, locations: Array<{ __typename?: 'SessionLocation', id: string, type: SessionLocationType, location: { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }> };

export type CreateManualOrderMutationVariables = Exact<{
  input: CreateManualOrderInput;
}>;


export type CreateManualOrderMutation = { __typename?: 'Mutation', createManualOrder: { __typename?: 'Order', id: string } };

export type ListMissionSetsForMissionSetSelectQueryVariables = Exact<{
  filter?: InputMaybe<MissionSetFilter>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListMissionSetsForMissionSetSelectQuery = { __typename?: 'Query', missionSets: { __typename?: 'MissionSetConnection', nodes: Array<{ __typename?: 'MissionSet', id: string, name: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type MissionSetForMissionSetSelectFragment = { __typename?: 'MissionSet', id: string, name: string };

export type ListSessionsForMissionSetMultiselectQueryVariables = Exact<{
  filter?: InputMaybe<SessionFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<SessionSort> | SessionSort>;
}>;


export type ListSessionsForMissionSetMultiselectQuery = { __typename?: 'Query', sessions: { __typename?: 'SessionConnection', nodes: Array<{ __typename?: 'Session', id: string, name: string, shortName?: string | null, startsAt?: string | null, startDate?: Date | null, missionSet?: { __typename?: 'MissionSet', id: string } | null }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type SessionForMissionSetSessionMultiselectFragment = { __typename?: 'Session', id: string, name: string, shortName?: string | null, startsAt?: string | null, startDate?: Date | null, missionSet?: { __typename?: 'MissionSet', id: string } | null };

export type ListModifiersForModifierMultiselectQueryVariables = Exact<{
  filter?: InputMaybe<ModifierFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<ModifierSort> | ModifierSort>;
}>;


export type ListModifiersForModifierMultiselectQuery = { __typename?: 'Query', modifiers: { __typename?: 'ModifierConnection', nodes: Array<{ __typename?: 'Modifier', id: string, label: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type ModifierForModifierMultiselectFragment = { __typename?: 'Modifier', id: string, label: string };

export type CreateGameZoneMutationVariables = Exact<{
  input: CreateGameZoneInput;
}>;


export type CreateGameZoneMutation = { __typename?: 'Mutation', createGameZone: { __typename?: 'GameZone', id: string, name: string } };

export type SessionWithPackageLevelFragment = { __typename?: 'Session', id: string, packageLevel: PackageLevel };

export type CreatePermissionForPermissionAssignerMutationVariables = Exact<{
  input: CreatePermissionInput;
}>;


export type CreatePermissionForPermissionAssignerMutation = { __typename?: 'Mutation', createPermission: { __typename?: 'Permission', id: string, workspaceId: string, userId: string, role: PermissionRole } };

export type DeletePermissionForPermissionAssignerMutationVariables = Exact<{
  input: DeletePermissionInput;
}>;


export type DeletePermissionForPermissionAssignerMutation = { __typename?: 'Mutation', deletePermission: { __typename?: 'Permission', id: string, workspaceId: string, userId: string, role: PermissionRole } };

export type ListPermissionsForPermissionsAssignerQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  role: PermissionRole;
}>;


export type ListPermissionsForPermissionsAssignerQuery = { __typename?: 'Query', permissions: { __typename?: 'PermissionConnection', nodes: Array<{ __typename?: 'Permission', id: string, workspaceId: string, userId: string, role: PermissionRole }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type ListUsersForPermissionsAssignerQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListUsersForPermissionsAssignerQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', nodes: Array<{ __typename?: 'User', id: string, fullName: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type PermissionForPermissionsAssignerFragment = { __typename?: 'Permission', id: string, workspaceId: string, userId: string, role: PermissionRole };

export type ListUserPermissionsForPrimaryWorkspaceSelectQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type ListUserPermissionsForPrimaryWorkspaceSelectQuery = { __typename?: 'Query', permissions: { __typename?: 'PermissionConnection', nodes: Array<{ __typename?: 'Permission', id: string, primary: boolean, workspace: { __typename?: 'Workspace', id: string, name: string } }> } };

export type PermissionWithPrimaryFragment = { __typename?: 'Permission', id: string, primary: boolean };

export type UpdatePrimaryPermissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpdatePrimaryPermissionMutation = { __typename?: 'Mutation', updatePermission: { __typename?: 'Permission', id: string, primary: boolean } };

export type SessionForScheduleDialogFragment = { __typename?: 'Session', id: string, startDate?: Date | null, timezone: string, duration: number, packageLevel: PackageLevel, language?: string | null, size: number, hostType: HostType, modifications: Array<string> };

export type SessionAssignmentForSessionAssignmentsSectionFragment = { __typename?: 'SessionAssignment', id: string, role: SessionRole, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, user?: { __typename?: 'User', id: string, fullName: string, avatar?: string | null } | null };

export type SessionForSessionAssignmentsSectionFragment = { __typename?: 'Session', id: string, diy: boolean, size: number, type: SessionType, remote: boolean, packageLevel: PackageLevel, hasUpgrade: boolean, locateable: boolean, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, user?: { __typename?: 'User', id: string, fullName: string, avatar?: string | null } | null }>, hosts: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, user?: { __typename?: 'User', id: string, fullName: string, avatar?: string | null } | null }> };

export type SessionForNonVirtualSessionAttendeesInputFragment = { __typename?: 'Session', id: string, credits: number, restrictions: { __typename?: 'SessionRestrictions', attendees: number } };

export type SessionForVirtualSessionAttendeesInputFragment = { __typename?: 'Session', id: string, size: number, diy: boolean, restrictions: { __typename?: 'SessionRestrictions', attendees: number } };

export type SessionForSessionAttendeesInputFragment = { __typename?: 'Session', id: string, type: SessionType, size: number, diy: boolean, credits: number, restrictions: { __typename?: 'SessionRestrictions', attendees: number } };

export type SessionForSessionCardFragment = { __typename?: 'Session', id: string, name: string, shortName?: string | null, preview?: string | null, type: SessionType, remote: boolean, startsAt?: string | null, startDate?: Date | null, attendees: number, teams: number, size: number, packageLevel: PackageLevel, status: SessionStatus, links: Map<IntegrationType, string>, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, group?: { __typename?: 'SessionGroup', id: string } | null };

export type SessionForSessionCheckoutDialogFragment = { __typename?: 'Session', id: string, type: SessionType, timezone: string, duration: number, packageLevel: PackageLevel, size: number, startDate?: Date | null };

export type SessionGroupForSessionGroupHighlightCardFragment = { __typename?: 'SessionGroup', id: string, name: string, attendees: number, image?: { __typename?: 'File', id: string, src: string } | null, experience?: { __typename?: 'Experience', id: string, title: string } | null };

export type SessionForSessionHighlightCardFragment = { __typename?: 'Session', id: string, name: string, shortName?: string | null, preview?: string | null, type: SessionType, attendees: number, teams: number, size: number, status: SessionStatus, experience?: { __typename?: 'Experience', id: string, title: string } | null, supportsSlots: { __typename?: 'SupportsSlots', customer: boolean, staff: boolean } };

export type UpdateSessionHostTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  hostType: HostType;
}>;


export type UpdateSessionHostTypeMutation = { __typename?: 'Mutation', updateSessionHostType: { __typename?: 'Session', id: string, hostType: HostType, name: string, isLobbyEligible: boolean, isApprovable: boolean, assignments: Array<{ __typename?: 'SessionAssignment', id: string, userId?: string | null, type: AssignmentType, user?: { __typename?: 'User', id: string } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null }>, supportsSlots: { __typename?: 'SupportsSlots', customer: boolean, staff: boolean } } };

export type ListSuggestedVenuesQueryVariables = Exact<{
  filter?: InputMaybe<VenueFilter>;
  sorting?: InputMaybe<Array<VenueSort> | VenueSort>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListSuggestedVenuesQuery = { __typename?: 'Query', venues: { __typename?: 'VenueConnection', nodes: Array<{ __typename?: 'Venue', id: string, name: string, rating: number, location: { __typename?: 'Location', id: string, name: string, address: string, placeId: string } }> } };

export type SuggestedVenueFragment = { __typename?: 'Venue', id: string, name: string, rating: number, location: { __typename?: 'Location', id: string, name: string, address: string, placeId: string } };

export type ListSessionsForSessionSelectQueryVariables = Exact<{
  filter?: InputMaybe<SessionFilter>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListSessionsForSessionSelectQuery = { __typename?: 'Query', sessions: { __typename?: 'SessionConnection', nodes: Array<{ __typename?: 'Session', id: string, name: string, startsAt?: string | null, startDate?: Date | null }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type SessionForSessionSelectFragment = { __typename?: 'Session', id: string, name: string, startsAt?: string | null, startDate?: Date | null };

export type UpdateSessionTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  type: SessionType;
}>;


export type UpdateSessionTypeMutation = { __typename?: 'Mutation', updateSessionType: { __typename?: 'Session', id: string, type: SessionType, name: string, remote: boolean, irl: boolean, hybrid: boolean, assignability: SessionAssignability, isLobbyEligible: boolean, isApprovable: boolean, locateable: boolean, hasGroupDetails: boolean, assignments: Array<{ __typename?: 'SessionAssignment', id: string, userId?: string | null, type: AssignmentType, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, user?: { __typename?: 'User', id: string } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null }>, supportsSlots: { __typename?: 'SupportsSlots', customer: boolean, staff: boolean }, meta: { __typename?: 'SessionMeta', gameControl?: boolean | null } } };

export type UpdateSessionSyncTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  value: SyncType;
}>;


export type UpdateSessionSyncTypeMutation = { __typename?: 'Mutation', updateSessionSyncType: { __typename?: 'Session', id: string, templateId?: string | null, syncType: SyncType, pdfType?: PdfType | null, vas: boolean, assignability: SessionAssignability, hasGroupDetails: boolean, isLobbyEligible: boolean, isCustomizable: boolean, locateable: boolean, supportsSlots: { __typename?: 'SupportsSlots', customer: boolean, staff: boolean }, meta: { __typename?: 'SessionMeta', template?: SessionTemplateType | null, gameControl?: boolean | null }, integrations: Array<{ __typename?: 'SessionIntegration', id: string, active: boolean }> } };

export type GetTemplateForTemplateSelectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  sync: SyncType;
  type?: InputMaybe<SessionTemplateType>;
}>;


export type GetTemplateForTemplateSelectQuery = { __typename?: 'Query', template?: { __typename?: 'Template', id: string, name: string, url: string } | null };

export type ListTemplatesForTemplateSelectQueryVariables = Exact<{
  sync: SyncType;
  type?: InputMaybe<SessionTemplateType>;
  search?: InputMaybe<Scalars['String']['input']>;
  paging?: InputMaybe<OffsetPaging>;
  exclude?: InputMaybe<Scalars['String']['input']>;
  lobby?: InputMaybe<Scalars['Boolean']['input']>;
  mine?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListTemplatesForTemplateSelectQuery = { __typename?: 'Query', templates: { __typename?: 'TemplateConnection', nodes: Array<{ __typename?: 'Template', id: string, name: string, url: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type TemplateForTemplateSelectFragment = { __typename?: 'Template', id: string, name: string, url: string };

export type ListUsersForUserMultiselectQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<UserSort> | UserSort>;
}>;


export type ListUsersForUserMultiselectQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', nodes: Array<{ __typename?: 'User', id: string, fullName: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type UserForUserMultiselectFragment = { __typename?: 'User', id: string, fullName: string };

export type GetUserForUserSelectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserForUserSelectQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, fullName: string } | null };

export type ListUsersForUserSelectQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListUsersForUserSelectQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', nodes: Array<{ __typename?: 'User', id: string, fullName: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type UserForUserSelectFragment = { __typename?: 'User', id: string, fullName: string };

export type CreatePermissionForWorkspaceAssignerMutationVariables = Exact<{
  input: CreatePermissionInput;
}>;


export type CreatePermissionForWorkspaceAssignerMutation = { __typename?: 'Mutation', createPermission: { __typename?: 'Permission', id: string, workspaceId: string } };

export type DeletePermissionForWorkspaceAssignerMutationVariables = Exact<{
  input: DeletePermissionInput;
}>;


export type DeletePermissionForWorkspaceAssignerMutation = { __typename?: 'Mutation', deletePermission: { __typename?: 'Permission', id: string } };

export type ListPermissionsForWorkspaceAssignerQueryVariables = Exact<{
  role?: InputMaybe<PermissionRole>;
  user: Scalars['ID']['input'];
}>;


export type ListPermissionsForWorkspaceAssignerQuery = { __typename?: 'Query', permissions: { __typename?: 'PermissionConnection', nodes: Array<{ __typename?: 'Permission', id: string, workspaceId: string }> } };

export type PermissionForWorkspaceAssignerFragment = { __typename?: 'Permission', id: string, workspaceId: string };

export type ListWorkspacesForWorkspaceMultiselectQueryVariables = Exact<{
  filter?: InputMaybe<WorkspaceFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<WorkspaceSort> | WorkspaceSort>;
}>;


export type ListWorkspacesForWorkspaceMultiselectQuery = { __typename?: 'Query', workspaces: { __typename?: 'WorkspaceConnection', nodes: Array<{ __typename?: 'Workspace', id: string, name: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type WorkspaceForWorkspaceMultiselectFragment = { __typename?: 'Workspace', id: string, name: string };

export type ListWorkspacesForWorkspaceSelectQueryVariables = Exact<{
  filter?: InputMaybe<WorkspaceFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<WorkspaceSort> | WorkspaceSort>;
}>;


export type ListWorkspacesForWorkspaceSelectQuery = { __typename?: 'Query', workspaces: { __typename?: 'WorkspaceConnection', nodes: Array<{ __typename?: 'Workspace', id: string, name: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type WorkspaceForWorkspaceSelectFragment = { __typename?: 'Workspace', id: string, name: string };

export type GetZoneAreaForSelectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetZoneAreaForSelectQuery = { __typename?: 'Query', zoneArea?: { __typename?: 'ZoneArea', id: string, name: string, price: number } | null };

export type ListZoneAreasForSelectQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListZoneAreasForSelectQuery = { __typename?: 'Query', zoneAreas: { __typename?: 'ZoneAreaConnection', nodes: Array<{ __typename?: 'ZoneArea', id: string, name: string, price: number }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null } } };

export type ZoneAreaForSelectFragment = { __typename?: 'ZoneArea', id: string, name: string, price: number };

export type AvailabilityFragment = { __typename?: 'Availability', id: string, from: number, to: number, enabled: boolean, day: number, date?: string | null, available: boolean, datetime?: Date | null, createdAt: string };

export type AvailableConsumableFragment = { __typename?: 'AvailableConsumable', name: ConsumableName, ordered: number, available: number, used: number };

export type CustomizationFragment = { __typename?: 'Customization', id: string, colors: { __typename?: 'CustomizationColors', primary?: string | null, secondary?: string | null, tertiary?: string | null }, media: Array<{ __typename?: 'CustomizationMedia', id: string, type: CustomizationMediaType, file: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } }> };

export type CustomizationMediaFragment = { __typename?: 'CustomizationMedia', id: string, type: CustomizationMediaType, file: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } };

export type FileFragment = { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType };

export type GroupDetailsFragment = { __typename?: 'SessionGroupDetails', playedPreviously?: string | null, multiSession?: string | null, multicultural?: string | null, young?: string | null, familiar?: string | null, sameLocation?: string | null, hasPreviousEvent?: string | null, previousEventDetails?: string | null, hasNextEvent?: string | null, nextEventUrl?: string | null, departments?: string | null, attendeesDetails?: string | null, eventDetails?: string | null, teamsOrigin?: string | null, teamsDetails?: string | null, prizesOrigin?: string | null, prizesShippingAddress?: string | null, food?: string | null, alcohol?: string | null, av?: Array<string> | null, avDetails?: string | null, age?: string | null, rating?: string | null, bar?: string | null, description?: string | null, mobility?: string | null };

export type LawnScheduleForShowFragment = { __typename?: 'LawnSchedule', id: string, break: boolean, breakDuration: number, roundBreakDuration: number, startOffset: number, endOffset: number, list: string, missions: Array<{ __typename?: 'BreadcrumbMission', id: string, name: string }>, tournament: { __typename?: 'Tournament', break?: { __typename?: 'TournamentBreak', afterRound: number, endsAt: string, startsAt: string } | null, rounds: Array<{ __typename?: 'TournamentRound', endsAt?: string | null, round: number, startsAt?: string | null, teams?: Array<Array<string>> | null }> } };

export type LocationFragment = { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } };

export type MissionFragment = { __typename?: 'Mission', id: string, name: string, type: MissionType, instructions: string, position?: number | null, notes?: string | null, createdAt: string, createdAtDate: Date, updatedAt: string, options: Array<{ __typename?: 'MissionOption', title: string, correct?: boolean | null }> };

export type MissionSetFragment = { __typename?: 'MissionSet', id: string, name: string };

export type ModifierWithLabelFragment = { __typename?: 'Modifier', id: string, label: string };

export type OffsetPageInfoFragment = { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null };

export type OrderFragment = { __typename?: 'Order', id: string, workspaceId: string, source: OrderCreationSource, paidAt: string };

export type OrderItemFragment = { __typename?: 'OrderItem', id: string, consumable: { __typename?: 'Consumable', id: number, name: ConsumableName } };

export type PageInfoFragment = { __typename?: 'PageInfo', startCursor?: any | null, endCursor?: any | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null };

export type SessionFragment = { __typename?: 'Session', id: string, workspaceId: string, templateId?: string | null, name: string, shortName?: string | null, startsAt?: string | null, endsAt?: string | null, duration: number, attendees: number, status: SessionStatus, timezone: string, type: SessionType, remote: boolean, irl: boolean, hybrid: boolean, isEscapeRoom: boolean, isMysteryExpress: boolean, packageLevel: PackageLevel, lobby: boolean, playType?: PlayType | null, language?: string | null, startDate?: Date | null, endDate?: Date | null, creationType: SessionCreationType, freeReschedule: boolean, pastEventsDetails?: string | null, futureEventsDetails?: string | null, internalNotes?: string | null, activityNotes?: string | null, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, experience?: { __typename?: 'Experience', id: string } | null, modifiers: Array<{ __typename?: 'Modifier', id: string }>, createdBy?: { __typename?: 'User', id: string } | null, files: Array<{ __typename?: 'File', id: string }>, missionSet?: { __typename?: 'MissionSet', id: string } | null, contact?: { __typename?: 'User', id: string, fullName: string } | null };

export type SessionForSessionGroupDetailsSectionFragment = { __typename?: 'Session', id: string, hasUpgrade: boolean };

export type SessionGroupWithSessionsFragment = { __typename?: 'SessionGroup', id: string, sessions: Array<{ __typename?: 'Session', id: string }> };

export type SessionIntegrationFragment = { __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } };

export type SessionLocationFragment = { __typename?: 'SessionLocation', id: string, type: SessionLocationType, location: { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } };

export type SessionSupportsUpgradeFragment = { __typename?: 'SessionSupportsUpgrade', customer: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null }, staff: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null } };

export type SessionVenueContactsFragment = { __typename?: 'SessionVenueContacts', name?: string | null, email?: string | null, phone?: string | null, details?: string | null };

export type SystemFragment = { __typename?: 'System', key: string, value: string };

export type TimelineFragment = { __typename?: 'Timeline', outdated?: boolean | null, items?: Array<{ __typename?: 'TimelineItem', id: string, time: string, description: string }> | null };

export type TimelineItemFragment = { __typename?: 'TimelineItem', id: string, time: string, description: string };

export type UserWithContactsFragment = { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null };

export type UserWithFullNameFragment = { __typename?: 'User', id: string, fullName: string };

export type UserWithFullNameAndAvatarFragment = { __typename?: 'User', id: string, fullName: string, avatar?: string | null };

export type WorkspaceWithConsumablesFragment = { __typename?: 'Workspace', id: string, consumables: { __typename?: 'WorkspaceConsumables', credits: number, openWeves: number } };

export type CreateMissionMutationVariables = Exact<{
  input: CreateMissionInput;
}>;


export type CreateMissionMutation = { __typename?: 'Mutation', createMission: { __typename?: 'Mission', id: string, name: string, type: MissionType, instructions: string, position?: number | null, notes?: string | null, createdAt: string, createdAtDate: Date, updatedAt: string, options: Array<{ __typename?: 'MissionOption', title: string, correct?: boolean | null }> } };

export type CreateMissionSetMutationVariables = Exact<{
  input: CreateOneMissionSetInput;
}>;


export type CreateMissionSetMutation = { __typename?: 'Mutation', createMissionSet: { __typename?: 'MissionSet', id: string, name: string } };

export type DeleteMissionMutationVariables = Exact<{
  input: DeleteOneMissionInput;
}>;


export type DeleteMissionMutation = { __typename?: 'Mutation', deleteMission: { __typename?: 'MissionDeleteResponse', id?: string | null } };

export type DeleteMissionSetMutationVariables = Exact<{
  input: DeleteOneMissionSetInput;
}>;


export type DeleteMissionSetMutation = { __typename?: 'Mutation', deleteMissionSet: { __typename?: 'MissionSetDeleteResponse', id?: string | null } };

export type DeleteSessionMutationVariables = Exact<{
  input: DeleteOneSessionInput;
}>;


export type DeleteSessionMutation = { __typename?: 'Mutation', deleteSession: { __typename?: 'SessionDeleteResponse', id?: string | null } };

export type DeleteSystemMutationVariables = Exact<{
  input: DeleteSystemInput;
}>;


export type DeleteSystemMutation = { __typename?: 'Mutation', deleteSystem: { __typename?: 'System', key: string } };

export type SetSystemMutationVariables = Exact<{
  input: SetSystemInput;
}>;


export type SetSystemMutation = { __typename?: 'Mutation', setSystem: { __typename?: 'System', key: string, value: string } };

export type UpdateMissionMutationVariables = Exact<{
  input: UpdateOneMissionInput;
}>;


export type UpdateMissionMutation = { __typename?: 'Mutation', updateMission: { __typename?: 'Mission', id: string, name: string, type: MissionType, instructions: string, position?: number | null, notes?: string | null, createdAt: string, createdAtDate: Date, updatedAt: string, options: Array<{ __typename?: 'MissionOption', title: string, correct?: boolean | null }> } };

export type UpdateMissionPositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  position: Scalars['Float']['input'];
}>;


export type UpdateMissionPositionMutation = { __typename?: 'Mutation', updateMission: { __typename?: 'Mission', id: string, position?: number | null } };

export type UpdateSessionMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type UpdateSessionMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'Session', id: string, workspaceId: string, templateId?: string | null, name: string, shortName?: string | null, startsAt?: string | null, endsAt?: string | null, duration: number, attendees: number, status: SessionStatus, timezone: string, type: SessionType, remote: boolean, irl: boolean, hybrid: boolean, isEscapeRoom: boolean, isMysteryExpress: boolean, packageLevel: PackageLevel, lobby: boolean, playType?: PlayType | null, language?: string | null, startDate?: Date | null, endDate?: Date | null, creationType: SessionCreationType, freeReschedule: boolean, pastEventsDetails?: string | null, futureEventsDetails?: string | null, internalNotes?: string | null, activityNotes?: string | null, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, experience?: { __typename?: 'Experience', id: string } | null, modifiers: Array<{ __typename?: 'Modifier', id: string }>, createdBy?: { __typename?: 'User', id: string } | null, files: Array<{ __typename?: 'File', id: string }>, missionSet?: { __typename?: 'MissionSet', id: string } | null, contact?: { __typename?: 'User', id: string, fullName: string } | null } };

export type GetWorkspaceWithConsumablesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkspaceWithConsumablesQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, consumables: { __typename?: 'WorkspaceConsumables', credits: number, openWeves: number } } | null };

export type ListSessionsForSearchQueryVariables = Exact<{
  filter?: InputMaybe<SessionFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<SessionSort> | SessionSort>;
}>;


export type ListSessionsForSearchQuery = { __typename?: 'Query', sessions: { __typename?: 'SessionConnection', nodes: Array<{ __typename?: 'Session', id: string, name: string, shortName?: string | null, preview?: string | null, type: SessionType, remote: boolean, startsAt?: string | null, startDate?: Date | null, attendees: number, teams: number, status: SessionStatus, size: number, links: Map<IntegrationType, string>, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null }>, group?: { __typename?: 'SessionGroup', id: string } | null }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type ExperienceForExperienceDurationInputFragment = { __typename?: 'Experience', id: string, title: string, bookable: boolean };

export type ExperienceFormatForExperienceDurationInputFragment = { __typename?: 'ExperienceFormat', id: string, type: ExperienceFormatType, hostType: HostType, minDuration?: number | null, maxDuration?: number | null };

export type ExperienceFormatForExperienceFormatSelectFragment = { __typename?: 'ExperienceFormat', id: string, title: string, type: ExperienceFormatType, hostType: HostType, experience: { __typename?: 'Experience', id: string, title: string } };

export type GetExperienceFormatForExperienceFormatSelectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExperienceFormatForExperienceFormatSelectQuery = { __typename?: 'Query', experienceFormat?: { __typename?: 'ExperienceFormat', id: string, title: string, type: ExperienceFormatType, hostType: HostType, experience: { __typename?: 'Experience', id: string, title: string } } | null };

export type ListExperienceFormatsForExperienceFormatSelectQueryVariables = Exact<{
  filter?: InputMaybe<ExperienceFormatFilter>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListExperienceFormatsForExperienceFormatSelectQuery = { __typename?: 'Query', experienceFormats: { __typename?: 'ExperienceFormatConnection', nodes: Array<{ __typename?: 'ExperienceFormat', id: string, title: string, type: ExperienceFormatType, hostType: HostType, experience: { __typename?: 'Experience', id: string, title: string } }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type ExperienceCustomizationFragment = { __typename?: 'ExperienceCustomization', title: string, description: string, notes: string };

export type ExperienceFormatWithModifiersFragment = { __typename?: 'ExperienceFormat', id: string, modifiers: Array<{ __typename?: 'Modifier', id: string }> };

export type GetExperienceFormatWithModifiersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExperienceFormatWithModifiersQuery = { __typename?: 'Query', experienceFormat?: { __typename?: 'ExperienceFormat', id: string, modifiers: Array<{ __typename?: 'Modifier', id: string }> } | null };

export type ModifierForSearchFragment = { __typename?: 'Modifier', id: string, label: string };

export type SearchModifiersQueryVariables = Exact<{
  lables: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SearchModifiersQuery = { __typename?: 'Query', modifiers: { __typename?: 'ModifierConnection', nodes: Array<{ __typename?: 'Modifier', id: string, label: string }> } };

export type SessionAssignmentForSessionAssignmentStatusFragment = { __typename?: 'SessionAssignment', id: string, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null };

export type SessionForSessionAssignmentStatusFragment = { __typename?: 'Session', id: string, locateable: boolean };

export type SessionAssignmentForTravelEditButtonFragment = { __typename?: 'SessionAssignment', id: string, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, user?: { __typename?: 'User', id: string } | null };

export type UpdateSessionAssignmentWithTravelMutationVariables = Exact<{
  input: UpdateSessionAssignmentInput;
}>;


export type UpdateSessionAssignmentWithTravelMutation = { __typename?: 'Mutation', updateSessionAssignment: { __typename?: 'SessionAssignment', id: string, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null } };

export type UpdateSessionAssignmentForStaffMutationVariables = Exact<{
  input: UpdateSessionAssignmentInput;
}>;


export type UpdateSessionAssignmentForStaffMutation = { __typename?: 'Mutation', updateSessionAssignment: { __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null } };

export type UpdateSessionAssignmentTravelConfirmationStatusMutationVariables = Exact<{
  input: UpdateSessionAssignmentTravelConfirmationStatusInput;
}>;


export type UpdateSessionAssignmentTravelConfirmationStatusMutation = { __typename?: 'Mutation', updateSessionAssignmentTravelConfirmationStatus: { __typename?: 'SessionAssignment', id: string, travelConfirmed?: boolean | null } };

export type GetUserForSessionTemplateSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserForSessionTemplateSelectQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, name: string } } };

export type UserForSessionTemplateSelectFragment = { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, name: string } };

export type GetSessionWithAssignmentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionWithAssignmentsQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }> } | null };

export type GetSessionWithIntegrationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionWithIntegrationsQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }> } | null };

export type SessionAssignmentWithTravelFragment = { __typename?: 'SessionAssignment', id: string, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null };

export type SessionAssignmentWithTravelAndCityFragment = { __typename?: 'SessionAssignment', id: string, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, session: { __typename?: 'Session', id: string, city?: string | null } };

export type SessionWithCreditsFragment = { __typename?: 'Session', id: string, credits: number };

export type SessionWithHasBreadcrumbIntegrationFragment = { __typename?: 'Session', id: string, syncType: SyncType, pdfType?: PdfType | null, hasBreadcrumbIntegration: boolean, integrations: Array<{ __typename?: 'SessionIntegration', id: string, type: IntegrationType }> };

export type SessionWithStatusFragment = { __typename?: 'Session', id: string, status: SessionStatus };

export type UpdateSessionImageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
}>;


export type UpdateSessionImageMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'Session', id: string, preview?: string | null } };

export type CreateUserAudioMutationVariables = Exact<{
  input: CreateUserAudioInput;
}>;


export type CreateUserAudioMutation = { __typename?: 'Mutation', createUserAudio: { __typename?: 'UserAudio', id: string, keypress?: string | null, volume?: number | null, overlay?: boolean | null, file: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } } };

export type DeleteUserAudioMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserAudioMutation = { __typename?: 'Mutation', deleteUserAudio: boolean };

export type ListUserAudioQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListUserAudioQuery = { __typename?: 'Query', userAudios: { __typename?: 'UserAudioConnection', nodes: Array<{ __typename?: 'UserAudio', id: string, keypress?: string | null, volume?: number | null, overlay?: boolean | null, file: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type UpdateUserAudioMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserAudioInput;
}>;


export type UpdateUserAudioMutation = { __typename?: 'Mutation', updateUserAudio: { __typename?: 'UserAudio', id: string, keypress?: string | null, volume?: number | null, overlay?: boolean | null, file: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } } };

export type UserAudioFragment = { __typename?: 'UserAudio', id: string, keypress?: string | null, volume?: number | null, overlay?: boolean | null, file: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } };

export type WorkspaceWithCreditsFragment = { __typename?: 'Workspace', id: string, consumables: { __typename?: 'WorkspaceConsumables', credits: number } };

export type GetWorkspaceForStoreQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkspaceForStoreQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, name: string, content?: boolean | null, subscriber: boolean, notifications?: boolean | null } | null };

export type WorkspaceForStoreFragment = { __typename?: 'Workspace', id: string, name: string, content?: boolean | null, subscriber: boolean, notifications?: boolean | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email: string, role: Role, permission: UserPermission, phone?: string | null, meetingLink?: string | null, avatar?: string | null, canHaveAvailability: boolean, permissions: Array<{ __typename?: 'Permission', id: string, workspaceId: string, userId: string, role: PermissionRole, primary: boolean }> } };

export type PermissionsForStoreFragment = { __typename?: 'Permission', id: string, workspaceId: string, userId: string, role: PermissionRole, primary: boolean };

export type UpdateUserForStoreMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserForStoreMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, phone?: string | null, meetingLink?: string | null, attributes: { __typename?: 'UserAttributes', email?: string | null } } };

export type UserForStoreFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email: string, role: Role, permission: UserPermission, phone?: string | null, meetingLink?: string | null, avatar?: string | null, canHaveAvailability: boolean, permissions: Array<{ __typename?: 'Permission', id: string, workspaceId: string, userId: string, role: PermissionRole, primary: boolean }> };

export type UserWithEmailFragment = { __typename?: 'User', id: string, email: string };

export type SessionForSessionRescheduleFragment = { __typename?: 'Session', id: string, type: SessionType, size: number, diy: boolean, freeReschedule: boolean, startDate?: Date | null, endDate?: Date | null, createdDate: Date, scheduled: boolean, complete: boolean };

export type GetSystemQueryVariables = Exact<{
  key: SystemKey;
}>;


export type GetSystemQuery = { __typename?: 'Query', system?: { __typename?: 'System', key: string, value: string } | null };

export type GetSessionForShiftPlanningSessionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionForShiftPlanningSessionQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, name: string, shortName?: string | null, preview?: string | null, type: SessionType, remote: boolean, startsAt?: string | null, startDate?: Date | null, attendees: number, teams: number, size: number, packageLevel: PackageLevel, status: SessionStatus, links: Map<IntegrationType, string>, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, group?: { __typename?: 'SessionGroup', id: string } | null } | null };

export type SessionForShiftPlanningSessionFragment = { __typename?: 'Session', id: string, name: string, shortName?: string | null, preview?: string | null, type: SessionType, remote: boolean, startsAt?: string | null, startDate?: Date | null, attendees: number, teams: number, size: number, packageLevel: PackageLevel, status: SessionStatus, links: Map<IntegrationType, string>, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, group?: { __typename?: 'SessionGroup', id: string } | null };

export type CreateAvailabilitiesMutationVariables = Exact<{
  input: Array<CreateAvailabilityInput> | CreateAvailabilityInput;
}>;


export type CreateAvailabilitiesMutation = { __typename?: 'Mutation', createAvailabilities: Array<{ __typename?: 'Availability', id: string, from: number, to: number, enabled: boolean, day: number, date?: string | null, available: boolean, datetime?: Date | null, createdAt: string }> };

export type CreateGlobalUnavailabilitiesMutationVariables = Exact<{
  input: CreateManyGlobalUnavailabilitiesInput;
}>;


export type CreateGlobalUnavailabilitiesMutation = { __typename?: 'Mutation', createGlobalUnavailabilities: Array<{ __typename?: 'GlobalUnavailability', id: string, startsAt: string, endsAt: string, startDate: Date, endDate: Date }> };

export type DeleteAvailabilitiesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteAvailabilitiesMutation = { __typename?: 'Mutation', deleteAvailabilities: Array<{ __typename?: 'DeleteAvailabilityResult', id: string, success: boolean }> };

export type DeleteGlobalUnavailabilityMutationVariables = Exact<{
  input: DeleteOneGlobalUnavailabilityInput;
}>;


export type DeleteGlobalUnavailabilityMutation = { __typename?: 'Mutation', deleteGlobalUnavailability: { __typename?: 'GlobalUnavailabilityDeleteResponse', id?: string | null } };

export type ExperienceForAvailabilityEventFragment = { __typename?: 'Experience', id: string, title: string, formats: Array<{ __typename?: 'ExperienceFormat', id: string, type: ExperienceFormatType, hostType: HostType, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> }> };

export type GetExperienceForAvailabilityEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExperienceForAvailabilityEventQuery = { __typename?: 'Query', experience: { __typename?: 'Experience', id: string, title: string, formats: Array<{ __typename?: 'ExperienceFormat', id: string, type: ExperienceFormatType, hostType: HostType, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> }> } };

export type GetUserForAvailabilityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserForAvailabilityQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, fullName: string, timezone?: string | null, availabilities: Array<{ __typename?: 'Availability', id: string, from: number, to: number, enabled: boolean, day: number, date?: string | null, available: boolean, datetime?: Date | null, createdAt: string }> } | null };

export type GlobalUnavailabilityFragment = { __typename?: 'GlobalUnavailability', id: string, startsAt: string, endsAt: string, startDate: Date, endDate: Date };

export type ListGlobalUnavailabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGlobalUnavailabilitiesQuery = { __typename?: 'Query', globalUnavailabilities: { __typename?: 'GlobalUnavailabilityConnection', nodes: Array<{ __typename?: 'GlobalUnavailability', id: string, startsAt: string, endsAt: string, startDate: Date, endDate: Date }> } };

export type ListGlobalUnavailabilitiesForShiftPlanningQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type ListGlobalUnavailabilitiesForShiftPlanningQuery = { __typename?: 'Query', globalUnavailabilities: { __typename?: 'GlobalUnavailabilityConnection', nodes: Array<{ __typename?: 'GlobalUnavailability', id: string, startsAt: string, endsAt: string, startDate: Date, endDate: Date }> } };

export type ListSessionAssignmentForShiftPlanningQueryVariables = Exact<{
  overlaps: Scalars['DateTimeRange']['input'];
  type?: InputMaybe<SessionType>;
}>;


export type ListSessionAssignmentForShiftPlanningQuery = { __typename?: 'Query', sessionAssignments: { __typename?: 'SessionAssignmentConnection', nodes: Array<{ __typename?: 'SessionAssignment', id: string, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, user?: { __typename?: 'User', id: string } | null, session: { __typename?: 'Session', type: SessionType, id: string, city?: string | null } }> } };

export type ListSessionsForShiftPlanningQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  type?: InputMaybe<SessionType>;
}>;


export type ListSessionsForShiftPlanningQuery = { __typename?: 'Query', sessions: { __typename?: 'SessionConnection', nodes: Array<{ __typename?: 'Session', id: string, type: SessionType, hostType: HostType, startsAt?: string | null, endsAt?: string | null, scheduleStartsAt?: string | null, startDate?: Date | null, endDate?: Date | null, scheduleStartDate?: Date | null, assignments: Array<{ __typename?: 'SessionAssignment', userId?: string | null }> }> } };

export type ListUsersForShiftPlanningQueryVariables = Exact<{
  filter: UserFilter;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListUsersForShiftPlanningQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', nodes: Array<{ __typename?: 'User', id: string, fullName: string, timezone?: string | null, avatar?: string | null, location?: { __typename?: 'Location', id: string, name: string } | null, availabilities: Array<{ __typename?: 'Availability', id: string, from: number, to: number, enabled: boolean, day: number, date?: string | null, available: boolean, datetime?: Date | null, createdAt: string }> }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type SessionForShiftPlanningFragment = { __typename?: 'Session', id: string, type: SessionType, hostType: HostType, startsAt?: string | null, endsAt?: string | null, scheduleStartsAt?: string | null, startDate?: Date | null, endDate?: Date | null, scheduleStartDate?: Date | null, assignments: Array<{ __typename?: 'SessionAssignment', userId?: string | null }> };

export type UpdateAvailabilityMutationVariables = Exact<{
  input: UpdateAvailabilityInput;
}>;


export type UpdateAvailabilityMutation = { __typename?: 'Mutation', updateAvailability: { __typename?: 'Availability', id: string, from: number, to: number, enabled: boolean, day: number, date?: string | null, available: boolean, datetime?: Date | null, createdAt: string } };

export type UpdateUserTimezoneMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  timezone: Scalars['String']['input'];
}>;


export type UpdateUserTimezoneMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, timezone?: string | null } };

export type UserForAvailabilityFragment = { __typename?: 'User', id: string, fullName: string, timezone?: string | null, availabilities: Array<{ __typename?: 'Availability', id: string, from: number, to: number, enabled: boolean, day: number, date?: string | null, available: boolean, datetime?: Date | null, createdAt: string }> };

export type UserForShiftPlanningFragment = { __typename?: 'User', id: string, fullName: string, timezone?: string | null, avatar?: string | null, location?: { __typename?: 'Location', id: string, name: string } | null, availabilities: Array<{ __typename?: 'Availability', id: string, from: number, to: number, enabled: boolean, day: number, date?: string | null, available: boolean, datetime?: Date | null, createdAt: string }> };

export type GetWorkspaceForContentLibraryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkspaceForContentLibraryQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, settings: { __typename?: 'WorkspaceSettings', missions?: number | null } } | null };

export type ListMissionSetsForContentLibraryQueryVariables = Exact<{
  filter?: InputMaybe<MissionSetFilter>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListMissionSetsForContentLibraryQuery = { __typename?: 'Query', missionSets: { __typename?: 'MissionSetConnection', nodes: Array<{ __typename?: 'MissionSet', id: string, name: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type ListMissionsByMissionSetQueryVariables = Exact<{
  missionSetId: Scalars['ID']['input'];
}>;


export type ListMissionsByMissionSetQuery = { __typename?: 'Query', missions: { __typename?: 'MissionConnection', nodes: Array<{ __typename?: 'Mission', id: string, name: string, type: MissionType, instructions: string, position?: number | null, notes?: string | null, createdAt: string, createdAtDate: Date, updatedAt: string, options: Array<{ __typename?: 'MissionOption', title: string, correct?: boolean | null }> }> } };

export type MissionForFormFragment = { __typename?: 'Mission', name: string, type: MissionType, instructions: string, notes?: string | null, options: Array<{ __typename?: 'MissionOption', title: string, correct?: boolean | null }> };

export type UpdateMissionSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateMissionSetMutation = { __typename?: 'Mutation', updateMissionSet: { __typename?: 'MissionSet', id: string, name: string } };

export type WorkspaceForContentLibraryFragment = { __typename?: 'Workspace', id: string, settings: { __typename?: 'WorkspaceSettings', missions?: number | null } };

export type CustomizationWithMediaFragment = { __typename?: 'Customization', id: string, media: Array<{ __typename?: 'CustomizationMedia', id: string, type: CustomizationMediaType, file: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } }> };

export type GetWorkspaceForCustomizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkspaceForCustomizationQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, customization: { __typename?: 'Customization', id: string, colors: { __typename?: 'CustomizationColors', primary?: string | null, secondary?: string | null, tertiary?: string | null }, media: Array<{ __typename?: 'CustomizationMedia', id: string, type: CustomizationMediaType, file: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } }> } } | null };

export type ResetCustomizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResetCustomizationMutation = { __typename?: 'Mutation', resetCustomization: { __typename?: 'Customization', id: string, colors: { __typename?: 'CustomizationColors', primary?: string | null, secondary?: string | null, tertiary?: string | null }, media: Array<{ __typename?: 'CustomizationMedia', id: string }> } };

export type UpdateCustomizationMutationVariables = Exact<{
  input: UpdateOneCustomizationInput;
}>;


export type UpdateCustomizationMutation = { __typename?: 'Mutation', updateCustomization: { __typename?: 'Customization', id: string, colors: { __typename?: 'CustomizationColors', primary?: string | null, secondary?: string | null, tertiary?: string | null } } };

export type WorkspaceWithCustomizationFragment = { __typename?: 'Workspace', id: string, customization: { __typename?: 'Customization', id: string, colors: { __typename?: 'CustomizationColors', primary?: string | null, secondary?: string | null, tertiary?: string | null }, media: Array<{ __typename?: 'CustomizationMedia', id: string, type: CustomizationMediaType, file: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } }> } };

export type IntegrationForMediaAndDownloadFragment = { __typename?: 'SessionIntegration', id: string, type: IntegrationType, url?: string | null, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null } };

export type SessionForEventMediaAndDownloadsFragment = { __typename?: 'Session', id: string, type: SessionType, remote: boolean, irl: boolean, onScreen: boolean, startsAt?: string | null, startDate?: Date | null, complete: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, integrations: Array<{ __typename?: 'SessionIntegration', id: string, type: IntegrationType, url?: string | null, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null } }>, files: Array<{ __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType }>, experience?: { __typename?: 'Experience', id: string, title: string } | null, meta: { __typename?: 'SessionMeta', attendees?: boolean | null } };

export type UpdateSessionForEventMediaAndDownloadsMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type UpdateSessionForEventMediaAndDownloadsMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'Session', id: string, meta: { __typename?: 'SessionMeta', attendees?: boolean | null } } };

export type ListMissionListsForGameMissionListQueryVariables = Exact<{
  filter: MissionListFilter;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListMissionListsForGameMissionListQuery = { __typename?: 'Query', breadcrumbMissionLists: { __typename?: 'BreadcrumbMissionListConnection', nodes: Array<{ __typename?: 'BreadcrumbMissionList', id: string, name: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type MissionListForGameMissionListFragment = { __typename?: 'BreadcrumbMissionList', id: string, name: string };

export type BreadcrumbMissionForSelectFragment = { __typename?: 'BreadcrumbMission', id: string, name: string };

export type ListBreadcrumbMissionsForSelectQueryVariables = Exact<{
  filter: BreadcrumbMissionFilter;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListBreadcrumbMissionsForSelectQuery = { __typename?: 'Query', breadcrumbMissions: { __typename?: 'BreadcrumbMissionConnection', nodes: Array<{ __typename?: 'BreadcrumbMission', id: string, name: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type GetLawnScheduleForShowQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type GetLawnScheduleForShowQuery = { __typename?: 'Query', lawnSchedule?: { __typename?: 'LawnSchedule', id: string, break: boolean, breakDuration: number, roundBreakDuration: number, startOffset: number, endOffset: number, list: string, missions: Array<{ __typename?: 'BreadcrumbMission', id: string, name: string }>, tournament: { __typename?: 'Tournament', break?: { __typename?: 'TournamentBreak', afterRound: number, endsAt: string, startsAt: string } | null, rounds: Array<{ __typename?: 'TournamentRound', endsAt?: string | null, round: number, startsAt?: string | null, teams?: Array<Array<string>> | null }> } } | null };

export type UpdateLawnScheduleMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  input: UpdateLawnScheduleInput;
}>;


export type UpdateLawnScheduleMutation = { __typename?: 'Mutation', updateLawnSchedule?: { __typename?: 'LawnSchedule', id: string, break: boolean, breakDuration: number, roundBreakDuration: number, startOffset: number, endOffset: number, list: string, missions: Array<{ __typename?: 'BreadcrumbMission', id: string, name: string }>, tournament: { __typename?: 'Tournament', break?: { __typename?: 'TournamentBreak', afterRound: number, endsAt: string, startsAt: string } | null, rounds: Array<{ __typename?: 'TournamentRound', endsAt?: string | null, round: number, startsAt?: string | null, teams?: Array<Array<string>> | null }> } } | null };

export type CreateUserForCreateNewPlantDialogMutationVariables = Exact<{
  input: CreatePlantInput;
}>;


export type CreateUserForCreateNewPlantDialogMutation = { __typename?: 'Mutation', createPlant: { __typename?: 'User', id: string, fullName: string } };

export type ListUsersForPlantSelectQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListUsersForPlantSelectQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', nodes: Array<{ __typename?: 'User', id: string, fullName: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type SessionForSearchFragment = { __typename?: 'Session', id: string, name: string, shortName?: string | null, preview?: string | null, type: SessionType, remote: boolean, startsAt?: string | null, startDate?: Date | null, attendees: number, teams: number, status: SessionStatus, size: number, links: Map<IntegrationType, string>, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null }>, group?: { __typename?: 'SessionGroup', id: string } | null };

export type GetSessionAssignmentForSessionAssignmentSelectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionAssignmentForSessionAssignmentSelectQuery = { __typename?: 'Query', sessionAssignment?: { __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null } | null };

export type CreateMissionSetForSessionActivityDetailsMutationVariables = Exact<{
  input: CreateOneMissionSetInput;
}>;


export type CreateMissionSetForSessionActivityDetailsMutation = { __typename?: 'Mutation', createMissionSet: { __typename?: 'MissionSet', id: string } };

export type RemoveMissionSetFromSessionMutationVariables = Exact<{
  input: RemoveMissionSetFromSessionInput;
}>;


export type RemoveMissionSetFromSessionMutation = { __typename?: 'Mutation', removeMissionSetFromSession: { __typename?: 'Session', id: string, missionSet?: { __typename?: 'MissionSet', id: string } | null } };

export type SessionForSessionActivityDetailsFragment = { __typename?: 'Session', id: string, type: SessionType, irl: boolean, activityNotes?: string | null, isCustomizable: boolean, missionSet?: { __typename?: 'MissionSet', id: string } | null };

export type SetMissionSetOnSessionMutationVariables = Exact<{
  input: SetMissionSetOnSessionInput;
}>;


export type SetMissionSetOnSessionMutation = { __typename?: 'Mutation', setMissionSetOnSession: { __typename?: 'Session', id: string, missionSet?: { __typename?: 'MissionSet', id: string } | null } };

export type CreateUserForCreateNewUserDialogMutationVariables = Exact<{
  input: CreateBookingUserInput;
}>;


export type CreateUserForCreateNewUserDialogMutation = { __typename?: 'Mutation', createBookingUser: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } };

export type SessionForSessionContactDetailsFragment = { __typename?: 'Session', id: string, contact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, bookingContact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null };

export type SessionWithContactFragment = { __typename?: 'Session', id: string, contact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null };

export type SetSessionContactMutationVariables = Exact<{
  input: SetContactOnSessionInput;
}>;


export type SetSessionContactMutation = { __typename?: 'Mutation', setContactOnSession: { __typename?: 'Session', id: string, contact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null } };

export type AddSessionModifiersMutationVariables = Exact<{
  input: AddSessionModifiersInput;
}>;


export type AddSessionModifiersMutation = { __typename?: 'Mutation', addSessionModifiers: { __typename?: 'Session', id: string, isEscapeRoom: boolean, isMysteryExpress: boolean, hasGroupDetails: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string }>, supportsUpgrade: { __typename?: 'SessionSupportsUpgrade', customer: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null }, staff: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null } } } };

export type RemoveSessionModifiersMutationVariables = Exact<{
  input: RemoveSessionModifiersInput;
}>;


export type RemoveSessionModifiersMutation = { __typename?: 'Mutation', removeSessionModifiers: { __typename?: 'Session', id: string, isEscapeRoom: boolean, isMysteryExpress: boolean, hasGroupDetails: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string }>, supportsUpgrade: { __typename?: 'SessionSupportsUpgrade', customer: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null }, staff: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null } } } };

export type SessionForSessionSlotsInputFragment = { __typename?: 'Session', id: string, size: number, startsAt?: string | null, startDate?: Date | null, supportsSlots: { __typename?: 'SupportsSlots', customer: boolean, staff: boolean } };

export type RemoveSourceSessionFromSessionMutationVariables = Exact<{
  input: RemoveSourceSessionFromSessionInput;
}>;


export type RemoveSourceSessionFromSessionMutation = { __typename?: 'Mutation', removeSourceSessionFromSession: { __typename?: 'Session', id: string, sourceSession?: { __typename?: 'Session', id: string, name: string } | null } };

export type SetSourceSessionOnSessionMutationVariables = Exact<{
  input: SetSourceSessionOnSessionInput;
}>;


export type SetSourceSessionOnSessionMutation = { __typename?: 'Mutation', setSourceSessionOnSession: { __typename?: 'Session', id: string, sourceSession?: { __typename?: 'Session', id: string, name: string } | null } };

export type SessionForSessionDetailsFragment = { __typename?: 'Session', id: string, workspaceId: string, name: string, shortName?: string | null, type: SessionType, remote: boolean, irl: boolean, hybrid: boolean, hostType: HostType, syncType: SyncType, isEscapeRoom: boolean, isMysteryExpress: boolean, pdfType?: PdfType | null, startsAt?: string | null, startDate?: Date | null, timezone: string, duration: number, packageLevel: PackageLevel, credits: number, templateId?: string | null, isLobbyEligible: boolean, lobby: boolean, playType?: PlayType | null, size: number, diy: boolean, vas: boolean, language?: string | null, emailRegexPattern?: string | null, attendees: number, teams: number, freeReschedule: boolean, createdAt: string, createdDate: Date, scheduled: boolean, complete: boolean, modifications: Array<string>, sourceSession?: { __typename?: 'Session', id: string } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, meta: { __typename?: 'SessionMeta', template?: SessionTemplateType | null, actors?: boolean | null, vas?: boolean | null, lodging?: boolean | null, corporateActor?: boolean | null, permissions?: boolean | null, phoneSource?: PhoneSource | null }, supportsSlots: { __typename?: 'SupportsSlots', customer: boolean, staff: boolean }, supportsUpgrade: { __typename?: 'SessionSupportsUpgrade', customer: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null }, staff: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null } }, restrictions: { __typename?: 'SessionRestrictions', attendees: number } };

export type SessionForSessionInfoFragment = { __typename?: 'Session', id: string, syncType: SyncType, internalNotes?: string | null, creationType: SessionCreationType, createdAt: string, createdDate: Date, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, contact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, bookingContact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, additionalBookingContacts: Array<{ __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null }>, createdBy?: { __typename?: 'User', id: string, fullName: string } | null };

export type SessionForSessionDetailsSectionFragment = { __typename?: 'Session', complete: boolean, id: string, syncType: SyncType, internalNotes?: string | null, creationType: SessionCreationType, createdAt: string, createdDate: Date, workspaceId: string, name: string, shortName?: string | null, type: SessionType, remote: boolean, irl: boolean, hybrid: boolean, hostType: HostType, isEscapeRoom: boolean, isMysteryExpress: boolean, pdfType?: PdfType | null, startsAt?: string | null, startDate?: Date | null, timezone: string, duration: number, packageLevel: PackageLevel, credits: number, templateId?: string | null, isLobbyEligible: boolean, lobby: boolean, playType?: PlayType | null, size: number, diy: boolean, vas: boolean, language?: string | null, emailRegexPattern?: string | null, attendees: number, teams: number, freeReschedule: boolean, scheduled: boolean, modifications: Array<string>, activityNotes?: string | null, isCustomizable: boolean, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, contact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, bookingContact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, additionalBookingContacts: Array<{ __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null }>, createdBy?: { __typename?: 'User', id: string, fullName: string } | null, sourceSession?: { __typename?: 'Session', id: string } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, meta: { __typename?: 'SessionMeta', template?: SessionTemplateType | null, actors?: boolean | null, vas?: boolean | null, lodging?: boolean | null, corporateActor?: boolean | null, permissions?: boolean | null, phoneSource?: PhoneSource | null }, supportsSlots: { __typename?: 'SupportsSlots', customer: boolean, staff: boolean }, supportsUpgrade: { __typename?: 'SessionSupportsUpgrade', customer: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null }, staff: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null } }, restrictions: { __typename?: 'SessionRestrictions', attendees: number }, missionSet?: { __typename?: 'MissionSet', id: string } | null };

export type UpdateSessionForSessionDetailsMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type UpdateSessionForSessionDetailsMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'Session', id: string, name: string, shortName?: string | null, credits: number, lobby: boolean, templateId?: string | null, internalNotes?: string | null, activityNotes?: string | null, language?: string | null, teams: number, attendees: number, freeReschedule: boolean, pdfType?: PdfType | null, meta: { __typename?: 'SessionMeta', template?: SessionTemplateType | null }, restrictions: { __typename?: 'SessionRestrictions', attendees: number }, instructions: Array<{ __typename?: 'Instruction', id: string, type: PdfType, documentType: SessionDocument, title?: string | null, description?: string | null }> } };

export type ActionEndRealPlaythroughMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type ActionEndRealPlaythroughMutation = { __typename?: 'Mutation', actionEndRealPlaythrough: { __typename?: 'Playthrough', id: string, status: PlaythroughStatus, startedAt?: string | null, endedAt?: string | null } };

export type ActionMessageRealPlaythroughMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type ActionMessageRealPlaythroughMutation = { __typename?: 'Mutation', actionMessageRealPlaythrough: { __typename?: 'Playthrough', id: string } };

export type ActionStartRealPlaythroughMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type ActionStartRealPlaythroughMutation = { __typename?: 'Mutation', actionStartRealPlaythrough: { __typename?: 'Playthrough', id: string, status: PlaythroughStatus, startedAt?: string | null, endedAt?: string | null } };

export type GetBreadcrumbRealPlaythroughQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type GetBreadcrumbRealPlaythroughQuery = { __typename?: 'Query', breadcrumbRealPlaythrough: { __typename?: 'Playthrough', id: string, status: PlaythroughStatus, startedAt?: string | null, endedAt?: string | null } };

export type PlaythroughForGameControlFragment = { __typename?: 'Playthrough', id: string, status: PlaythroughStatus, startedAt?: string | null, endedAt?: string | null };

export type SessionForGameControlFragment = { __typename?: 'Session', id: string, duration: number, startsAt?: string | null, meta: { __typename?: 'SessionMeta', gameControl?: boolean | null } };

export type UpdateSessionGameControlMutationVariables = Exact<{
  input: UpdateGameControl;
}>;


export type UpdateSessionGameControlMutation = { __typename?: 'Mutation', updateSessionGameControl: { __typename?: 'Session', id: string, meta: { __typename?: 'SessionMeta', gameControl?: boolean | null } } };

export type ClearGroupDetailsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClearGroupDetailsMutation = { __typename?: 'Mutation', clearGroupDetails: { __typename?: 'Session', id: string, pastEventsDetails?: string | null, futureEventsDetails?: string | null, meta: { __typename?: 'SessionMeta', group?: { __typename?: 'SessionGroupDetails', playedPreviously?: string | null, multiSession?: string | null, multicultural?: string | null, young?: string | null, familiar?: string | null, sameLocation?: string | null, hasPreviousEvent?: string | null, previousEventDetails?: string | null, hasNextEvent?: string | null, nextEventUrl?: string | null, departments?: string | null, attendeesDetails?: string | null, eventDetails?: string | null, teamsOrigin?: string | null, teamsDetails?: string | null, prizesOrigin?: string | null, prizesShippingAddress?: string | null, food?: string | null, alcohol?: string | null, av?: Array<string> | null, avDetails?: string | null, age?: string | null, rating?: string | null, bar?: string | null, description?: string | null, mobility?: string | null } | null }, relations: Array<{ __typename?: 'SessionRelation', id: string, type: SessionRelationType }> } };

export type CopyGroupDetailsMutationVariables = Exact<{
  input: CopyGroupDetailsInput;
}>;


export type CopyGroupDetailsMutation = { __typename?: 'Mutation', copyGroupDetails: { __typename?: 'Session', id: string, pastEventsDetails?: string | null, futureEventsDetails?: string | null, meta: { __typename?: 'SessionMeta', group?: { __typename?: 'SessionGroupDetails', playedPreviously?: string | null, multiSession?: string | null, multicultural?: string | null, young?: string | null, familiar?: string | null, sameLocation?: string | null, hasPreviousEvent?: string | null, previousEventDetails?: string | null, hasNextEvent?: string | null, nextEventUrl?: string | null, departments?: string | null, attendeesDetails?: string | null, eventDetails?: string | null, teamsOrigin?: string | null, teamsDetails?: string | null, prizesOrigin?: string | null, prizesShippingAddress?: string | null, food?: string | null, alcohol?: string | null, av?: Array<string> | null, avDetails?: string | null, age?: string | null, rating?: string | null, bar?: string | null, description?: string | null, mobility?: string | null } | null } } };

export type AddSessionRelationsMutationVariables = Exact<{
  input: AddSessionRelationsInput;
}>;


export type AddSessionRelationsMutation = { __typename?: 'Mutation', addSessionRelations: { __typename?: 'Session', id: string, relations: Array<{ __typename?: 'SessionRelation', id: string, right: { __typename?: 'Session', id: string } }> } };

export type GetSessionForRelationsDialogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionForRelationsDialogQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, workspaceId: string, pastEventsDetails?: string | null, futureEventsDetails?: string | null, relations: Array<{ __typename?: 'SessionRelation', id: string, type: SessionRelationType, right: { __typename?: 'Session', id: string } }> } | null };

export type RemoveSessionRelationsMutationVariables = Exact<{
  input: RemoveSessionRelationsInput;
}>;


export type RemoveSessionRelationsMutation = { __typename?: 'Mutation', removeSessionRelations: { __typename?: 'Session', id: string, relations: Array<{ __typename?: 'SessionRelation', id: string }> } };

export type SessionForRelationsDialogFragment = { __typename?: 'Session', id: string, workspaceId: string, pastEventsDetails?: string | null, futureEventsDetails?: string | null, relations: Array<{ __typename?: 'SessionRelation', id: string, type: SessionRelationType, right: { __typename?: 'Session', id: string } }> };

export type UpdateSessionForPickPastSessionsDialogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  pastEventsDetails?: InputMaybe<Scalars['String']['input']>;
  futureEventsDetails?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSessionForPickPastSessionsDialogMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'Session', id: string, pastEventsDetails?: string | null, futureEventsDetails?: string | null } };

export type SessionForSessionGroupDetailsFragment = { __typename?: 'Session', id: string, type: SessionType, hostType: HostType, irl: boolean, hybrid: boolean, size: number, pastEventsDetails?: string | null, futureEventsDetails?: string | null, supportsPrizes: boolean, hasUpgrade: boolean, experience?: { __typename?: 'Experience', id: string, category: ExperienceCategory, title: string } | null, relations: Array<{ __typename?: 'SessionRelation', id: string, type: SessionRelationType }>, meta: { __typename?: 'SessionMeta', kitBased?: boolean | null, group?: { __typename?: 'SessionGroupDetails', playedPreviously?: string | null, multiSession?: string | null, multicultural?: string | null, young?: string | null, familiar?: string | null, sameLocation?: string | null, hasPreviousEvent?: string | null, previousEventDetails?: string | null, hasNextEvent?: string | null, nextEventUrl?: string | null, departments?: string | null, attendeesDetails?: string | null, eventDetails?: string | null, teamsOrigin?: string | null, teamsDetails?: string | null, prizesOrigin?: string | null, prizesShippingAddress?: string | null, food?: string | null, alcohol?: string | null, av?: Array<string> | null, avDetails?: string | null, age?: string | null, rating?: string | null, bar?: string | null, description?: string | null, mobility?: string | null } | null }, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> };

export type UpdateSessionForGroupDetailsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  meta?: InputMaybe<SessionMetaInput>;
}>;


export type UpdateSessionForGroupDetailsMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'Session', id: string, meta: { __typename?: 'SessionMeta', group?: { __typename?: 'SessionGroupDetails', playedPreviously?: string | null, multiSession?: string | null, multicultural?: string | null, young?: string | null, familiar?: string | null, sameLocation?: string | null, hasPreviousEvent?: string | null, previousEventDetails?: string | null, hasNextEvent?: string | null, nextEventUrl?: string | null, departments?: string | null, attendeesDetails?: string | null, eventDetails?: string | null, teamsOrigin?: string | null, teamsDetails?: string | null, prizesOrigin?: string | null, prizesShippingAddress?: string | null, food?: string | null, alcohol?: string | null, av?: Array<string> | null, avDetails?: string | null, age?: string | null, rating?: string | null, bar?: string | null, description?: string | null, mobility?: string | null } | null } } };

export type GetUserForSessionHostSelectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserForSessionHostSelectQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, fullName: string } | null };

export type AddLocationToSessionMutationVariables = Exact<{
  input: AddLocationToSessionInput;
}>;


export type AddLocationToSessionMutation = { __typename?: 'Mutation', addLocationToSession: { __typename?: 'Session', id: string, locations: Array<{ __typename?: 'SessionLocation', id: string, type: SessionLocationType, location: { __typename?: 'Location', venueId?: string | null, id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }> } };

export type RemoveLocationFromSessionMutationVariables = Exact<{
  input: RemoveLocationFromSessionInput;
}>;


export type RemoveLocationFromSessionMutation = { __typename?: 'Mutation', removeLocationFromSession: { __typename?: 'Session', id: string, locations: Array<{ __typename?: 'SessionLocation', id: string, location: { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }> } };

export type SessionForSessionLocationSectionFragment = { __typename?: 'Session', id: string, irl: boolean, city?: string | null, priceZone?: Credit | null, gameZoneId?: string | null, gameZoneDescription?: string | null, locationDetails?: string | null, supportsGameZone: boolean, gameZone?: { __typename?: 'GameZone', id: string, point: { type: 'Point', coordinates: [lng: number, lat: number] }, hull: Array<{ type: 'Point', coordinates: [lng: number, lat: number] }> } | null, locations: Array<{ __typename?: 'SessionLocation', id: string, type: SessionLocationType, location: { __typename?: 'Location', venueId?: string | null, id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }>, venue?: { __typename?: 'SessionVenueContacts', name?: string | null, email?: string | null, phone?: string | null, details?: string | null } | null };

export type UpdateSessionForSessionLocationSectionMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type UpdateSessionForSessionLocationSectionMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'Session', id: string, city?: string | null, gameZoneId?: string | null, credits: number, priceZone?: Credit | null, locationDetails?: string | null, gameZone?: { __typename?: 'GameZone', id: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } | null, venue?: { __typename?: 'SessionVenueContacts', name?: string | null, email?: string | null, phone?: string | null, details?: string | null } | null } };

export type AddTimelineItemMutationVariables = Exact<{
  input: AddTimelineItem;
}>;


export type AddTimelineItemMutation = { __typename?: 'Mutation', addTimelineItem: { __typename?: 'TimelineItem', id: string, time: string, description: string } };

export type RemoveTimelineItemMutationVariables = Exact<{
  input: RemoveTimelineItem;
}>;


export type RemoveTimelineItemMutation = { __typename?: 'Mutation', removeTimelineItem: { __typename?: 'TimelineItem', id: string } };

export type SessionForTimelineFragment = { __typename?: 'Session', id: string, startsAt?: string | null, startDate?: Date | null, timeline: { __typename?: 'Timeline', outdated?: boolean | null, items?: Array<{ __typename?: 'TimelineItem', id: string, time: string, description: string }> | null } };

export type SetTimelineMutationVariables = Exact<{
  input: SetTimelineInput;
}>;


export type SetTimelineMutation = { __typename?: 'Mutation', setTimeline: { __typename?: 'Session', id: string, timeline: { __typename?: 'Timeline', outdated?: boolean | null, items?: Array<{ __typename?: 'TimelineItem', id: string, time: string, description: string }> | null } } };

export type SessionForSessionScheduleSectionFragment = { __typename?: 'Session', id: string, name: string, type: SessionType, hostType: HostType, startsAt?: string | null, startDate?: Date | null, timezone: string, duration: number, scheduleOffset: number, packageLevel: PackageLevel, size: number, teams: number, diy: boolean, vas: boolean, scheduled: boolean, complete: boolean, upcoming: boolean, timeline: { __typename?: 'Timeline', outdated?: boolean | null, items?: Array<{ __typename?: 'TimelineItem', id: string, time: string, description: string }> | null } };

export type GetSessionForShuffleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionForShuffleQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, assignments: Array<{ __typename?: 'SessionAssignment', id: string, order: number }> } | null };

export type GetSessionForStaffAssignmentDialogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionForStaffAssignmentDialogQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, name: string, type: SessionType, irl: boolean, hybrid: boolean, scheduled: boolean, city?: string | null, assignability: SessionAssignability, isTravelable: boolean, isApprovable: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, order: number, rating?: number | null, travel?: { start: string, end: string } | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }>, hosts: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, order: number, rating?: number | null, travel?: { start: string, end: string } | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }> } | null };

export type SessionAssignmentForStaffAssignmentDialogFragment = { __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, order: number, rating?: number | null, travel?: { start: string, end: string } | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null };

export type SessionForStaffAssignmentDialogFragment = { __typename?: 'Session', id: string, name: string, type: SessionType, irl: boolean, hybrid: boolean, scheduled: boolean, city?: string | null, assignability: SessionAssignability, isTravelable: boolean, isApprovable: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, order: number, rating?: number | null, travel?: { start: string, end: string } | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }>, hosts: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, order: number, rating?: number | null, travel?: { start: string, end: string } | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }> };

export type SessionWithAssignmentsForStaffAssignmentFragment = { __typename?: 'Session', id: string, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }> };

export type SessionWithIntegrationsFragment = { __typename?: 'Session', id: string, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null }> };

export type AddAdditionalBookingContactMutationVariables = Exact<{
  input: AddAdditionalBookingContactsToSessionInput;
}>;


export type AddAdditionalBookingContactMutation = { __typename?: 'Mutation', addAdditionalBookingContactsToSession: { __typename?: 'Session', id: string, additionalBookingContacts: Array<{ __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null }> } };

export type ClearSessionAssignmentForStaffAssignmentMutationVariables = Exact<{
  input: ClearSessionAssignmentInput;
}>;


export type ClearSessionAssignmentForStaffAssignmentMutation = { __typename?: 'Mutation', clearSessionAssignment: { __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null } };

export type DeleteSessionAssignmentForStaffAssignmentMutationVariables = Exact<{
  input: DeleteSessionAssignmentInput;
}>;


export type DeleteSessionAssignmentForStaffAssignmentMutation = { __typename?: 'Mutation', deleteSessionAssignment?: { __typename?: 'SessionAssignment', id: string } | null };

export type GetSessionForShowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionForShowQuery = { __typename?: 'Query', session?: { __typename?: 'Session', preview?: string | null, city?: string | null, gameZoneId?: string | null, scheduled: boolean, upcoming: boolean, complete: boolean, assignability: SessionAssignability, size: number, diy: boolean, hasGroupDetails: boolean, vas: boolean, hasGroup: boolean, hasBreadcrumbIntegration: boolean, priceZone?: Credit | null, credits: number, createdDate: Date, hasUpgrade: boolean, links: Map<IntegrationType, string>, locateable: boolean, isTravelable: boolean, isApprovable: boolean, wrapUpEmailSentAt?: string | null, id: string, workspaceId: string, templateId?: string | null, name: string, shortName?: string | null, startsAt?: string | null, endsAt?: string | null, duration: number, attendees: number, status: SessionStatus, timezone: string, type: SessionType, remote: boolean, irl: boolean, hybrid: boolean, isEscapeRoom: boolean, isMysteryExpress: boolean, packageLevel: PackageLevel, lobby: boolean, playType?: PlayType | null, language?: string | null, startDate?: Date | null, endDate?: Date | null, creationType: SessionCreationType, freeReschedule: boolean, pastEventsDetails?: string | null, futureEventsDetails?: string | null, internalNotes?: string | null, activityNotes?: string | null, gameZoneDescription?: string | null, locationDetails?: string | null, supportsGameZone: boolean, hostType: HostType, scheduleOffset: number, teams: number, supportsPrizes: boolean, onScreen: boolean, syncType: SyncType, pdfType?: PdfType | null, createdAt: string, isLobbyEligible: boolean, emailRegexPattern?: string | null, modifications: Array<string>, isCustomizable: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }>, hosts: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }>, experience?: { __typename?: 'Experience', id: string, title: string, category: ExperienceCategory } | null, files: Array<{ __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType }>, contact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, bookingContact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, additionalBookingContacts: Array<{ __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null }>, group?: { __typename?: 'SessionGroup', id: string, name: string } | null, producer?: { __typename?: 'User', id: string } | null, producers: Array<{ __typename?: 'User', id: string }>, integrations: Array<{ __typename?: 'SessionIntegration', id: string, type: IntegrationType, url?: string | null, integrationId: string, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, createdBy?: { __typename?: 'User', id: string, fullName: string } | null, missionSet?: { __typename?: 'MissionSet', id: string } | null, gameZone?: { __typename?: 'GameZone', id: string, point: { type: 'Point', coordinates: [lng: number, lat: number] }, hull: Array<{ type: 'Point', coordinates: [lng: number, lat: number] }> } | null, locations: Array<{ __typename?: 'SessionLocation', id: string, type: SessionLocationType, location: { __typename?: 'Location', venueId?: string | null, id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }>, venue?: { __typename?: 'SessionVenueContacts', name?: string | null, email?: string | null, phone?: string | null, details?: string | null } | null, timeline: { __typename?: 'Timeline', outdated?: boolean | null, items?: Array<{ __typename?: 'TimelineItem', id: string, time: string, description: string }> | null }, relations: Array<{ __typename?: 'SessionRelation', id: string, type: SessionRelationType }>, meta: { __typename?: 'SessionMeta', kitBased?: boolean | null, attendees?: boolean | null, gameControl?: boolean | null, template?: SessionTemplateType | null, actors?: boolean | null, vas?: boolean | null, lodging?: boolean | null, corporateActor?: boolean | null, permissions?: boolean | null, phoneSource?: PhoneSource | null, group?: { __typename?: 'SessionGroupDetails', playedPreviously?: string | null, multiSession?: string | null, multicultural?: string | null, young?: string | null, familiar?: string | null, sameLocation?: string | null, hasPreviousEvent?: string | null, previousEventDetails?: string | null, hasNextEvent?: string | null, nextEventUrl?: string | null, departments?: string | null, attendeesDetails?: string | null, eventDetails?: string | null, teamsOrigin?: string | null, teamsDetails?: string | null, prizesOrigin?: string | null, prizesShippingAddress?: string | null, food?: string | null, alcohol?: string | null, av?: Array<string> | null, avDetails?: string | null, age?: string | null, rating?: string | null, bar?: string | null, description?: string | null, mobility?: string | null } | null }, instructions: Array<{ __typename?: 'Instruction', id: string, type: PdfType, documentType: SessionDocument, title?: string | null, description?: string | null }>, sourceSession?: { __typename?: 'Session', id: string } | null, supportsSlots: { __typename?: 'SupportsSlots', customer: boolean, staff: boolean }, supportsUpgrade: { __typename?: 'SessionSupportsUpgrade', customer: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null }, staff: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null } }, restrictions: { __typename?: 'SessionRestrictions', attendees: number } } | null };

export type RemoveAdditionalBookingContactMutationVariables = Exact<{
  input: RemoveAdditionalBookingContactsFromSessionInput;
}>;


export type RemoveAdditionalBookingContactMutation = { __typename?: 'Mutation', removeAdditionalBookingContactsFromSession: { __typename?: 'Session', id: string, additionalBookingContacts: Array<{ __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null }> } };

export type RemoveSessionBookingContactMutationVariables = Exact<{
  input: RemoveBookingContactFromSessionInput;
}>;


export type RemoveSessionBookingContactMutation = { __typename?: 'Mutation', removeBookingContactFromSession: { __typename?: 'Session', id: string, bookingContact?: { __typename?: 'User', id: string } | null } };

export type RemoveSessionContactMutationVariables = Exact<{
  input: RemoveContactFromSessionInput;
}>;


export type RemoveSessionContactMutation = { __typename?: 'Mutation', removeContactFromSession: { __typename?: 'Session', id: string, contact?: { __typename?: 'User', id: string } | null } };

export type ListSessionsForPickPastEventsQueryVariables = Exact<{
  filter?: InputMaybe<SessionFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<SessionSort> | SessionSort>;
}>;


export type ListSessionsForPickPastEventsQuery = { __typename?: 'Query', sessions: { __typename?: 'SessionConnection', nodes: Array<{ __typename?: 'Session', id: string, workspaceId: string, templateId?: string | null, name: string, shortName?: string | null, startsAt?: string | null, endsAt?: string | null, duration: number, attendees: number, status: SessionStatus, timezone: string, type: SessionType, remote: boolean, irl: boolean, hybrid: boolean, isEscapeRoom: boolean, isMysteryExpress: boolean, packageLevel: PackageLevel, lobby: boolean, playType?: PlayType | null, language?: string | null, startDate?: Date | null, endDate?: Date | null, creationType: SessionCreationType, freeReschedule: boolean, pastEventsDetails?: string | null, futureEventsDetails?: string | null, internalNotes?: string | null, activityNotes?: string | null, integrations: Array<{ __typename?: 'SessionIntegration', id: string, integrationId: string, type: IntegrationType, url?: string | null, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, experience?: { __typename?: 'Experience', id: string } | null, modifiers: Array<{ __typename?: 'Modifier', id: string }>, createdBy?: { __typename?: 'User', id: string } | null, files: Array<{ __typename?: 'File', id: string }>, missionSet?: { __typename?: 'MissionSet', id: string } | null, contact?: { __typename?: 'User', id: string, fullName: string } | null }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type SessionAssignmentForStaffAssignmentFragment = { __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null };

export type SessionForShowFragment = { __typename?: 'Session', preview?: string | null, city?: string | null, gameZoneId?: string | null, scheduled: boolean, upcoming: boolean, complete: boolean, assignability: SessionAssignability, size: number, diy: boolean, hasGroupDetails: boolean, vas: boolean, hasGroup: boolean, hasBreadcrumbIntegration: boolean, priceZone?: Credit | null, credits: number, createdDate: Date, hasUpgrade: boolean, links: Map<IntegrationType, string>, locateable: boolean, isTravelable: boolean, isApprovable: boolean, wrapUpEmailSentAt?: string | null, id: string, workspaceId: string, templateId?: string | null, name: string, shortName?: string | null, startsAt?: string | null, endsAt?: string | null, duration: number, attendees: number, status: SessionStatus, timezone: string, type: SessionType, remote: boolean, irl: boolean, hybrid: boolean, isEscapeRoom: boolean, isMysteryExpress: boolean, packageLevel: PackageLevel, lobby: boolean, playType?: PlayType | null, language?: string | null, startDate?: Date | null, endDate?: Date | null, creationType: SessionCreationType, freeReschedule: boolean, pastEventsDetails?: string | null, futureEventsDetails?: string | null, internalNotes?: string | null, activityNotes?: string | null, gameZoneDescription?: string | null, locationDetails?: string | null, supportsGameZone: boolean, hostType: HostType, scheduleOffset: number, teams: number, supportsPrizes: boolean, onScreen: boolean, syncType: SyncType, pdfType?: PdfType | null, createdAt: string, isLobbyEligible: boolean, emailRegexPattern?: string | null, modifications: Array<string>, isCustomizable: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }>, hosts: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null }>, experience?: { __typename?: 'Experience', id: string, title: string, category: ExperienceCategory } | null, files: Array<{ __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType }>, contact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, bookingContact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, additionalBookingContacts: Array<{ __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null }>, group?: { __typename?: 'SessionGroup', id: string, name: string } | null, producer?: { __typename?: 'User', id: string } | null, producers: Array<{ __typename?: 'User', id: string }>, integrations: Array<{ __typename?: 'SessionIntegration', id: string, type: IntegrationType, url?: string | null, integrationId: string, syncedAt?: string | null, active: boolean, attributes: { __typename?: 'SessionIntegrationAttributes', password?: string | null, code?: string | null } }>, createdBy?: { __typename?: 'User', id: string, fullName: string } | null, missionSet?: { __typename?: 'MissionSet', id: string } | null, gameZone?: { __typename?: 'GameZone', id: string, point: { type: 'Point', coordinates: [lng: number, lat: number] }, hull: Array<{ type: 'Point', coordinates: [lng: number, lat: number] }> } | null, locations: Array<{ __typename?: 'SessionLocation', id: string, type: SessionLocationType, location: { __typename?: 'Location', venueId?: string | null, id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }>, venue?: { __typename?: 'SessionVenueContacts', name?: string | null, email?: string | null, phone?: string | null, details?: string | null } | null, timeline: { __typename?: 'Timeline', outdated?: boolean | null, items?: Array<{ __typename?: 'TimelineItem', id: string, time: string, description: string }> | null }, relations: Array<{ __typename?: 'SessionRelation', id: string, type: SessionRelationType }>, meta: { __typename?: 'SessionMeta', kitBased?: boolean | null, attendees?: boolean | null, gameControl?: boolean | null, template?: SessionTemplateType | null, actors?: boolean | null, vas?: boolean | null, lodging?: boolean | null, corporateActor?: boolean | null, permissions?: boolean | null, phoneSource?: PhoneSource | null, group?: { __typename?: 'SessionGroupDetails', playedPreviously?: string | null, multiSession?: string | null, multicultural?: string | null, young?: string | null, familiar?: string | null, sameLocation?: string | null, hasPreviousEvent?: string | null, previousEventDetails?: string | null, hasNextEvent?: string | null, nextEventUrl?: string | null, departments?: string | null, attendeesDetails?: string | null, eventDetails?: string | null, teamsOrigin?: string | null, teamsDetails?: string | null, prizesOrigin?: string | null, prizesShippingAddress?: string | null, food?: string | null, alcohol?: string | null, av?: Array<string> | null, avDetails?: string | null, age?: string | null, rating?: string | null, bar?: string | null, description?: string | null, mobility?: string | null } | null }, instructions: Array<{ __typename?: 'Instruction', id: string, type: PdfType, documentType: SessionDocument, title?: string | null, description?: string | null }>, sourceSession?: { __typename?: 'Session', id: string } | null, supportsSlots: { __typename?: 'SupportsSlots', customer: boolean, staff: boolean }, supportsUpgrade: { __typename?: 'SessionSupportsUpgrade', customer: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null }, staff: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null } }, restrictions: { __typename?: 'SessionRestrictions', attendees: number } };

export type SessionWithGroupFragment = { __typename?: 'Session', id: string, group?: { __typename?: 'SessionGroup', id: string, name: string } | null };

export type SetSessionBookingContactMutationVariables = Exact<{
  input: SetBookingContactOnSessionInput;
}>;


export type SetSessionBookingContactMutation = { __typename?: 'Mutation', setBookingContactOnSession: { __typename?: 'Session', id: string, bookingContact?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null } };

export type SetUserOnSessionAssignmentForStaffAssignmentMutationVariables = Exact<{
  input: SetUserOnSessionAssignmentInput;
}>;


export type SetUserOnSessionAssignmentForStaffAssignmentMutation = { __typename?: 'Mutation', setUserOnSessionAssignment: { __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, userId?: string | null, order: number, travel?: { start: string, end: string } | null, travelConfirmed?: boolean | null, rating?: number | null, user?: { __typename?: 'User', id: string, fullName: string, email: string, phone?: string | null, avatar?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, fullName: string } | null, approval?: { __typename?: 'AssignmentApproval', id: string, state: AssignmentApprovalState } | null } };

export type GetSessionWithSchedulingDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionWithSchedulingDataQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, startsAt?: string | null, startDate?: Date | null, endsAt?: string | null, endDate?: Date | null, duration: number, scheduleOffset: number, timezone: string, lobby: boolean, size: number, assignability: SessionAssignability, timeline: { __typename?: 'Timeline', outdated?: boolean | null, items?: Array<{ __typename?: 'TimelineItem', id: string, time: string, description: string }> | null }, lawnSchedule?: { __typename?: 'LawnSchedule', id: string, break: boolean, breakDuration: number, roundBreakDuration: number, startOffset: number, endOffset: number, list: string, missions: Array<{ __typename?: 'BreadcrumbMission', id: string, name: string }>, tournament: { __typename?: 'Tournament', break?: { __typename?: 'TournamentBreak', afterRound: number, endsAt: string, startsAt: string } | null, rounds: Array<{ __typename?: 'TournamentRound', endsAt?: string | null, round: number, startsAt?: string | null, teams?: Array<Array<string>> | null }> } } | null, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, travel?: { start: string, end: string } | null, user?: { __typename?: 'User', id: string, fullName: string } | null }>, restrictions: { __typename?: 'SessionRestrictions', attendees: number }, supportsUpgrade: { __typename?: 'SessionSupportsUpgrade', customer: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null }, staff: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null } } } | null };

export type SessionWithSchedulingDataFragment = { __typename?: 'Session', id: string, startsAt?: string | null, startDate?: Date | null, endsAt?: string | null, endDate?: Date | null, duration: number, scheduleOffset: number, timezone: string, lobby: boolean, size: number, assignability: SessionAssignability, timeline: { __typename?: 'Timeline', outdated?: boolean | null, items?: Array<{ __typename?: 'TimelineItem', id: string, time: string, description: string }> | null }, lawnSchedule?: { __typename?: 'LawnSchedule', id: string, break: boolean, breakDuration: number, roundBreakDuration: number, startOffset: number, endOffset: number, list: string, missions: Array<{ __typename?: 'BreadcrumbMission', id: string, name: string }>, tournament: { __typename?: 'Tournament', break?: { __typename?: 'TournamentBreak', afterRound: number, endsAt: string, startsAt: string } | null, rounds: Array<{ __typename?: 'TournamentRound', endsAt?: string | null, round: number, startsAt?: string | null, teams?: Array<Array<string>> | null }> } } | null, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, type: AssignmentType, travel?: { start: string, end: string } | null, user?: { __typename?: 'User', id: string, fullName: string } | null }>, restrictions: { __typename?: 'SessionRestrictions', attendees: number }, supportsUpgrade: { __typename?: 'SessionSupportsUpgrade', customer: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null }, staff: { __typename?: 'SessionSupportsUpgradeDefinition', value: boolean, reason?: SessionUpgradeNotAlowedReason | null } } };

export type ListExperiencesForCategoryQueryVariables = Exact<{
  category: ExperienceCategory;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListExperiencesForCategoryQuery = { __typename?: 'Query', experiences: { __typename?: 'ExperienceConnection', nodes: Array<{ __typename?: 'Experience', id: string, title: string, subtitle?: string | null, description?: string | null, position: number, status?: ExperienceStatus | null, category: ExperienceCategory, tags: Array<string>, types: Array<ExperienceFormatType>, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null }> } };

export type ExperienceForExperienceCardFragment = { __typename?: 'Experience', id: string, title: string, subtitle?: string | null, description?: string | null, visible: boolean, bookable: boolean, subscribers: boolean, position: number, type: ExperienceType, category: ExperienceCategory, status?: ExperienceStatus | null, tier?: number | null, tags: Array<string>, url?: string | null, types: Array<ExperienceFormatType>, updatedAt: string, updatedDate: Date, featured?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, thumbnail?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, banner?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, overview: { __typename?: 'ExperienceOverview', titleTag?: string | null, description?: string | null, cost?: string | null, path?: string | null, attendees?: number | null, label?: string | null, youtube?: string | null, keywords?: Array<string> | null, url?: string | null, features?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, feedbacks?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, studies?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, customizations?: Array<{ __typename?: 'ExperienceCustomization', title: string, description: string, notes: string }> | null }, formats: Array<{ __typename?: 'ExperienceFormat', locatable: boolean, id: string, type: ExperienceFormatType, hostType: HostType, pdfType?: PdfType | null, title: string, subtitle?: string | null, description?: string | null, formatDescription?: string | null, hostDescription?: string | null, minDuration?: number | null, duration: number, maxDuration?: number | null, lobby?: boolean | null, kitBased?: boolean | null, syncType: SyncType, playType?: PlayType | null, templateId?: string | null, template: SessionTemplateType, youtube?: string | null, settings: { __typename?: 'ExperienceFormatSettings', customization?: Array<{ __typename?: 'ExperienceFormatCustomization', type: PackageLevel, description?: string | null }> | null }, media?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> }>, attributes: { __typename?: 'ExperienceAttributes', gCalPrefix?: string | null, hubSpotDisabled?: boolean | null, webSiteDisabled?: boolean | null, quoteDisabled?: boolean | null } };

export type ExperienceFormatForExperienceCardFragment = { __typename?: 'ExperienceFormat', locatable: boolean, id: string, type: ExperienceFormatType, hostType: HostType, pdfType?: PdfType | null, title: string, subtitle?: string | null, description?: string | null, formatDescription?: string | null, hostDescription?: string | null, minDuration?: number | null, duration: number, maxDuration?: number | null, lobby?: boolean | null, kitBased?: boolean | null, syncType: SyncType, playType?: PlayType | null, templateId?: string | null, template: SessionTemplateType, youtube?: string | null, settings: { __typename?: 'ExperienceFormatSettings', customization?: Array<{ __typename?: 'ExperienceFormatCustomization', type: PackageLevel, description?: string | null }> | null }, media?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> };

export type GetExperienceForExperienceCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExperienceForExperienceCardQuery = { __typename?: 'Query', experience: { __typename?: 'Experience', id: string, title: string, subtitle?: string | null, description?: string | null, visible: boolean, bookable: boolean, subscribers: boolean, position: number, type: ExperienceType, category: ExperienceCategory, status?: ExperienceStatus | null, tier?: number | null, tags: Array<string>, url?: string | null, types: Array<ExperienceFormatType>, updatedAt: string, updatedDate: Date, featured?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, thumbnail?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, banner?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, overview: { __typename?: 'ExperienceOverview', titleTag?: string | null, description?: string | null, cost?: string | null, path?: string | null, attendees?: number | null, label?: string | null, youtube?: string | null, keywords?: Array<string> | null, url?: string | null, features?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, feedbacks?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, studies?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, customizations?: Array<{ __typename?: 'ExperienceCustomization', title: string, description: string, notes: string }> | null }, formats: Array<{ __typename?: 'ExperienceFormat', locatable: boolean, id: string, type: ExperienceFormatType, hostType: HostType, pdfType?: PdfType | null, title: string, subtitle?: string | null, description?: string | null, formatDescription?: string | null, hostDescription?: string | null, minDuration?: number | null, duration: number, maxDuration?: number | null, lobby?: boolean | null, kitBased?: boolean | null, syncType: SyncType, playType?: PlayType | null, templateId?: string | null, template: SessionTemplateType, youtube?: string | null, settings: { __typename?: 'ExperienceFormatSettings', customization?: Array<{ __typename?: 'ExperienceFormatCustomization', type: PackageLevel, description?: string | null }> | null }, media?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> }>, attributes: { __typename?: 'ExperienceAttributes', gCalPrefix?: string | null, hubSpotDisabled?: boolean | null, webSiteDisabled?: boolean | null, quoteDisabled?: boolean | null } } };

export type ExperienceFormatForTileFragment = { __typename?: 'ExperienceFormat', id: string, title: string, type: ExperienceFormatType, hostType: HostType };

export type CopyExperienceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CopyExperienceMutation = { __typename?: 'Mutation', copyExperience: { __typename?: 'Experience', id: string, title: string, subtitle?: string | null, description?: string | null, visible: boolean, bookable: boolean, subscribers: boolean, position: number, type: ExperienceType, category: ExperienceCategory, status?: ExperienceStatus | null, tier?: number | null, tags: Array<string>, url?: string | null, types: Array<ExperienceFormatType>, updatedAt: string, updatedDate: Date, featured?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, thumbnail?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, banner?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, overview: { __typename?: 'ExperienceOverview', titleTag?: string | null, description?: string | null, cost?: string | null, path?: string | null, attendees?: number | null, label?: string | null, youtube?: string | null, keywords?: Array<string> | null, url?: string | null, features?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, feedbacks?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, studies?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, customizations?: Array<{ __typename?: 'ExperienceCustomization', title: string, description: string, notes: string }> | null }, formats: Array<{ __typename?: 'ExperienceFormat', locatable: boolean, id: string, type: ExperienceFormatType, hostType: HostType, pdfType?: PdfType | null, title: string, subtitle?: string | null, description?: string | null, formatDescription?: string | null, hostDescription?: string | null, minDuration?: number | null, duration: number, maxDuration?: number | null, lobby?: boolean | null, kitBased?: boolean | null, syncType: SyncType, playType?: PlayType | null, templateId?: string | null, template: SessionTemplateType, youtube?: string | null, settings: { __typename?: 'ExperienceFormatSettings', customization?: Array<{ __typename?: 'ExperienceFormatCustomization', type: PackageLevel, description?: string | null }> | null }, media?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> }>, attributes: { __typename?: 'ExperienceAttributes', gCalPrefix?: string | null, hubSpotDisabled?: boolean | null, webSiteDisabled?: boolean | null, quoteDisabled?: boolean | null } } };

export type CreateExperienceFormatMutationVariables = Exact<{
  input: CreateExperienceFormatInput;
}>;


export type CreateExperienceFormatMutation = { __typename?: 'Mutation', createExperienceFormat: { __typename?: 'ExperienceFormat', locatable: boolean, id: string, type: ExperienceFormatType, hostType: HostType, pdfType?: PdfType | null, title: string, subtitle?: string | null, description?: string | null, formatDescription?: string | null, hostDescription?: string | null, minDuration?: number | null, duration: number, maxDuration?: number | null, lobby?: boolean | null, kitBased?: boolean | null, syncType: SyncType, playType?: PlayType | null, templateId?: string | null, template: SessionTemplateType, youtube?: string | null, settings: { __typename?: 'ExperienceFormatSettings', customization?: Array<{ __typename?: 'ExperienceFormatCustomization', type: PackageLevel, description?: string | null }> | null }, media?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> } };

export type DeleteExperienceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExperienceMutation = { __typename?: 'Mutation', deleteExperience: boolean };

export type UpdateExperienceMutationVariables = Exact<{
  input: UpdateOneExperienceInput;
}>;


export type UpdateExperienceMutation = { __typename?: 'Mutation', updateExperience: { __typename?: 'Experience', id: string, title: string, subtitle?: string | null, description?: string | null, visible: boolean, bookable: boolean, subscribers: boolean, position: number, category: ExperienceCategory, status?: ExperienceStatus | null, tags: Array<string>, tier?: number | null, attributes: { __typename?: 'ExperienceAttributes', gCalPrefix?: string | null, hubSpotDisabled?: boolean | null, webSiteDisabled?: boolean | null }, overview: { __typename?: 'ExperienceOverview', titleTag?: string | null, description?: string | null, cost?: string | null, path?: string | null, attendees?: number | null, label?: string | null, youtube?: string | null, keywords?: Array<string> | null, url?: string | null, features?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, feedbacks?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null, studies?: Array<{ __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null }> | null } } };

export type DeleteExperienceFormatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExperienceFormatMutation = { __typename?: 'Mutation', deleteExperienceFormat: { __typename?: 'ExperienceFormatDeleteResponse', id?: string | null } };

export type ExperienceForEditExperienceFormatFragment = { __typename?: 'Experience', id: string, title: string, bookable: boolean };

export type ExperienceFormatForEditFragment = { __typename?: 'ExperienceFormat', id: string, type: ExperienceFormatType, hostType: HostType, pdfType?: PdfType | null, title: string, subtitle?: string | null, description?: string | null, formatDescription?: string | null, hostDescription?: string | null, minDuration?: number | null, duration: number, maxDuration?: number | null, lobby?: boolean | null, kitBased?: boolean | null, syncType: SyncType, playType?: PlayType | null, templateId?: string | null, template: SessionTemplateType, youtube?: string | null, settings: { __typename?: 'ExperienceFormatSettings', customization?: Array<{ __typename?: 'ExperienceFormatCustomization', type: PackageLevel, description?: string | null }> | null }, media?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> };

export type UpdateExperienceFormatMutationVariables = Exact<{
  input: UpdateOneExperienceFormatInput;
}>;


export type UpdateExperienceFormatMutation = { __typename?: 'Mutation', updateExperienceFormat: { __typename?: 'ExperienceFormat', id: string, type: ExperienceFormatType, hostType: HostType, pdfType?: PdfType | null, title: string, subtitle?: string | null, description?: string | null, formatDescription?: string | null, hostDescription?: string | null, minDuration?: number | null, duration: number, maxDuration?: number | null, lobby?: boolean | null, kitBased?: boolean | null, syncType: SyncType, playType?: PlayType | null, templateId?: string | null, template: SessionTemplateType, youtube?: string | null, settings: { __typename?: 'ExperienceFormatSettings', customization?: Array<{ __typename?: 'ExperienceFormatCustomization', type: PackageLevel, description?: string | null }> | null }, media?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }> } };

export type ExperienceFormatWithMediaFragment = { __typename?: 'ExperienceFormat', id: string, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, media?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null };

export type ExperienceWithMediaFragment = { __typename?: 'Experience', id: string, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, featured?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, thumbnail?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, poster?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null, banner?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null };

export type ExperienceWithCustomizationFragment = { __typename?: 'Experience', id: string, overview: { __typename?: 'ExperienceOverview', customizations?: Array<{ __typename?: 'ExperienceCustomization', title: string, description: string, notes: string }> | null } };

export type ExperienceForLegacyExperienceViewCardFragment = { __typename?: 'Experience', id: string, type: ExperienceType, title: string, subtitle?: string | null, description?: string | null, bookable: boolean, formats: Array<{ __typename?: 'ExperienceFormat', id: string, type: ExperienceFormatType, hostType: HostType, duration: number }>, overview: { __typename?: 'ExperienceOverview', url?: string | null } };

export type CreateExperienceForListMutationVariables = Exact<{
  input: CreateExperienceInput;
}>;


export type CreateExperienceForListMutation = { __typename?: 'Mutation', createExperience: { __typename?: 'Experience', id: string, title: string, subtitle?: string | null, description?: string | null, position: number, status?: ExperienceStatus | null, category: ExperienceCategory, tags: Array<string>, types: Array<ExperienceFormatType>, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null } };

export type ExperienceForListFragment = { __typename?: 'Experience', id: string, title: string, subtitle?: string | null, description?: string | null, position: number, status?: ExperienceStatus | null, category: ExperienceCategory, tags: Array<string>, types: Array<ExperienceFormatType>, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null };

export type ExperienceForHeroFragment = { __typename?: 'Experience', id: string, title: string, description?: string | null, position: number, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null };

export type ExperienceOverviewItemFragment = { __typename?: 'ExperienceOverviewItem', title?: string | null, subtitle?: string | null, body?: string | null, image?: string | null, imageId?: string | null };

export type ListExperiencesQueryVariables = Exact<{
  filter?: InputMaybe<ExperienceFilter>;
}>;


export type ListExperiencesQuery = { __typename?: 'Query', experiences: { __typename?: 'ExperienceConnection', nodes: Array<{ __typename?: 'Experience', id: string, title: string, subtitle?: string | null, description?: string | null, position: number, status?: ExperienceStatus | null, category: ExperienceCategory, tags: Array<string>, types: Array<ExperienceFormatType>, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null }> } };

export type ListOrdersForOrdersListQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListOrdersForOrdersListQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', nodes: Array<{ __typename?: 'Order', id: string, dealId?: string | null, url?: string | null, subscription: boolean, paidAt: string, createdAt: string, paidDate: Date, createdDate: Date, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number, unitPrice: number, discount: number, consumable: { __typename?: 'Consumable', id: number, name: ConsumableName } }>, createdBy?: { __typename?: 'User', id: string, fullName: string } | null }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type OrderForOrderListItemFragment = { __typename?: 'Order', id: string, dealId?: string | null, url?: string | null, subscription: boolean, paidAt: string, createdAt: string, paidDate: Date, createdDate: Date, items: Array<{ __typename?: 'OrderItem', id: string, quantity: number, unitPrice: number, discount: number, consumable: { __typename?: 'Consumable', id: number, name: ConsumableName } }>, createdBy?: { __typename?: 'User', id: string, fullName: string } | null };

export type OrderItemForOrderListFragment = { __typename?: 'OrderItem', id: string, quantity: number, unitPrice: number, discount: number, consumable: { __typename?: 'Consumable', id: number, name: ConsumableName } };

export type GetSessionForWorkspaceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionForWorkspaceQuery = { __typename?: 'Query', session?: { __typename?: 'Session', id: string, workspaceId: string } | null };

export type SessionForWorkspaceFragment = { __typename?: 'Session', id: string, workspaceId: string };

export type GetOpenWeveForOpenWeveCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOpenWeveForOpenWeveCardQuery = { __typename?: 'Query', openWeve?: { __typename?: 'OpenWeve', id: string, title: string, subtitle: string, description: string, url: string } | null };

export type OpenWeveForOpenWeveCardFragment = { __typename?: 'OpenWeve', id: string, title: string, subtitle: string, description: string, url: string };

export type OpenWeveForEditFragment = { __typename?: 'OpenWeve', id: string, title: string, subtitle: string, description: string };

export type UpdateOpenWeveMutationVariables = Exact<{
  input: UpdateOpenWeveInput;
}>;


export type UpdateOpenWeveMutation = { __typename?: 'Mutation', updateOpenWeve: { __typename?: 'OpenWeve', id: string, title: string, subtitle: string, description: string } };

export type OpenWeveForViewFragment = { __typename?: 'OpenWeve', id: string, title: string, subtitle: string, description: string, url: string };

export type CreateOpenWeveForListMutationVariables = Exact<{
  input: CreateOpenWeveInput;
}>;


export type CreateOpenWeveForListMutation = { __typename?: 'Mutation', createOpenWeve: { __typename?: 'OpenWeve', id: string, title: string } };

export type DeleteOpenWeveMutationVariables = Exact<{
  input: DeleteOpenWeveInput;
}>;


export type DeleteOpenWeveMutation = { __typename?: 'Mutation', deleteOpenWeve: { __typename?: 'OpenWeve', id: string } };

export type ListOpenWevesQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListOpenWevesQuery = { __typename?: 'Query', openWeves: { __typename?: 'OpenWeveConnection', nodes: Array<{ __typename?: 'OpenWeve', id: string, title: string }> } };

export type OpenWeveForListFragment = { __typename?: 'OpenWeve', id: string, title: string };

export type GetSessionForSessionGroupPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionForSessionGroupPageQuery = { __typename?: 'Query', sessionGroup?: { __typename?: 'SessionGroup', id: string, name: string, image?: { __typename?: 'File', id: string, src: string } | null, sessions: Array<{ __typename?: 'Session', id: string, name: string, shortName?: string | null, type: SessionType, hostType: HostType, attendees: number, size: number, status: SessionStatus, startsAt?: string | null, startDate?: Date | null, endsAt?: string | null, endDate?: Date | null, timezone: string, locateable: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, experience?: { __typename?: 'Experience', id: string, title: string } | null, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, user?: { __typename?: 'User', id: string, fullName: string, avatar?: string | null } | null }>, hosts: Array<{ __typename?: 'SessionAssignment', id: string, user?: { __typename?: 'User', id: string, fullName: string, avatar?: string | null } | null }>, locations: Array<{ __typename?: 'SessionLocation', id: string, type: SessionLocationType, location: { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }> }>, experience?: { __typename?: 'Experience', id: string, title: string } | null } | null };

export type SessionForSessionGroupPageFragment = { __typename?: 'Session', id: string, name: string, shortName?: string | null, type: SessionType, hostType: HostType, attendees: number, size: number, status: SessionStatus, startsAt?: string | null, startDate?: Date | null, endsAt?: string | null, endDate?: Date | null, timezone: string, locateable: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, experience?: { __typename?: 'Experience', id: string, title: string } | null, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, user?: { __typename?: 'User', id: string, fullName: string, avatar?: string | null } | null }>, hosts: Array<{ __typename?: 'SessionAssignment', id: string, user?: { __typename?: 'User', id: string, fullName: string, avatar?: string | null } | null }>, locations: Array<{ __typename?: 'SessionLocation', id: string, type: SessionLocationType, location: { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }> };

export type SessionGroupForSessionGroupPageFragment = { __typename?: 'SessionGroup', id: string, name: string, image?: { __typename?: 'File', id: string, src: string } | null, sessions: Array<{ __typename?: 'Session', id: string, name: string, shortName?: string | null, type: SessionType, hostType: HostType, attendees: number, size: number, status: SessionStatus, startsAt?: string | null, startDate?: Date | null, endsAt?: string | null, endDate?: Date | null, timezone: string, locateable: boolean, modifiers: Array<{ __typename?: 'Modifier', id: string, label: string }>, experience?: { __typename?: 'Experience', id: string, title: string } | null, assignments: Array<{ __typename?: 'SessionAssignment', id: string, role: SessionRole, user?: { __typename?: 'User', id: string, fullName: string, avatar?: string | null } | null }>, hosts: Array<{ __typename?: 'SessionAssignment', id: string, user?: { __typename?: 'User', id: string, fullName: string, avatar?: string | null } | null }>, locations: Array<{ __typename?: 'SessionLocation', id: string, type: SessionLocationType, location: { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }> }>, experience?: { __typename?: 'Experience', id: string, title: string } | null };

export type AiPromptForAdminSettingsFragment = { __typename?: 'AiPrompt', id: string, name: string, model: OpenAiModel, prompt: string, webhookUrl?: string | null };

export type AiPromptForListForAdminSettingsFragment = { __typename?: 'AiPrompt', id: string, name: string };

export type CreateAiPromptMutationVariables = Exact<{
  input: CreateOneAiPromptInput;
}>;


export type CreateAiPromptMutation = { __typename?: 'Mutation', createAiPrompt: { __typename?: 'AiPrompt', id: string, name: string, model: OpenAiModel, prompt: string, webhookUrl?: string | null } };

export type DeleteAiPromptMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAiPromptMutation = { __typename?: 'Mutation', deleteAiPrompt: { __typename?: 'AiPromptDeleteResponse', id?: string | null } };

export type GetAiPromptForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAiPromptForEditQuery = { __typename?: 'Query', aiPrompt?: { __typename?: 'AiPrompt', id: string, name: string, model: OpenAiModel, prompt: string, webhookUrl?: string | null } | null };

export type ListAiPromptsQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListAiPromptsQuery = { __typename?: 'Query', aiPrompts: { __typename?: 'AiPromptConnection', nodes: Array<{ __typename?: 'AiPrompt', id: string, name: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null } } };

export type UpdateAiPromptMutationVariables = Exact<{
  input: UpdateOneAiPromptInput;
}>;


export type UpdateAiPromptMutation = { __typename?: 'Mutation', updateAiPrompt: { __typename?: 'AiPrompt', id: string, name: string, model: OpenAiModel, prompt: string, webhookUrl?: string | null } };

export type CreateInstructionMutationVariables = Exact<{
  input: CreateOneInstructionInput;
}>;


export type CreateInstructionMutation = { __typename?: 'Mutation', createInstruction: { __typename?: 'Instruction', id: string, type: PdfType, hosts: Array<HostType>, documentType: SessionDocument, content: string, description?: string | null, title?: string | null } };

export type GetInstructionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInstructionQuery = { __typename?: 'Query', instruction?: { __typename?: 'Instruction', id: string, type: PdfType, hosts: Array<HostType>, documentType: SessionDocument, content: string, description?: string | null, title?: string | null } | null };

export type ListInstructionsQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListInstructionsQuery = { __typename?: 'Query', instructions: { __typename?: 'InstructionConnection', nodes: Array<{ __typename?: 'Instruction', id: string, type: PdfType, documentType: SessionDocument }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null } } };

export type UpdateInstructionMutationVariables = Exact<{
  input: UpdateOneInstructionInput;
}>;


export type UpdateInstructionMutation = { __typename?: 'Mutation', updateInstruction: { __typename?: 'Instruction', id: string, type: PdfType, hosts: Array<HostType>, documentType: SessionDocument, content: string, description?: string | null } };

export type CreateModifierMutationVariables = Exact<{
  input: CreateModifierInput;
}>;


export type CreateModifierMutation = { __typename?: 'Mutation', createModifier: { __typename?: 'Modifier', id: string, label: string, description?: string | null } };

export type DeleteModifierMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteModifierMutation = { __typename?: 'Mutation', deleteModifier: { __typename?: 'ModifierDeleteResponse', id?: string | null } };

export type ListModifiersQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListModifiersQuery = { __typename?: 'Query', modifiers: { __typename?: 'ModifierConnection', nodes: Array<{ __typename?: 'Modifier', id: string, label: string, description?: string | null }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null } } };

export type ModifierForAdminSettingsFragment = { __typename?: 'Modifier', id: string, label: string, description?: string | null };

export type CreatePriceModifierMutationVariables = Exact<{
  input: CreateOnePriceModifierInput;
}>;


export type CreatePriceModifierMutation = { __typename?: 'Mutation', createPriceModifier: { __typename?: 'PriceModifier', id: string, dateRange: { start: string, end: string }, types: Array<SessionType>, percent: number } };

export type DeletePriceModifierMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePriceModifierMutation = { __typename?: 'Mutation', deletePriceModifier: { __typename?: 'PriceModifierDeleteResponse', id?: string | null } };

export type GetPriceModifierQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPriceModifierQuery = { __typename?: 'Query', priceModifier?: { __typename?: 'PriceModifier', id: string, dateRange: { start: string, end: string }, types: Array<SessionType>, percent: number } | null };

export type ListPriceModifierQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListPriceModifierQuery = { __typename?: 'Query', priceModifiers: { __typename?: 'PriceModifierConnection', nodes: Array<{ __typename?: 'PriceModifier', id: string, dateRange: { start: string, end: string }, types: Array<SessionType>, percent: number }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null } } };

export type PriceModifierForAdminSettingsFragment = { __typename?: 'PriceModifier', id: string, dateRange: { start: string, end: string }, types: Array<SessionType>, percent: number };

export type UpdatePriceModifierMutationVariables = Exact<{
  input: UpdateOnePriceModifierInput;
}>;


export type UpdatePriceModifierMutation = { __typename?: 'Mutation', updatePriceModifier: { __typename?: 'PriceModifier', id: string, dateRange: { start: string, end: string }, types: Array<SessionType>, percent: number } };

export type SessionPhoneForSessionPhoneFormFragment = { __typename?: 'SessionPhone', id: string, phone: string, sessionType: SessionType, hostType: HostType, packageLevel: PackageLevel };

export type CreateSessionPhoneMutationVariables = Exact<{
  input: CreateOneSessionPhoneInput;
}>;


export type CreateSessionPhoneMutation = { __typename?: 'Mutation', createSessionPhone: { __typename?: 'SessionPhone', id: string, phone: string, sessionType: SessionType, hostType: HostType, packageLevel: PackageLevel } };

export type DeleteSessionPhoneMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSessionPhoneMutation = { __typename?: 'Mutation', deleteSessionPhone: { __typename?: 'SessionPhoneDeleteResponse', id?: string | null } };

export type GetSessionPhoneForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionPhoneForEditQuery = { __typename?: 'Query', sessionPhone?: { __typename?: 'SessionPhone', id: string, phone: string, sessionType: SessionType, hostType: HostType, packageLevel: PackageLevel } | null };

export type ListSessionPhonesQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListSessionPhonesQuery = { __typename?: 'Query', sessionPhones: { __typename?: 'SessionPhoneConnection', nodes: Array<{ __typename?: 'SessionPhone', id: string, phone: string, sessionType: SessionType, hostType: HostType, packageLevel: PackageLevel }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null } } };

export type SessionPhoneForAdminSettingsFragment = { __typename?: 'SessionPhone', id: string, phone: string, sessionType: SessionType, hostType: HostType, packageLevel: PackageLevel };

export type UpdateSessionPhoneMutationVariables = Exact<{
  input: UpdateOneSessionPhoneInput;
}>;


export type UpdateSessionPhoneMutation = { __typename?: 'Mutation', updateSessionPhone: { __typename?: 'SessionPhone', id: string, phone: string, sessionType: SessionType, hostType: HostType, packageLevel: PackageLevel } };

export type ZoneAreaForZoneAreaFormFragment = { __typename?: 'ZoneArea', id: string, name: string, price: number, area: { type: 'Polygon', coordinates: [lng: number, lat: number][][] } };

export type CreateZoneAreaMutationVariables = Exact<{
  input: CreateZoneAreaInput;
}>;


export type CreateZoneAreaMutation = { __typename?: 'Mutation', createZoneArea: { __typename?: 'ZoneArea', id: string, name: string } };

export type DeleteZoneAreaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteZoneAreaMutation = { __typename?: 'Mutation', deleteZoneArea: { __typename?: 'ZoneAreaDeleteResponse', id?: string | null } };

export type GetZoneAreaForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetZoneAreaForEditQuery = { __typename?: 'Query', zoneArea?: { __typename?: 'ZoneArea', id: string, name: string, price: number, area: { type: 'Polygon', coordinates: [lng: number, lat: number][][] } } | null };

export type ListZoneAreasQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListZoneAreasQuery = { __typename?: 'Query', zoneAreas: { __typename?: 'ZoneAreaConnection', nodes: Array<{ __typename?: 'ZoneArea', id: string, name: string }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null } } };

export type UpdateZoneAreaMutationVariables = Exact<{
  input: UpdateOneZoneAreaInput;
}>;


export type UpdateZoneAreaMutation = { __typename?: 'Mutation', updateZoneArea: { __typename?: 'ZoneArea', id: string, name: string, price: number, area: { type: 'Polygon', coordinates: [lng: number, lat: number][][] } } };

export type ZoneAreaForAdminSettingsFragment = { __typename?: 'ZoneArea', id: string, name: string };

export type MeForProfileSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MeForProfileSettingsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, fullName: string, phone?: string | null, meetingLink?: string | null, attributes: { __typename?: 'UserAttributes', email?: string | null }, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null } };

export type UserForProfileSettingsFragment = { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, fullName: string, phone?: string | null, meetingLink?: string | null, attributes: { __typename?: 'UserAttributes', email?: string | null }, image?: { __typename?: 'File', id: string, src: string, name?: string | null, size?: number | null, mime?: string | null, type: MediaType } | null };

export type GetWorkspaceForSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorkspaceForSettingsQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, name: string, company?: string | null, notes?: string | null, content?: boolean | null, preferredEventProducerId?: string | null, preferredSalesId?: string | null, notifications?: boolean | null, settings: { __typename?: 'WorkspaceSettings', missions?: number | null } } | null };

export type UpdateWorkspaceMutationVariables = Exact<{
  input: UpdateWorkspaceInput;
}>;


export type UpdateWorkspaceMutation = { __typename?: 'Mutation', updateWorkspace: { __typename?: 'Workspace', id: string, name: string, company?: string | null, notifications?: boolean | null } };

export type UpdateWorkspaceStaffMutationVariables = Exact<{
  input: UpdateWorkspaceStaffInput;
}>;


export type UpdateWorkspaceStaffMutation = { __typename?: 'Mutation', updateWorkspaceStaff: { __typename?: 'Workspace', id: string, name: string, company?: string | null, notes?: string | null, content?: boolean | null, preferredEventProducerId?: string | null, preferredSalesId?: string | null, notifications?: boolean | null, settings: { __typename?: 'WorkspaceSettings', missions?: number | null } } };

export type WorkspaceForSettingsFragment = { __typename?: 'Workspace', id: string, name: string, company?: string | null, notes?: string | null, content?: boolean | null, preferredEventProducerId?: string | null, preferredSalesId?: string | null, notifications?: boolean | null, settings: { __typename?: 'WorkspaceSettings', missions?: number | null } };

export type CreateBookingUserForUserManagementFormMutationVariables = Exact<{
  input: CreateBookingUserInput;
}>;


export type CreateBookingUserForUserManagementFormMutation = { __typename?: 'Mutation', createBookingUser: { __typename?: 'User', id: string } };

export type CreatePlantForUserManagementFormMutationVariables = Exact<{
  input: CreatePlantInput;
}>;


export type CreatePlantForUserManagementFormMutation = { __typename?: 'Mutation', createPlant: { __typename?: 'User', id: string } };

export type CreateStaffUserForUserManagementFormMutationVariables = Exact<{
  input: CreateStaffUserInput;
}>;


export type CreateStaffUserForUserManagementFormMutation = { __typename?: 'Mutation', createStaffUser: { __typename?: 'User', id: string } };

export type UpdateUserForUserManagementFormMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserForUserManagementFormMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email: string, phone?: string | null, role: Role, permission: UserPermission, active: boolean, timezone?: string | null, languages: Array<string>, notes?: string | null, level: number, upgrades: Array<PackageLevel>, load?: number | null, lastLoggedInAt?: string | null, zoneAreaId?: string | null, birthYear?: number | null, unsubscribed?: boolean | null, meetingLink?: string | null, modifiers: Array<{ __typename?: 'Modifier', id: string }>, attributes: { __typename?: 'UserAttributes', email?: string | null }, location?: { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } | null } };

export type DeleteUserForUserManagementMutationVariables = Exact<{
  input: DeleteUserInput;
}>;


export type DeleteUserForUserManagementMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'DeleteUserDto', id: string } };

export type GetUserForUserManagementFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserForUserManagementFormQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email: string, phone?: string | null, role: Role, permission: UserPermission, active: boolean, timezone?: string | null, languages: Array<string>, notes?: string | null, level: number, upgrades: Array<PackageLevel>, load?: number | null, lastLoggedInAt?: string | null, zoneAreaId?: string | null, birthYear?: number | null, unsubscribed?: boolean | null, meetingLink?: string | null, modifiers: Array<{ __typename?: 'Modifier', id: string }>, attributes: { __typename?: 'UserAttributes', email?: string | null }, location?: { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } | null } | null };

export type ListUsersForUserManagementQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<OffsetPaging>;
  sorting?: InputMaybe<Array<UserSort> | UserSort>;
}>;


export type ListUsersForUserManagementQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', nodes: Array<{ __typename?: 'User', id: string, fullName: string, email: string, role: Role, permission: UserPermission, avatar?: string | null, lastAssignedAt?: string | null, permissions: Array<{ __typename?: 'Permission', id: string, workspace: { __typename?: 'Workspace', id: string, name: string } }> }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } };

export type UpdateUserForUserManagementMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserForUserManagementMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, fullName: string, email: string, role: Role, permission: UserPermission, avatar?: string | null, lastAssignedAt?: string | null, permissions: Array<{ __typename?: 'Permission', id: string, workspace: { __typename?: 'Workspace', id: string, name: string } }> } };

export type UserForUserManagementFragment = { __typename?: 'User', id: string, fullName: string, email: string, role: Role, permission: UserPermission, avatar?: string | null, lastAssignedAt?: string | null, permissions: Array<{ __typename?: 'Permission', id: string, workspace: { __typename?: 'Workspace', id: string, name: string } }> };

export type UserForUserManagementFormFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email: string, phone?: string | null, role: Role, permission: UserPermission, active: boolean, timezone?: string | null, languages: Array<string>, notes?: string | null, level: number, upgrades: Array<PackageLevel>, load?: number | null, lastLoggedInAt?: string | null, zoneAreaId?: string | null, birthYear?: number | null, unsubscribed?: boolean | null, meetingLink?: string | null, modifiers: Array<{ __typename?: 'Modifier', id: string }>, attributes: { __typename?: 'UserAttributes', email?: string | null }, location?: { __typename?: 'Location', id: string, placeId: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } | null };

export type CreateVenueForVenueManagementMutationVariables = Exact<{
  input: CreateOneVenueInput;
}>;


export type CreateVenueForVenueManagementMutation = { __typename?: 'Mutation', createVenue: { __typename?: 'Venue', id: string, name: string, rating: number, location: { __typename?: 'Location', id: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } } };

export type CreateVenueReviewMutationVariables = Exact<{
  input: CreateOneVenueReviewInput;
}>;


export type CreateVenueReviewMutation = { __typename?: 'Mutation', createVenueReview: { __typename?: 'VenueReview', id: string, rate: number, review: string, venueId: string, sessionId: string, createdById: string, media: Array<{ __typename?: 'File', id: string }> } };

export type CreateVenueReviewForVenuePageMutationVariables = Exact<{
  input: CreateOneVenueReviewInput;
}>;


export type CreateVenueReviewForVenuePageMutation = { __typename?: 'Mutation', createVenueReview: { __typename?: 'VenueReview', id: string, rate: number, review: string, venueId: string, createdAt: string, session: { __typename?: 'Session', id: string, shortName?: string | null }, createdBy: { __typename?: 'User', id: string, fullName: string, avatar?: string | null }, media: Array<{ __typename?: 'File', id: string, src: string, type: MediaType }> } };

export type DeleteVenueForVenueManagementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteVenueForVenueManagementMutation = { __typename?: 'Mutation', deleteVenue: { __typename?: 'VenueDeleteResponse', id?: string | null } };

export type DeleteVenueReviewForVenuePageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteVenueReviewForVenuePageMutation = { __typename?: 'Mutation', deleteVenueReview: { __typename?: 'VenueReviewDeleteResponse', id?: string | null } };

export type GetGameZoneForVenueManagementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetGameZoneForVenueManagementQuery = { __typename?: 'Query', gameZone?: { __typename?: 'GameZone', id: string, name: string, point: { type: 'Point', coordinates: [lng: number, lat: number] }, hull: Array<{ type: 'Point', coordinates: [lng: number, lat: number] }> } | null };

export type GetVenueForVenuePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVenueForVenuePageQuery = { __typename?: 'Query', venue?: { __typename?: 'Venue', description?: string | null, id: string, gameZoneId?: string | null, participantsMin: number, participantsMax: number, name: string, city: string, rating: number, nOfReviews: number, nOfEvents: number, private: boolean, location: { __typename?: 'Location', id: string, name: string, address: string, placeId: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } }, gameZone?: { __typename?: 'GameZone', id: string, name: string } | null } | null };

export type ListVenueReviewsForVenuePageQueryVariables = Exact<{
  filter: VenueReviewFilter;
  paging?: InputMaybe<OffsetPaging>;
}>;


export type ListVenueReviewsForVenuePageQuery = { __typename?: 'Query', venueReviews: { __typename?: 'VenueReviewConnection', nodes: Array<{ __typename?: 'VenueReview', id: string, rate: number, review: string, venueId: string, createdAt: string, session: { __typename?: 'Session', id: string, shortName?: string | null }, createdBy: { __typename?: 'User', id: string, fullName: string, avatar?: string | null }, media: Array<{ __typename?: 'File', id: string, src: string, type: MediaType }> }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null } } };

export type ListVenuesForVenueManagementQueryVariables = Exact<{
  paging?: InputMaybe<OffsetPaging>;
  filter?: InputMaybe<VenueFilter>;
  sorting?: InputMaybe<Array<VenueSort> | VenueSort>;
}>;


export type ListVenuesForVenueManagementQuery = { __typename?: 'Query', venues: { __typename?: 'VenueConnection', nodes: Array<{ __typename?: 'Venue', id: string, name: string, rating: number, location: { __typename?: 'Location', id: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage?: boolean | null } } };

export type UpdateVenueForVenuePageMutationVariables = Exact<{
  input: UpdateOneVenueInput;
}>;


export type UpdateVenueForVenuePageMutation = { __typename?: 'Mutation', updateVenue: { __typename?: 'Venue', description?: string | null, id: string, gameZoneId?: string | null, participantsMin: number, participantsMax: number, name: string, city: string, rating: number, nOfReviews: number, nOfEvents: number, private: boolean, location: { __typename?: 'Location', id: string, name: string, address: string, placeId: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } }, gameZone?: { __typename?: 'GameZone', id: string, name: string } | null } };

export type UpdateVenueReviewMutationVariables = Exact<{
  input: UpdateOneVenueReviewInput;
}>;


export type UpdateVenueReviewMutation = { __typename?: 'Mutation', updateVenueReview: { __typename?: 'VenueReview', id: string, rate: number, review: string, venueId: string, createdAt: string, session: { __typename?: 'Session', id: string, shortName?: string | null }, createdBy: { __typename?: 'User', id: string, fullName: string, avatar?: string | null }, media: Array<{ __typename?: 'File', id: string, src: string, type: MediaType }> } };

export type VenueForVenueManagementFragment = { __typename?: 'Venue', id: string, name: string, rating: number, location: { __typename?: 'Location', id: string, name: string, address: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } } };

export type VenueForVenuePageFragment = { __typename?: 'Venue', description?: string | null, id: string, gameZoneId?: string | null, participantsMin: number, participantsMax: number, name: string, city: string, rating: number, nOfReviews: number, nOfEvents: number, private: boolean, location: { __typename?: 'Location', id: string, name: string, address: string, placeId: string, point: { type: 'Point', coordinates: [lng: number, lat: number] } }, gameZone?: { __typename?: 'GameZone', id: string, name: string } | null };

export type VenueReviewForCreateVenueReviewFormFragment = { __typename?: 'VenueReview', id: string, rate: number, review: string, venueId: string, sessionId: string, createdById: string, media: Array<{ __typename?: 'File', id: string }> };

export type VenueReviewForUpdateVenueReviewFormFragment = { __typename?: 'VenueReview', id: string, rate: number, review: string, sessionId: string, media: Array<{ __typename?: 'File', id: string }> };

export type VenueReviewForVenuePageFragment = { __typename?: 'VenueReview', id: string, rate: number, review: string, venueId: string, createdAt: string, session: { __typename?: 'Session', id: string, shortName?: string | null }, createdBy: { __typename?: 'User', id: string, fullName: string, avatar?: string | null }, media: Array<{ __typename?: 'File', id: string, src: string, type: MediaType }> };

export const namedOperations = {
  Query: {
    GetWorkspaceForEventsSearchDropdown: 'GetWorkspaceForEventsSearchDropdown',
    GetOrderForEdit: 'GetOrderForEdit',
    ListExperiencesForExperienceMultiselect: 'ListExperiencesForExperienceMultiselect',
    GetExperienceForExperienceSelect: 'GetExperienceForExperienceSelect',
    ListExperiencesForExperienceSelect: 'ListExperiencesForExperienceSelect',
    ListGameCitiesForGameCitySelect: 'ListGameCitiesForGameCitySelect',
    ListGameZonesForGameZoneSelect: 'ListGameZonesForGameZoneSelect',
    ListMissionSetsForMissionSetSelect: 'ListMissionSetsForMissionSetSelect',
    ListSessionsForMissionSetMultiselect: 'ListSessionsForMissionSetMultiselect',
    ListModifiersForModifierMultiselect: 'ListModifiersForModifierMultiselect',
    ListPermissionsForPermissionsAssigner: 'ListPermissionsForPermissionsAssigner',
    ListUsersForPermissionsAssigner: 'ListUsersForPermissionsAssigner',
    ListUserPermissionsForPrimaryWorkspaceSelect: 'ListUserPermissionsForPrimaryWorkspaceSelect',
    listSuggestedVenues: 'listSuggestedVenues',
    ListSessionsForSessionSelect: 'ListSessionsForSessionSelect',
    GetTemplateForTemplateSelect: 'GetTemplateForTemplateSelect',
    ListTemplatesForTemplateSelect: 'ListTemplatesForTemplateSelect',
    ListUsersForUserMultiselect: 'ListUsersForUserMultiselect',
    GetUserForUserSelect: 'GetUserForUserSelect',
    ListUsersForUserSelect: 'ListUsersForUserSelect',
    ListPermissionsForWorkspaceAssigner: 'ListPermissionsForWorkspaceAssigner',
    ListWorkspacesForWorkspaceMultiselect: 'ListWorkspacesForWorkspaceMultiselect',
    ListWorkspacesForWorkspaceSelect: 'ListWorkspacesForWorkspaceSelect',
    getZoneAreaForSelect: 'getZoneAreaForSelect',
    listZoneAreasForSelect: 'listZoneAreasForSelect',
    GetWorkspaceWithConsumables: 'GetWorkspaceWithConsumables',
    ListSessionsForSearch: 'ListSessionsForSearch',
    GetExperienceFormatForExperienceFormatSelect: 'GetExperienceFormatForExperienceFormatSelect',
    ListExperienceFormatsForExperienceFormatSelect: 'ListExperienceFormatsForExperienceFormatSelect',
    GetExperienceFormatWithModifiers: 'GetExperienceFormatWithModifiers',
    SearchModifiers: 'SearchModifiers',
    GetUserForSessionTemplateSelect: 'GetUserForSessionTemplateSelect',
    GetSessionWithAssignments: 'GetSessionWithAssignments',
    GetSessionWithIntegrations: 'GetSessionWithIntegrations',
    ListUserAudio: 'ListUserAudio',
    GetWorkspaceForStore: 'GetWorkspaceForStore',
    Me: 'Me',
    GetSystem: 'GetSystem',
    GetSessionForShiftPlanningSession: 'GetSessionForShiftPlanningSession',
    GetExperienceForAvailabilityEvent: 'GetExperienceForAvailabilityEvent',
    GetUserForAvailability: 'GetUserForAvailability',
    ListGlobalUnavailabilities: 'ListGlobalUnavailabilities',
    ListGlobalUnavailabilitiesForShiftPlanning: 'ListGlobalUnavailabilitiesForShiftPlanning',
    ListSessionAssignmentForShiftPlanning: 'ListSessionAssignmentForShiftPlanning',
    ListSessionsForShiftPlanning: 'ListSessionsForShiftPlanning',
    ListUsersForShiftPlanning: 'ListUsersForShiftPlanning',
    GetWorkspaceForContentLibrary: 'GetWorkspaceForContentLibrary',
    listMissionSetsForContentLibrary: 'listMissionSetsForContentLibrary',
    listMissionsByMissionSet: 'listMissionsByMissionSet',
    GetWorkspaceForCustomization: 'GetWorkspaceForCustomization',
    ListMissionListsForGameMissionList: 'ListMissionListsForGameMissionList',
    ListBreadcrumbMissionsForSelect: 'ListBreadcrumbMissionsForSelect',
    GetLawnScheduleForShow: 'GetLawnScheduleForShow',
    ListUsersForPlantSelect: 'ListUsersForPlantSelect',
    GetSessionAssignmentForSessionAssignmentSelect: 'GetSessionAssignmentForSessionAssignmentSelect',
    GetBreadcrumbRealPlaythrough: 'GetBreadcrumbRealPlaythrough',
    GetSessionForRelationsDialog: 'GetSessionForRelationsDialog',
    GetUserForSessionHostSelect: 'GetUserForSessionHostSelect',
    GetSessionForShuffle: 'GetSessionForShuffle',
    GetSessionForStaffAssignmentDialog: 'GetSessionForStaffAssignmentDialog',
    GetSessionForShow: 'GetSessionForShow',
    ListSessionsForPickPastEvents: 'ListSessionsForPickPastEvents',
    GetSessionWithSchedulingData: 'GetSessionWithSchedulingData',
    ListExperiencesForCategory: 'ListExperiencesForCategory',
    GetExperienceForExperienceCard: 'GetExperienceForExperienceCard',
    ListExperiences: 'ListExperiences',
    ListOrdersForOrdersList: 'ListOrdersForOrdersList',
    GetSessionForWorkspace: 'GetSessionForWorkspace',
    GetOpenWeveForOpenWeveCard: 'GetOpenWeveForOpenWeveCard',
    ListOpenWeves: 'ListOpenWeves',
    GetSessionForSessionGroupPage: 'GetSessionForSessionGroupPage',
    GetAiPromptForEdit: 'GetAiPromptForEdit',
    ListAiPrompts: 'ListAiPrompts',
    GetInstruction: 'GetInstruction',
    ListInstructions: 'ListInstructions',
    ListModifiers: 'ListModifiers',
    GetPriceModifier: 'GetPriceModifier',
    ListPriceModifier: 'ListPriceModifier',
    GetSessionPhoneForEdit: 'GetSessionPhoneForEdit',
    ListSessionPhones: 'ListSessionPhones',
    GetZoneAreaForEdit: 'GetZoneAreaForEdit',
    ListZoneAreas: 'ListZoneAreas',
    MeForProfileSettings: 'MeForProfileSettings',
    GetWorkspaceForSettings: 'GetWorkspaceForSettings',
    GetUserForUserManagementForm: 'GetUserForUserManagementForm',
    ListUsersForUserManagement: 'ListUsersForUserManagement',
    GetGameZoneForVenueManagement: 'GetGameZoneForVenueManagement',
    GetVenueForVenuePage: 'GetVenueForVenuePage',
    ListVenueReviewsForVenuePage: 'ListVenueReviewsForVenuePage',
    ListVenuesForVenueManagement: 'ListVenuesForVenueManagement'
  },
  Mutation: {
    DeleteOrder: 'DeleteOrder',
    DeleteOrderItems: 'DeleteOrderItems',
    UpdateOrderItem: 'UpdateOrderItem',
    UpdateGalleryPassword: 'UpdateGalleryPassword',
    CreateManualOrder: 'CreateManualOrder',
    CreateGameZone: 'CreateGameZone',
    CreatePermissionForPermissionAssigner: 'CreatePermissionForPermissionAssigner',
    DeletePermissionForPermissionAssigner: 'DeletePermissionForPermissionAssigner',
    UpdatePrimaryPermission: 'UpdatePrimaryPermission',
    UpdateSessionHostType: 'UpdateSessionHostType',
    UpdateSessionType: 'UpdateSessionType',
    UpdateSessionSyncType: 'UpdateSessionSyncType',
    CreatePermissionForWorkspaceAssigner: 'CreatePermissionForWorkspaceAssigner',
    DeletePermissionForWorkspaceAssigner: 'DeletePermissionForWorkspaceAssigner',
    CreateMission: 'CreateMission',
    CreateMissionSet: 'CreateMissionSet',
    DeleteMission: 'DeleteMission',
    DeleteMissionSet: 'DeleteMissionSet',
    DeleteSession: 'DeleteSession',
    DeleteSystem: 'DeleteSystem',
    SetSystem: 'SetSystem',
    UpdateMission: 'UpdateMission',
    UpdateMissionPosition: 'UpdateMissionPosition',
    UpdateSession: 'UpdateSession',
    UpdateSessionAssignmentWithTravel: 'UpdateSessionAssignmentWithTravel',
    UpdateSessionAssignmentForStaff: 'UpdateSessionAssignmentForStaff',
    UpdateSessionAssignmentTravelConfirmationStatus: 'UpdateSessionAssignmentTravelConfirmationStatus',
    UpdateSessionImage: 'UpdateSessionImage',
    CreateUserAudio: 'CreateUserAudio',
    DeleteUserAudio: 'DeleteUserAudio',
    UpdateUserAudio: 'UpdateUserAudio',
    UpdateUserForStore: 'UpdateUserForStore',
    CreateAvailabilities: 'CreateAvailabilities',
    CreateGlobalUnavailabilities: 'CreateGlobalUnavailabilities',
    DeleteAvailabilities: 'DeleteAvailabilities',
    DeleteGlobalUnavailability: 'DeleteGlobalUnavailability',
    UpdateAvailability: 'UpdateAvailability',
    UpdateUserTimezone: 'UpdateUserTimezone',
    UpdateMissionSet: 'UpdateMissionSet',
    ResetCustomization: 'ResetCustomization',
    UpdateCustomization: 'UpdateCustomization',
    UpdateSessionForEventMediaAndDownloads: 'UpdateSessionForEventMediaAndDownloads',
    UpdateLawnSchedule: 'UpdateLawnSchedule',
    CreateUserForCreateNewPlantDialog: 'CreateUserForCreateNewPlantDialog',
    CreateMissionSetForSessionActivityDetails: 'CreateMissionSetForSessionActivityDetails',
    RemoveMissionSetFromSession: 'RemoveMissionSetFromSession',
    SetMissionSetOnSession: 'SetMissionSetOnSession',
    CreateUserForCreateNewUserDialog: 'CreateUserForCreateNewUserDialog',
    SetSessionContact: 'SetSessionContact',
    AddSessionModifiers: 'AddSessionModifiers',
    RemoveSessionModifiers: 'RemoveSessionModifiers',
    RemoveSourceSessionFromSession: 'RemoveSourceSessionFromSession',
    SetSourceSessionOnSession: 'SetSourceSessionOnSession',
    UpdateSessionForSessionDetails: 'UpdateSessionForSessionDetails',
    ActionEndRealPlaythrough: 'ActionEndRealPlaythrough',
    ActionMessageRealPlaythrough: 'ActionMessageRealPlaythrough',
    ActionStartRealPlaythrough: 'ActionStartRealPlaythrough',
    updateSessionGameControl: 'updateSessionGameControl',
    ClearGroupDetails: 'ClearGroupDetails',
    CopyGroupDetails: 'CopyGroupDetails',
    AddSessionRelations: 'AddSessionRelations',
    RemoveSessionRelations: 'RemoveSessionRelations',
    UpdateSessionForPickPastSessionsDialog: 'UpdateSessionForPickPastSessionsDialog',
    UpdateSessionForGroupDetails: 'UpdateSessionForGroupDetails',
    AddLocationToSession: 'AddLocationToSession',
    RemoveLocationFromSession: 'RemoveLocationFromSession',
    UpdateSessionForSessionLocationSection: 'UpdateSessionForSessionLocationSection',
    AddTimelineItem: 'AddTimelineItem',
    RemoveTimelineItem: 'RemoveTimelineItem',
    SetTimeline: 'SetTimeline',
    AddAdditionalBookingContact: 'AddAdditionalBookingContact',
    ClearSessionAssignmentForStaffAssignment: 'ClearSessionAssignmentForStaffAssignment',
    DeleteSessionAssignmentForStaffAssignment: 'DeleteSessionAssignmentForStaffAssignment',
    RemoveAdditionalBookingContact: 'RemoveAdditionalBookingContact',
    RemoveSessionBookingContact: 'RemoveSessionBookingContact',
    RemoveSessionContact: 'RemoveSessionContact',
    SetSessionBookingContact: 'SetSessionBookingContact',
    SetUserOnSessionAssignmentForStaffAssignment: 'SetUserOnSessionAssignmentForStaffAssignment',
    CopyExperience: 'CopyExperience',
    CreateExperienceFormat: 'CreateExperienceFormat',
    DeleteExperience: 'DeleteExperience',
    UpdateExperience: 'UpdateExperience',
    DeleteExperienceFormat: 'DeleteExperienceFormat',
    UpdateExperienceFormat: 'UpdateExperienceFormat',
    CreateExperienceForList: 'CreateExperienceForList',
    UpdateOpenWeve: 'UpdateOpenWeve',
    CreateOpenWeveForList: 'CreateOpenWeveForList',
    DeleteOpenWeve: 'DeleteOpenWeve',
    CreateAiPrompt: 'CreateAiPrompt',
    DeleteAiPrompt: 'DeleteAiPrompt',
    UpdateAiPrompt: 'UpdateAiPrompt',
    CreateInstruction: 'CreateInstruction',
    UpdateInstruction: 'UpdateInstruction',
    CreateModifier: 'CreateModifier',
    DeleteModifier: 'DeleteModifier',
    CreatePriceModifier: 'CreatePriceModifier',
    DeletePriceModifier: 'DeletePriceModifier',
    UpdatePriceModifier: 'UpdatePriceModifier',
    CreateSessionPhone: 'CreateSessionPhone',
    DeleteSessionPhone: 'DeleteSessionPhone',
    UpdateSessionPhone: 'UpdateSessionPhone',
    CreateZoneArea: 'CreateZoneArea',
    DeleteZoneArea: 'DeleteZoneArea',
    UpdateZoneArea: 'UpdateZoneArea',
    UpdateWorkspace: 'UpdateWorkspace',
    UpdateWorkspaceStaff: 'UpdateWorkspaceStaff',
    CreateBookingUserForUserManagementForm: 'CreateBookingUserForUserManagementForm',
    createPlantForUserManagementForm: 'createPlantForUserManagementForm',
    createStaffUserForUserManagementForm: 'createStaffUserForUserManagementForm',
    UpdateUserForUserManagementForm: 'UpdateUserForUserManagementForm',
    DeleteUserForUserManagement: 'DeleteUserForUserManagement',
    UpdateUserForUserManagement: 'UpdateUserForUserManagement',
    CreateVenueForVenueManagement: 'CreateVenueForVenueManagement',
    CreateVenueReview: 'CreateVenueReview',
    CreateVenueReviewForVenuePage: 'CreateVenueReviewForVenuePage',
    DeleteVenueForVenueManagement: 'DeleteVenueForVenueManagement',
    DeleteVenueReviewForVenuePage: 'DeleteVenueReviewForVenuePage',
    updateVenueForVenuePage: 'updateVenueForVenuePage',
    updateVenueReview: 'updateVenueReview'
  },
  Fragment: {
    workspaceForEventsSearchDropdown: 'workspaceForEventsSearchDropdown',
    userWithAvatarAndImage: 'userWithAvatarAndImage',
    orderForEdit: 'orderForEdit',
    sessionWithFiles: 'sessionWithFiles',
    experienceForExperienceMultiselect: 'experienceForExperienceMultiselect',
    experienceForExperienceSelect: 'experienceForExperienceSelect',
    gameCityForGameCitiesSelect: 'gameCityForGameCitiesSelect',
    gameZoneForGameZoneSelect: 'gameZoneForGameZoneSelect',
    sessionForInstructions: 'sessionForInstructions',
    sessionForInviteLinks: 'sessionForInviteLinks',
    missionSetForMissionSetSelect: 'missionSetForMissionSetSelect',
    sessionForMissionSetSessionMultiselect: 'sessionForMissionSetSessionMultiselect',
    modifierForModifierMultiselect: 'modifierForModifierMultiselect',
    sessionWithPackageLevel: 'sessionWithPackageLevel',
    permissionForPermissionsAssigner: 'permissionForPermissionsAssigner',
    permissionWithPrimary: 'permissionWithPrimary',
    sessionForScheduleDialog: 'sessionForScheduleDialog',
    sessionAssignmentForSessionAssignmentsSection: 'sessionAssignmentForSessionAssignmentsSection',
    sessionForSessionAssignmentsSection: 'sessionForSessionAssignmentsSection',
    sessionForNonVirtualSessionAttendeesInput: 'sessionForNonVirtualSessionAttendeesInput',
    sessionForVirtualSessionAttendeesInput: 'sessionForVirtualSessionAttendeesInput',
    sessionForSessionAttendeesInput: 'sessionForSessionAttendeesInput',
    sessionForSessionCard: 'sessionForSessionCard',
    sessionForSessionCheckoutDialog: 'sessionForSessionCheckoutDialog',
    sessionGroupForSessionGroupHighlightCard: 'sessionGroupForSessionGroupHighlightCard',
    sessionForSessionHighlightCard: 'sessionForSessionHighlightCard',
    suggestedVenue: 'suggestedVenue',
    sessionForSessionSelect: 'sessionForSessionSelect',
    templateForTemplateSelect: 'templateForTemplateSelect',
    userForUserMultiselect: 'userForUserMultiselect',
    userForUserSelect: 'userForUserSelect',
    permissionForWorkspaceAssigner: 'permissionForWorkspaceAssigner',
    workspaceForWorkspaceMultiselect: 'workspaceForWorkspaceMultiselect',
    workspaceForWorkspaceSelect: 'workspaceForWorkspaceSelect',
    zoneAreaForSelect: 'zoneAreaForSelect',
    availability: 'availability',
    availableConsumable: 'availableConsumable',
    customization: 'customization',
    customizationMedia: 'customizationMedia',
    file: 'file',
    groupDetails: 'groupDetails',
    lawnScheduleForShow: 'lawnScheduleForShow',
    location: 'location',
    mission: 'mission',
    missionSet: 'missionSet',
    modifierWithLabel: 'modifierWithLabel',
    offsetPageInfo: 'offsetPageInfo',
    order: 'order',
    orderItem: 'orderItem',
    pageInfo: 'pageInfo',
    session: 'session',
    sessionForSessionGroupDetailsSection: 'sessionForSessionGroupDetailsSection',
    sessionGroupWithSessions: 'sessionGroupWithSessions',
    sessionIntegration: 'sessionIntegration',
    sessionLocation: 'sessionLocation',
    sessionSupportsUpgrade: 'sessionSupportsUpgrade',
    sessionVenueContacts: 'sessionVenueContacts',
    system: 'system',
    timeline: 'timeline',
    timelineItem: 'timelineItem',
    userWithContacts: 'userWithContacts',
    userWithFullName: 'userWithFullName',
    userWithFullNameAndAvatar: 'userWithFullNameAndAvatar',
    workspaceWithConsumables: 'workspaceWithConsumables',
    experienceForExperienceDurationInput: 'experienceForExperienceDurationInput',
    experienceFormatForExperienceDurationInput: 'experienceFormatForExperienceDurationInput',
    experienceFormatForExperienceFormatSelect: 'experienceFormatForExperienceFormatSelect',
    experienceCustomization: 'experienceCustomization',
    experienceFormatWithModifiers: 'experienceFormatWithModifiers',
    modifierForSearch: 'modifierForSearch',
    sessionAssignmentForSessionAssignmentStatus: 'sessionAssignmentForSessionAssignmentStatus',
    sessionForSessionAssignmentStatus: 'sessionForSessionAssignmentStatus',
    sessionAssignmentForTravelEditButton: 'sessionAssignmentForTravelEditButton',
    userForSessionTemplateSelect: 'userForSessionTemplateSelect',
    sessionAssignmentWithTravel: 'sessionAssignmentWithTravel',
    sessionAssignmentWithTravelAndCity: 'sessionAssignmentWithTravelAndCity',
    sessionWithCredits: 'sessionWithCredits',
    sessionWithHasBreadcrumbIntegration: 'sessionWithHasBreadcrumbIntegration',
    sessionWithStatus: 'sessionWithStatus',
    userAudio: 'userAudio',
    workspaceWithCredits: 'workspaceWithCredits',
    workspaceForStore: 'workspaceForStore',
    permissionsForStore: 'permissionsForStore',
    userForStore: 'userForStore',
    userWithEmail: 'userWithEmail',
    sessionForSessionReschedule: 'sessionForSessionReschedule',
    sessionForShiftPlanningSession: 'sessionForShiftPlanningSession',
    experienceForAvailabilityEvent: 'experienceForAvailabilityEvent',
    globalUnavailability: 'globalUnavailability',
    sessionForShiftPlanning: 'sessionForShiftPlanning',
    userForAvailability: 'userForAvailability',
    userForShiftPlanning: 'userForShiftPlanning',
    missionForForm: 'missionForForm',
    workspaceForContentLibrary: 'workspaceForContentLibrary',
    customizationWithMedia: 'customizationWithMedia',
    workspaceWithCustomization: 'workspaceWithCustomization',
    integrationForMediaAndDownload: 'integrationForMediaAndDownload',
    sessionForEventMediaAndDownloads: 'sessionForEventMediaAndDownloads',
    missionListForGameMissionList: 'missionListForGameMissionList',
    breadcrumbMissionForSelect: 'breadcrumbMissionForSelect',
    sessionForSearch: 'sessionForSearch',
    sessionForSessionActivityDetails: 'sessionForSessionActivityDetails',
    sessionForSessionContactDetails: 'sessionForSessionContactDetails',
    sessionWithContact: 'sessionWithContact',
    sessionForSessionSlotsInput: 'sessionForSessionSlotsInput',
    sessionForSessionDetails: 'sessionForSessionDetails',
    sessionForSessionInfo: 'sessionForSessionInfo',
    sessionForSessionDetailsSection: 'sessionForSessionDetailsSection',
    playthroughForGameControl: 'playthroughForGameControl',
    sessionForGameControl: 'sessionForGameControl',
    sessionForRelationsDialog: 'sessionForRelationsDialog',
    sessionForSessionGroupDetails: 'sessionForSessionGroupDetails',
    sessionForSessionLocationSection: 'sessionForSessionLocationSection',
    sessionForTimeline: 'sessionForTimeline',
    sessionForSessionScheduleSection: 'sessionForSessionScheduleSection',
    sessionAssignmentForStaffAssignmentDialog: 'sessionAssignmentForStaffAssignmentDialog',
    sessionForStaffAssignmentDialog: 'sessionForStaffAssignmentDialog',
    sessionWithAssignmentsForStaffAssignment: 'sessionWithAssignmentsForStaffAssignment',
    sessionWithIntegrations: 'sessionWithIntegrations',
    sessionAssignmentForStaffAssignment: 'sessionAssignmentForStaffAssignment',
    sessionForShow: 'sessionForShow',
    sessionWithGroup: 'sessionWithGroup',
    sessionWithSchedulingData: 'sessionWithSchedulingData',
    experienceForExperienceCard: 'experienceForExperienceCard',
    experienceFormatForExperienceCard: 'experienceFormatForExperienceCard',
    experienceFormatForTile: 'experienceFormatForTile',
    experienceForEditExperienceFormat: 'experienceForEditExperienceFormat',
    experienceFormatForEdit: 'experienceFormatForEdit',
    experienceFormatWithMedia: 'experienceFormatWithMedia',
    experienceWithMedia: 'experienceWithMedia',
    experienceWithCustomization: 'experienceWithCustomization',
    experienceForLegacyExperienceViewCard: 'experienceForLegacyExperienceViewCard',
    experienceForList: 'experienceForList',
    experienceForHero: 'experienceForHero',
    experienceOverviewItem: 'experienceOverviewItem',
    orderForOrderListItem: 'orderForOrderListItem',
    orderItemForOrderList: 'orderItemForOrderList',
    sessionForWorkspace: 'sessionForWorkspace',
    openWeveForOpenWeveCard: 'openWeveForOpenWeveCard',
    openWeveForEdit: 'openWeveForEdit',
    openWeveForView: 'openWeveForView',
    openWeveForList: 'openWeveForList',
    sessionForSessionGroupPage: 'sessionForSessionGroupPage',
    sessionGroupForSessionGroupPage: 'sessionGroupForSessionGroupPage',
    aiPromptForAdminSettings: 'aiPromptForAdminSettings',
    aiPromptForListForAdminSettings: 'aiPromptForListForAdminSettings',
    modifierForAdminSettings: 'modifierForAdminSettings',
    priceModifierForAdminSettings: 'priceModifierForAdminSettings',
    sessionPhoneForSessionPhoneForm: 'sessionPhoneForSessionPhoneForm',
    sessionPhoneForAdminSettings: 'sessionPhoneForAdminSettings',
    zoneAreaForZoneAreaForm: 'zoneAreaForZoneAreaForm',
    zoneAreaForAdminSettings: 'zoneAreaForAdminSettings',
    userForProfileSettings: 'userForProfileSettings',
    workspaceForSettings: 'workspaceForSettings',
    userForUserManagement: 'userForUserManagement',
    userForUserManagementForm: 'userForUserManagementForm',
    venueForVenueManagement: 'venueForVenueManagement',
    venueForVenuePage: 'venueForVenuePage',
    venueReviewForCreateVenueReviewForm: 'venueReviewForCreateVenueReviewForm',
    venueReviewForUpdateVenueReviewForm: 'venueReviewForUpdateVenueReviewForm',
    venueReviewForVenuePage: 'venueReviewForVenuePage'
  }
}